(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.breakpoint = undefined;

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Extract current breakpoint name as string from DOM
// More details: https://www.lullabot.com/articles/importing-css-breakpoints-into-javascript
var breakpoint = exports.breakpoint = function breakpoint() {
    return window.getComputedStyle(document.querySelector("body"), "::before").getPropertyValue("content").replace(/\"/g, "");
};

},{"jquery":"jquery"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _facets = require("../redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_FACETS_SHOWN = 5;

var FacetGroup = function (_React$Component) {
  _inherits(FacetGroup, _React$Component);

  function FacetGroup(props) {
    _classCallCheck(this, FacetGroup);

    var _this = _possibleConstructorReturn(this, (FacetGroup.__proto__ || Object.getPrototypeOf(FacetGroup)).call(this, props));

    _this.state = {
      isGroupOpen: _this.props.isOpen,
      isGroupExpanded: false,
      valuesExpanded: []
    };
    return _this;
  }

  // Lifecycle

  _createClass(FacetGroup, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // if group is closed, but has selected
      // values, open it
      var group = this.props.group;

      var selected = (0, _facets.selectedFacetsFromGroup)(group);
      var shouldOpen = this.state.isGroupOpen;
      if (selected.length > 0) {
        shouldOpen = true;
      }

      // Some facets will be expanded by default due to
      // children being pre-selected
      var hasSelected = (0, _facets.valuesWithSelectedChildren)(group);
      var selectedIds = hasSelected.map(function (v) {
        return v.id;
      });

      // similarly, if group's values or value children
      // are selected, auto-expand that group
      var tailValues = _ramda2.default.drop(MAX_FACETS_SHOWN, group.values);
      var shouldExpand = tailValues.reduce(function (should, tv) {
        if (tv.selected === true || selectedIds.indexOf(tv.id) >= 0) {
          should = true;
        }

        return should;
      }, false);

      this.setState({
        isGroupOpen: shouldOpen,
        isGroupExpanded: shouldExpand,
        valuesExpanded: selectedIds
      });
    }
  }, {
    key: "chunkValues",
    value: function chunkValues(values) {
      // divide the values into two arrays, the first for the Top X facets
      // and the second for overflow. If recursion level is over zero, put
      // all values in first array.
      return values.length > MAX_FACETS_SHOWN ? _ramda2.default.splitAt(MAX_FACETS_SHOWN, values) : [values, []];
    }
  }, {
    key: "showExpandButton",
    value: function showExpandButton() {
      return !this.state.isGroupExpanded;
    }
  }, {
    key: "shouldRenderTailValues",
    value: function shouldRenderTailValues(tailValues) {
      return this.state.isGroupExpanded && tailValues.length > 0;
    }
  }, {
    key: "shouldRenderChildGroups",
    value: function shouldRenderChildGroups(group) {
      return group.isOpen && !!group.childGroups && group.childGroups.length > 0;
    }
  }, {
    key: "toggleGroup",
    value: function toggleGroup() {
      var isOpen = !this.state.isGroupOpen;
      this.setState({ isGroupOpen: isOpen });
    }
  }, {
    key: "toggleExpand",
    value: function toggleExpand() {
      var isExpanded = !this.state.isGroupExpanded;
      this.setState({ isGroupExpanded: isExpanded });
    }
  }, {
    key: "toggleValueExpand",
    value: function toggleValueExpand(valueId) {
      // check if the valueId is in the list. Remove it
      // if found, add it if not.
      var valueIdx = this.state.valuesExpanded.indexOf(valueId);
      var selectedValues = valueIdx >= 0 ? _ramda2.default.remove(valueIdx, 1, this.state.valuesExpanded) : _ramda2.default.append(valueId, this.state.valuesExpanded);

      this.setState({ valuesExpanded: selectedValues });
    }
  }, {
    key: "valueIsExpanded",
    value: function valueIsExpanded(value) {
      return this.state.valuesExpanded.indexOf(value.id) >= 0;
    }
  }, {
    key: "onFacetChange",
    value: function onFacetChange(event, valueId) {
      this.props.handleFacetChange(valueId, event.target.checked);
    }
  }, {
    key: "onClearGroup",
    value: function onClearGroup() {
      var group = this.props.group;
      this.props.handleClearGroup(group);
    }

    // Rendering

  }, {
    key: "renderOpenButton",
    value: function renderOpenButton() {
      var _this2 = this;

      var openClass = (0, _classnames2.default)("search-facets__group-toggle", { "is-open": this.state.isGroupOpen });
      return _react2.default.createElement(
        "button",
        { className: openClass, type: "button", onClick: function onClick(e) {
            return _this2.toggleGroup(e);
          } },
        _react2.default.createElement(
          "svg",
          { className: "icon" },
          _react2.default.createElement("use", { xlinkhref: window._ir + "svg-sprite/chevron-down" })
        )
      );
    }
  }, {
    key: "renderValueItem",
    value: function renderValueItem(value, recursionLevel) {
      var _this3 = this;

      var childValues = value.childValues;
      var hasChildValues = !!childValues && childValues.length > 0;
      var isExpanded = this.valueIsExpanded(value);
      var renderChildValues = hasChildValues && isExpanded;
      var toggleClass = (0, _classnames2.default)("search-facets__value-expand", { "is-open": isExpanded });

      return _react2.default.createElement(
        "li",
        { key: value.id },
        _react2.default.createElement("input", { id: value.id, checked: value.selected, onChange: function onChange(e) {
            return _this3.onFacetChange(e, value.id);
          }, type: "checkbox" }),
        _react2.default.createElement(
          "label",
          { htmlFor: value.id },
          value.name,
          " (",
          value.count,
          ")"
        ),
        hasChildValues && _react2.default.createElement(
          "button",
          { type: "button", className: toggleClass, onClick: function onClick() {
              return _this3.toggleValueExpand(value.id);
            } },
          _react2.default.createElement(
            "svg",
            { className: "icon" },
            _react2.default.createElement("use", { xlinkhref: window._ir + "svg-sprite/chevron-down" })
          )
        ),
        renderChildValues && this.renderValues(childValues, recursionLevel + 1)
      );
    }
  }, {
    key: "renderFlatValues",
    value: function renderFlatValues(values) {
      var _this4 = this;

      var renderValue = function renderValue(value) {
        return _react2.default.createElement(
          "li",
          { key: value.id },
          _react2.default.createElement("input", { id: value.id, checked: value.selected, onChange: function onChange(e) {
              return _this4.onFacetChange(e, value.id);
            }, type: "checkbox" }),
          _react2.default.createElement(
            "label",
            { htmlFor: value.id },
            value.name,
            " (",
            value.count,
            ")"
          )
        );
      };

      return _react2.default.createElement(
        "ul",
        { className: "search-facets__group-values" },
        values.map(function (value) {
          return renderValue(value);
        })
      );
    }
  }, {
    key: "renderValues",
    value: function renderValues(values, recursionLevel) {
      var _this5 = this;

      var chunkedValues = void 0;
      if (recursionLevel === 0) {
        chunkedValues = this.chunkValues(values);
      } else {
        chunkedValues = [values, []];
      }

      var headValues = chunkedValues[0];
      var tailValues = chunkedValues[1];

      var stateClass = "search-facets__group-values is-level-" + recursionLevel;
      var valuesWrapperClass = (0, _classnames2.default)("search-facets__values-wrapper", { "has-no-values": !values.length });
      var shouldRenderTailValues = this.shouldRenderTailValues(tailValues);

      return _react2.default.createElement(
        "div",
        { className: valuesWrapperClass },
        _react2.default.createElement(
          "ul",
          { className: stateClass },
          headValues.map(function (val) {
            return _this5.renderValueItem(val, recursionLevel);
          })
        ),
        shouldRenderTailValues && _react2.default.createElement(
          "ul",
          { className: (0, _classnames2.default)(stateClass, "is-overflow") },
          tailValues.map(function (val) {
            return _this5.renderValueItem(val, recursionLevel);
          })
        )
      );
    }
  }, {
    key: "renderChildGroups",
    value: function renderChildGroups(group) {
      var _this6 = this;

      if (this.state.isGroupOpen && group.childGroups && group.childGroups.length) {

        return group.childGroups.map(function (childGroup) {
          if (childGroup.values.length === 0) {
            return null;
          }

          return _react2.default.createElement(FacetGroup, { key: childGroup.id,
            group: childGroup,
            dupeSelected: false,
            handleFacetChange: _this6.props.handleFacetChange,
            handleClearGroup: _this6.props.handleClearGroup
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var group = this.props.group;
      var selectedValues = (0, _facets.selectedFacetsFromGroup)(group);
      var showDupeSelected = selectedValues.length > 0 && this.props.dupeSelected;
      var groupClass = (0, _classnames2.default)("search-facets__group", {
        "is-open": this.state.isGroupOpen
      });
      var expandLabel = this.state.isGroupExpanded ? "Show Less" : "Show More";

      return _react2.default.createElement(
        "div",
        { className: groupClass },
        _react2.default.createElement(
          "div",
          { className: "search-facets__group-heading" },
          _react2.default.createElement(
            "h4",
            null,
            group.label
          ),
          this.renderOpenButton()
        ),
        _react2.default.createElement(
          "div",
          { className: "search-facets__group-wrapper" },
          this.state.isGroupOpen && _react2.default.createElement(
            "div",
            { className: "search-facets__group-body" },
            group.values.length > 0 && _react2.default.createElement(
              "div",
              { className: "search-facets__group-top" },
              _react2.default.createElement(
                "button",
                {
                  onClick: function onClick() {
                    return _this7.onClearGroup();
                  },
                  className: "search-facets__group-clear",
                  type: "button" },
                "Clear"
              )
            ),
            showDupeSelected && _react2.default.createElement(
              "div",
              { className: "search-facets__group-selected" },
              this.renderFlatValues(selectedValues)
            ),
            this.renderValues(group.values, 0),
            group.values.length > MAX_FACETS_SHOWN && _react2.default.createElement(
              "div",
              { className: "search-facets__group-more" },
              _react2.default.createElement(
                "button",
                { type: "button", onClick: function onClick() {
                    return _this7.toggleExpand();
                  } },
                expandLabel
              )
            ),
            this.renderChildGroups(group)
          )
        )
      );
    }
  }]);

  return FacetGroup;
}(_react2.default.Component);

exports.default = FacetGroup;
var _React$PropTypes = _react2.default.PropTypes,
    func = _React$PropTypes.func,
    shape = _React$PropTypes.shape,
    bool = _React$PropTypes.bool,
    number = _React$PropTypes.number,
    string = _React$PropTypes.string,
    oneOfType = _React$PropTypes.oneOfType,
    arrayOf = _React$PropTypes.arrayOf;

// allows us to define propTypes recursively
// https://github.com/facebook/react/issues/5676

var lazyF = function lazyF(f) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return f().apply(undefined, args);
  };
};

var facetValueShape = shape({
  id: oneOfType([number, string]).isRequired,
  name: string.isRequired,
  count: number.isRequired,
  selected: bool.isRequired,
  childValues: arrayOf(lazyF(function () {
    return facetValueShape;
  }))
});

var facetGroupShape = shape({
  id: oneOfType([number, string]).isRequired,
  label: string.isRequired,
  values: arrayOf(facetValueShape).isRequired,
  childGroups: arrayOf(lazyF(function () {
    return facetGroupShape;
  }))
});

FacetGroup.propTypes = {
  isOpen: bool,
  dupeSelected: bool,
  handleFacetChange: func.isRequired,
  handleClearGroup: func.isRequired,
  group: facetGroupShape
};

FacetGroup.defaultProps = {
  isOpen: true,
  dupeSelected: true
};

},{"../redux/facets":21,"classnames":"classnames","ramda":"ramda","react":"react"}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _FacetGroup = require("./FacetGroup.jsx");

var _FacetGroup2 = _interopRequireDefault(_FacetGroup);

var _filterSlider = require("../filterSlider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FacetList = function (_React$Component) {
  _inherits(FacetList, _React$Component);

  function FacetList(props) {
    _classCallCheck(this, FacetList);

    return _possibleConstructorReturn(this, (FacetList.__proto__ || Object.getPrototypeOf(FacetList)).call(this, props));
  }

  _createClass(FacetList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      //setFiltersOpenDirection();
      //manageContainerWhitespace();
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this.props.handleClearAll();
    }
  }, {
    key: "hideFilters",
    value: function hideFilters() {
      //closeFilters(); // DOM ops
      this.props.hideMobileFacets(); // action creator
    }
  }, {
    key: "renderHideFilters",
    value: function renderHideFilters() {
      var _this2 = this;

      return _react2.default.createElement(
        "div",
        { className: "search-facets__filter-close" },
        _react2.default.createElement(
          "button",
          { type: "button",
            className: "btn--primary",
            onClick: function onClick() {
              return _this2.hideFilters();
            } },
          this.props.title,
          _react2.default.createElement(
            "svg",
            { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", version: "1.1", width: "17", height: "17", viewBox: "0 0 17 17" },
            _react2.default.createElement("path", { fill: "#424242", d: "M11.984,5.71739l-2.78261,2.78261l2.78261,2.78261l-0.70139,0.70139l-2.78261,-2.78261l-2.78261,2.78261l-0.70139,-0.70139l2.78261,-2.78261l-2.78261,-2.78261l0.70139,-0.70139l2.78261,2.78261l2.78261,-2.78261l0.70139,0.70139z" })
          )
        )
      );
    }
  }, {
    key: "renderFacetGroups",
    value: function renderFacetGroups() {
      var _this3 = this;

      return this.props.facets.map(function (group, i) {
        if (group.values.length === 0) {
          return null;
        }
        var numOpenGroups = _this3.props.numOpenGroups;
        var isOpen = typeof numOpenGroups !== "undefined" && numOpenGroups !== null && i < numOpenGroups;
        return _react2.default.createElement(_FacetGroup2.default, { key: group.id,
          handleFacetChange: _this3.props.handleFacetChange,
          handleClearGroup: _this3.props.handleClearGroup,
          isOpen: isOpen,
          group: group });
      });
    }
  }, {
    key: "renderClearAll",
    value: function renderClearAll() {
      var _this4 = this;

      return _react2.default.createElement(
        "div",
        { className: "search-facets__clear-all" },
        _react2.default.createElement(
          "button",
          { type: "button",
            className: "btn btn--primary",
            onClick: function onClick() {
              return _this4.clearAll();
            } },
          "Clear Filters"
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      var facetGroups = this.renderFacetGroups();
      return _react2.default.createElement(
        "div",
        null,
        this.renderHideFilters(),
        this.props.mobileFacetsShown ? _react2.default.createElement(
          "h3",
          null,
          this.props.title
        ) : null,
        _react2.default.createElement(
          "div",
          { className: "search-facets" },
          this.renderClearAll(),
          facetGroups,
          this.renderClearAll()
        )
      );
    }
  }]);

  return FacetList;
}(_react2.default.Component);

exports.default = FacetList;
var _React$PropTypes = _react2.default.PropTypes,
    string = _React$PropTypes.string,
    arrayOf = _React$PropTypes.arrayOf,
    bool = _React$PropTypes.bool,
    shape = _React$PropTypes.shape,
    number = _React$PropTypes.number,
    oneOfType = _React$PropTypes.oneOfType,
    func = _React$PropTypes.func;

FacetList.propTypes = {
  title: string,
  mobileFiltersShown: bool,
  mobileFacetsShown: bool,
  hideMobileFacets: func,
  facets: arrayOf(shape({ id: oneOfType([number, string]) })),
  numOpenGroups: number,
  handleFacetChange: func.isRequired,
  handleClearGroup: func.isRequired,
  handleClearAll: func.isRequired
};

FacetList.defaultProps = {
  facets: [],
  numOpenGroups: null
};

},{"../filterSlider":16,"./FacetGroup.jsx":2,"react":"react"}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _LoadingSpinner = require("./LoadingSpinner.jsx");

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadMore = function (_React$Component) {
  _inherits(LoadMore, _React$Component);

  function LoadMore(props) {
    _classCallCheck(this, LoadMore);

    var _this = _possibleConstructorReturn(this, (LoadMore.__proto__ || Object.getPrototypeOf(LoadMore)).call(this, props));

    _this.state = {
      initiatedLoad: false
    };
    return _this;
  }

  _createClass(LoadMore, [{
    key: "onClick",
    value: function onClick(event) {
      event.preventDefault();
      this.props.handleClick();
      this.setState({
        initiatedLoad: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var dictionary = this.props.dictionary;

      var shouldShowSpinner = this.props.loading && this.state.initiatedLoad;
      return _react2.default.createElement(
        "div",
        { className: "directory-results__load-more" },
        _react2.default.createElement(
          "button",
          { className: "btn btn--primary", type: "button", onClick: function onClick(e) {
              return _this2.onClick(e);
            } },
          dictionary.loadMoreLabel,
          shouldShowSpinner ? _react2.default.createElement(_LoadingSpinner2.default, null) : null
        )
      );
    }
  }]);

  return LoadMore;
}(_react2.default.Component);

exports.default = LoadMore;
var _React$PropTypes = _react2.default.PropTypes,
    func = _React$PropTypes.func,
    shape = _React$PropTypes.shape,
    string = _React$PropTypes.string,
    bool = _React$PropTypes.bool;


LoadMore.propTypes = {
  handleClick: func.isRequired,
  loading: bool,
  dictionary: shape({
    loadMoreLabel: string
  })
};

},{"./LoadingSpinner.jsx":5,"react":"react"}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    "div",
    { className: "content-list__spinner" },
    _react2.default.createElement("img", { src: window._ir + "svg-sprite/loading-squares" })
  );
};

},{"react":"react"}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _paging = require("../paging");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pagination = function Pagination(_ref) {
  var totalResults = _ref.totalResults,
      resultsPerPage = _ref.resultsPerPage,
      currentPage = _ref.currentPage,
      handlePageChange = _ref.handlePageChange;


  var block = (0, _paging.pageBlock)(totalResults, resultsPerPage, currentPage);
  var isLast = (0, _paging.isLastPage)(totalResults, resultsPerPage, currentPage);
  var isFirst = (0, _paging.isFirstPage)(currentPage);
  var lastPage = (0, _paging.totalPages)(totalResults, resultsPerPage);

  function getPage(label, value, isDisabled) {
    return _react2.default.createElement(
      "li",
      null,
      _react2.default.createElement(
        "button",
        {
          className: "pagination__item",
          key: label,
          type: "button",
          onClick: function onClick() {
            return onPageClick(value, isDisabled);
          },
          disabled: isDisabled },
        label
      )
    );
  }

  function onPageClick(pageNum, isDisabled) {
    if (!isDisabled) {
      handlePageChange(pageNum);
    }
  }

  return _react2.default.createElement(
    "div",
    { className: "pagination" },
    _react2.default.createElement(
      "button",
      { type: "button", className: "pagination__jump pagination__jump--back", onClick: function onClick() {
          return onPageClick(currentPage - 1, isFirst);
        }, disabled: isFirst },
      "Back"
    ),
    _react2.default.createElement(
      "ul",
      { className: "pagination__list" },
      block.map(function (page) {
        return _react2.default.createElement(
          "li",
          { key: page.label },
          _react2.default.createElement(
            "button",
            {
              className: "pagination__item",
              type: "button",
              onClick: function onClick() {
                return onPageClick(page.num, page.current);
              },
              disabled: page.current },
            page.label
          )
        );
      })
    ),
    _react2.default.createElement(
      "button",
      { type: "button", className: "pagination__jump pagination__jump--next", onClick: function onClick() {
          return onPageClick(currentPage + 1, isLast);
        }, disabled: isLast },
      "Next"
    )
  );
};

var _React$PropTypes = _react2.default.PropTypes,
    number = _React$PropTypes.number,
    func = _React$PropTypes.func;


Pagination.propTypes = {
  totalResults: number.isRequired,
  resultsPerPage: number.isRequired,
  currentPage: number.isRequired,
  handlePageChange: func.isRequired
};

exports.default = Pagination;

},{"../paging":18,"react":"react"}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResultItem = function (_React$Component) {
  _inherits(ResultItem, _React$Component);

  function ResultItem(props) {
    _classCallCheck(this, ResultItem);

    var _this = _possibleConstructorReturn(this, (ResultItem.__proto__ || Object.getPrototypeOf(ResultItem)).call(this, props));

    _this.itemWrapper = null;
    return _this;
  }

  _createClass(ResultItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.itemWrapper.className = this.itemWrapper.className + " is-visible";
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          authors = _props.authors,
          date = _props.date,
          description = _props.description,
          image = _props.image,
          title = _props.title,
          url = _props.url;


      return _react2.default.createElement(
        "li",
        { className: "content-list__item" },
        _react2.default.createElement(
          "section",
          { className: "list-item is-right", ref: function ref(el) {
              return _this2.itemWrapper = el;
            } },
          image ? _react2.default.createElement(
            "a",
            { href: url, className: "list-item__media-link", title: title },
            _react2.default.createElement(
              "div",
              { className: "list-item__media-container" },
              _react2.default.createElement("img", { src: image, alt: title, className: "list-item__media" })
            )
          ) : null,
          _react2.default.createElement(
            "div",
            { className: "list-item__content" },
            _react2.default.createElement(
              "header",
              { className: "list-item__header" },
              _react2.default.createElement(
                "h3",
                { className: "list-item__title", id: title.split(' ').join('-') },
                _react2.default.createElement(
                  "a",
                  { href: url },
                  title
                )
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "list-item__meta" },
              _react2.default.createElement(
                "span",
                null,
                date
              ),
              authors ? _react2.default.createElement(
                "span",
                { className: "list-item__authors" },
                "By:\xA0",
                authors.map(function (author, index) {
                  if (author.profile) {

                    if (index > 0) {
                      return _react2.default.createElement(
                        "span",
                        { key: author.name, className: "list-item__author" },
                        "and ",
                        _react2.default.createElement(
                          "a",
                          { href: author.profile },
                          author.name
                        ),
                        "\xA0"
                      );
                    } else {
                      return _react2.default.createElement(
                        "a",
                        { className: "list-item__author", href: author.profile },
                        author.name,
                        "\xA0"
                      );
                    }
                  } else {
                    if (index > 0) {
                      return _react2.default.createElement(
                        "span",
                        { key: author.name, className: "list-item__author" },
                        "and ",
                        author.name,
                        "\xA0"
                      );
                    } else {
                      return _react2.default.createElement(
                        "span",
                        { className: "list-item__author" },
                        author.name,
                        "\xA0"
                      );
                    }
                  }
                })
              ) : null
            ),
            description ? _react2.default.createElement(
              "p",
              { className: "list-item__description" },
              description
            ) : null
          )
        )
      );
    }
  }]);

  return ResultItem;
}(_react2.default.Component);

exports.default = ResultItem;
var _React$PropTypes = _react2.default.PropTypes,
    string = _React$PropTypes.string,
    arrayOf = _React$PropTypes.arrayOf,
    object = _React$PropTypes.object;

ResultItem.propTypes = {
  authors: arrayOf(object),
  date: string,
  description: string,
  image: string,
  title: string.isRequired,
  url: string
};

},{"moment":"moment","react":"react"}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _paging = require("../paging");

var _filterSlider = require("../filterSlider");

var _ResultItem = require("./ResultItem.jsx");

var _ResultItem2 = _interopRequireDefault(_ResultItem);

var _LoadMore = require("./LoadMore.jsx");

var _LoadMore2 = _interopRequireDefault(_LoadMore);

var _LoadingSpinner = require("./LoadingSpinner.jsx");

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _SortBar = require("./SortBar.jsx");

var _SortBar2 = _interopRequireDefault(_SortBar);

var _SearchStatus = require("./SearchStatus.jsx");

var _SearchStatus2 = _interopRequireDefault(_SearchStatus);

var _Pagination = require("./Pagination.jsx");

var _Pagination2 = _interopRequireDefault(_Pagination);

var _resultsDisplay = require("../redux/resultsDisplay");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResultList = function ResultList(_ref) {
  var results = _ref.results,
      resultsDisplayStrategy = _ref.resultsDisplayStrategy,
      selectedFacets = _ref.selectedFacets,
      totalResults = _ref.totalResults,
      loading = _ref.loading,
      isFirstLoad = _ref.isFirstLoad,
      sorters = _ref.sorters,
      nextPage = _ref.nextPage,
      gotoPage = _ref.gotoPage,
      dismissFacet = _ref.dismissFacet,
      changeSort = _ref.changeSort,
      query = _ref.query,
      pagination = _ref.pagination,
      dictionary = _ref.dictionary,
      showMobileFacets = _ref.showMobileFacets,
      yearsFacets = _ref.yearsFacets,
      changeFilter = _ref.changeFilter;


  var isLast = (0, _paging.isLastPage)(totalResults, query.perPage, query.page);
  var shouldShowNoResults = results.length === 0 && !isFirstLoad;
  var shouldShowPager = totalResults > query.perPage;

  function showFilters() {
    (0, _filterSlider.openFilters)(); // DOM ops
    showMobileFacets(); // action creator
  }

  function wrapperClass() {
    var isRefreshing = loading && resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_REFRESH;
    var isAppending = loading && resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND;
    return (0, _classnames2.default)("content-list__alt", { "is-refreshing": isRefreshing, "is-appending": isAppending });
  }

  function resultsRange() {
    // Upper bound of visible results
    var ceiling = query.page * query.perPage;

    // Lower bound of visible results
    var floor = ceiling - query.perPage + 1;

    // make sure the ceiling does not exceed total results
    if (ceiling > totalResults) {
      ceiling = totalResults;
    }

    // if results are only one page, eschew the range entirely
    if (totalResults <= query.perPage) {
      return "" + totalResults;
    }

    // if we're using load more, we want to show only
    // the ceiling of results displayed
    if (resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND) {
      return "" + ceiling;
    }

    // otherwise, return the full range
    return floor + " - " + ceiling;
  }

  function renderPagingControl() {
    if (pagination) {
      return _react2.default.createElement(_Pagination2.default, {
        totalResults: totalResults,
        resultsPerPage: query.perPage,
        currentPage: query.page,
        handlePageChange: gotoPage });
    }

    if (!pagination && !isLast) {
      return _react2.default.createElement(_LoadMore2.default, { handleClick: nextPage, dictionary: dictionary, loading: loading });
    }
  }

  function renderFilterToggle() {
    return _react2.default.createElement(
      "button",
      { type: "button",
        className: "content-list__filter-open btn--primary",
        onClick: function onClick() {
          return showFilters();
        } },
      "Filter Your Results",
      _react2.default.createElement(
        "svg",
        { className: "icon" },
        _react2.default.createElement("use", { xlinkhref: window._ir + "svg-sprite/equalizer" })
      )
    );
  }

  return _react2.default.createElement(
    "section",
    { className: wrapperClass() },
    _react2.default.createElement(_SearchStatus2.default, {
      resultsRange: resultsRange(),
      totalResults: totalResults,
      keywords: query.q,
      selectedFacets: selectedFacets,
      handleFacetDismiss: dismissFacet
    }),
    _react2.default.createElement(_SortBar2.default, {
      sorters: sorters,
      handleSortClick: changeSort,
      yearsFacets: yearsFacets,
      handleFilterChange: changeFilter,
      query: query
    }),
    _react2.default.createElement(
      "ul",
      { className: "content-list__list" },
      shouldShowNoResults ? _react2.default.createElement(
        "p",
        null,
        "No results found to match your query."
      ) : null,
      results.map(function (item) {
        return _react2.default.createElement(_ResultItem2.default, _extends({ key: item.id }, item));
      })
    ),
    loading && _react2.default.createElement(
      "div",
      { className: "content-list__loader" },
      _react2.default.createElement(_LoadingSpinner2.default, null)
    ),
    shouldShowPager ? renderPagingControl() : null
  );
};

var _React$PropTypes = _react2.default.PropTypes,
    arrayOf = _React$PropTypes.arrayOf,
    string = _React$PropTypes.string,
    object = _React$PropTypes.object,
    func = _React$PropTypes.func,
    bool = _React$PropTypes.bool,
    number = _React$PropTypes.number,
    shape = _React$PropTypes.shape,
    oneOfType = _React$PropTypes.oneOfType,
    array = _React$PropTypes.array;


ResultList.propTypes = {
  results: arrayOf(shape({
    id: oneOfType([number, string])
  })),
  resultsDisplayStrategy: number,
  selectedFacets: arrayOf(object).isRequired,
  totalResults: number.isRequired,
  sorters: arrayOf(shape({
    id: oneOfType([number, string]).isRequired,
    label: string.isRequired,
    value: string.isRequired,
    direction: oneOfType([bool, string]),
    isActive: bool.isRequired
  })),
  loading: bool,
  isFirstLoad: bool,
  nextPage: func,
  gotoPage: func,
  changeSort: func,
  showMobileFacets: func,
  dismissFacet: func,
  query: shape({
    q: string,
    sortBy: string,
    page: number,
    perPage: number,
    pageId: string,
    year: string
  }),
  pagination: bool,
  dictionary: object,
  yearsFacets: array,
  changeFilter: func
};

ResultList.defaultProps = {
  selectedFacets: []
};

exports.default = ResultList;

},{"../filterSlider":16,"../paging":18,"../redux/resultsDisplay":22,"./LoadMore.jsx":4,"./LoadingSpinner.jsx":5,"./Pagination.jsx":6,"./ResultItem.jsx":7,"./SearchStatus.jsx":10,"./SortBar.jsx":11,"classnames":"classnames","react":"react"}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _LoadingSpinner = require("./LoadingSpinner.jsx");

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchBox = function (_React$Component) {
  _inherits(SearchBox, _React$Component);

  function SearchBox(props) {
    _classCallCheck(this, SearchBox);

    var _this = _possibleConstructorReturn(this, (SearchBox.__proto__ || Object.getPrototypeOf(SearchBox)).call(this, props));

    _this.state = {
      initiatedLoad: false
    };
    return _this;
  }

  _createClass(SearchBox, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.loading) {
        this.setState({ initiatedLoad: false });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      event.preventDefault();
      this.props.handleEntry(this.keywordInput.value);
      this.setState({ initiatedLoad: true });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          dictionary = _props.dictionary,
          keywords = _props.keywords,
          loading = _props.loading,
          hideIcon = _props.hideIcon;

      var shouldShowSpinner = this.state.initiatedLoad && loading;
      return _react2.default.createElement(
        "form",
        { className: "search-box", onSubmit: function onSubmit(e) {
            return _this2.handleSubmit(e);
          }, noValidate: true },
        _react2.default.createElement(
          "div",
          { className: "search-box__input" },
          _react2.default.createElement(
            "label",
            { htmlFor: "site-search", className: "u-visuallyhidden" },
            dictionary.searchBoxLabel
          ),
          _react2.default.createElement("input", { id: "site-search",
            type: "text",
            placeholder: dictionary.searchBoxPlaceholder,
            defaultValue: keywords || "",
            ref: function ref(input) {
              return _this2.keywordInput = input;
            }
          }),
          _react2.default.createElement(
            "div",
            { className: "search-box__loader" },
            shouldShowSpinner ? _react2.default.createElement(_LoadingSpinner2.default, null) : null
          ),
          _react2.default.createElement(
            "button",
            { type: "submit", className: "search-box__button " + (hideIcon ? "u-visuallyhidden" : "") },
            _react2.default.createElement(
              "span",
              { className: "u-visuallyhidden" },
              "Submit Search"
            ),
            !hideIcon && _react2.default.createElement(
              "svg",
              { className: "icon", role: "img", "aria-label": "maginfying glass icon" },
              _react2.default.createElement(
                "title",
                null,
                "magnifying glass icon"
              ),
              _react2.default.createElement("use", { xlinkhref: window._ir + "svg-sprite/search" })
            )
          )
        )
      );
    }
  }]);

  return SearchBox;
}(_react2.default.Component);

exports.default = SearchBox;
var _React$PropTypes = _react2.default.PropTypes,
    string = _React$PropTypes.string,
    func = _React$PropTypes.func,
    shape = _React$PropTypes.shape,
    bool = _React$PropTypes.bool;


SearchBox.propTypes = {
  keywords: string,
  handleEntry: func.isRequired,
  loading: bool,
  dictionary: shape({
    searchBoxPlaceholder: string,
    searchBoxLabel: string
  }).isRequired,
  hideIcon: bool
};

},{"./LoadingSpinner.jsx":5,"react":"react"}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchStatus = function SearchStatus(_ref) {
  var resultsRange = _ref.resultsRange,
      totalResults = _ref.totalResults,
      keywords = _ref.keywords,
      selectedFacets = _ref.selectedFacets,
      handleFacetDismiss = _ref.handleFacetDismiss;


  var shouldRenderFacets = selectedFacets.length > 0;
  var shouldRenderKeywords = !!keywords;
  var exactlyOneFacet = selectedFacets.length === 1;
  var moreThanOneFacet = selectedFacets.length > 0;
  var numberOfFacets = selectedFacets.length;

  console.log(exactlyOneFacet);

  var onFacetClick = function onFacetClick(value) {
    handleFacetDismiss(value.id);
  };

  var resultLabel = totalResults === 1 ? "result" : "results";

  var renderSelectedFacets = function renderSelectedFacets() {
    return _react2.default.createElement(
      "div",
      { className: "content-list__active-facets" },
      _react2.default.createElement(
        "span",
        null,
        "for\xA0"
      ),
      _react2.default.createElement(
        "ul",
        null,
        selectedFacets.map(function (value, index) {
          console.log(index);
          console.log(numberOfFacets);
          if (exactlyOneFacet) {
            return _react2.default.createElement(
              "li",
              { key: value.id },
              _react2.default.createElement(
                "span",
                null,
                _react2.default.createElement(
                  "a",
                  { href: "#" },
                  value.name
                )
              )
            );
          } else if (index === numberOfFacets - 1) {
            return _react2.default.createElement(
              "li",
              { key: value.id },
              _react2.default.createElement(
                "span",
                null,
                "and ",
                _react2.default.createElement(
                  "a",
                  { href: "#" },
                  value.name
                )
              )
            );
          } else {
            return _react2.default.createElement(
              "li",
              { key: value.id },
              _react2.default.createElement(
                "span",
                null,
                _react2.default.createElement(
                  "a",
                  { href: "#" },
                  value.name
                ),
                ",\xA0"
              )
            );
          }
        })
      )
    );
  };

  return _react2.default.createElement(
    "div",
    { className: "content-list__status" },
    "Showing ",
    resultsRange,
    " results of ",
    totalResults,
    "\xA0",
    shouldRenderKeywords && _react2.default.createElement(
      "span",
      null,
      "for \"",
      keywords,
      "\"\xA0"
    ),
    shouldRenderFacets && renderSelectedFacets()
  );
};

var _React$PropTypes = _react2.default.PropTypes,
    string = _React$PropTypes.string,
    number = _React$PropTypes.number,
    object = _React$PropTypes.object,
    arrayOf = _React$PropTypes.arrayOf,
    func = _React$PropTypes.func;


SearchStatus.propTypes = {
  resultsRange: string.isRequired,
  totalResults: number.isRequired,
  keywords: string,
  selectedFacets: arrayOf(object).isRequired,
  handleFacetDismiss: func.isRequired
};

SearchStatus.defaultProps = {
  selectedFacets: []
};

exports.default = SearchStatus;

},{"react":"react"}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require("react-redux");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _SearchBox = require("./SearchBox.jsx");

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _YearFilter = require("./YearFilter.jsx");

var _YearFilter2 = _interopRequireDefault(_YearFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activeSortAscClass(sorter) {
  return (0, _classnames2.default)({ "is-selected": sorter.isActive && sorter.direction === "asc" });
}

function activeSortDescClass(sorter) {
  return (0, _classnames2.default)({ "is-selected": sorter.isActive && sorter.direction === "desc" });
}

function activateOrToggleSorter(sorterId, sorters, handleSortClick) {
  var toggleDir = function toggleDir(dir) {
    if (!dir) {
      return null;
    } else {
      return dir === "asc" ? "desc" : "asc";
    }
  };

  // this is like a 'bookmark' to the direction property
  var dirLens = _ramda2.default.lensProp("direction");

  // each argument array supplies a condition predicate, and an action
  // 1) if clicked sorter and active, toggle the sort direction
  // 2) if clicked sorter and not active, make active
  // 3) if not clicked sorter, and active, make inactive
  // 4) all other cases, do nothing
  var adjustSorters = _ramda2.default.cond([[_ramda2.default.whereEq({ id: sorterId, isActive: true }), _ramda2.default.over(dirLens, toggleDir)], [_ramda2.default.whereEq({ id: sorterId, isActive: false }), _ramda2.default.assoc("isActive", true)], [_ramda2.default.whereEq({ isActive: true }), _ramda2.default.assoc("isActive", false)], [_ramda2.default.T, _ramda2.default.identity]]);

  var newSorters = _ramda2.default.map(adjustSorters, sorters);
  handleSortClick(newSorters);
}

var SortBar = function SortBar(_ref) {
  var sorters = _ref.sorters,
      handleSortClick = _ref.handleSortClick,
      yearsFacets = _ref.yearsFacets,
      handleFilterChange = _ref.handleFilterChange,
      query = _ref.query,
      dictionary = _ref.dictionary;

  function filterUpdate(_ref2) {
    var search = _ref2.search,
        year = _ref2.year;

    handleFilterChange({ search: search, year: year });
  }

  return _react2.default.createElement(
    "div",
    { className: "content-list__sort-bar" },
    _react2.default.createElement(
      "ul",
      null,
      sorters.map(function (sorter) {
        var uniqueClass = "content-list__sorter--" + sorter.label.split(' ').join('-').toLowerCase();
        var sorterClass = (0, _classnames2.default)("content-list__sorter", uniqueClass, { "is-active": sorter.isActive });

        if (sorter.label !== "Title") {
          return _react2.default.createElement(
            "li",
            {
              key: sorter.id,
              className: sorterClass,
              onClick: function onClick() {
                return activateOrToggleSorter(sorter.id, sorters, handleSortClick);
              } },
            _react2.default.createElement(
              "span",
              { className: "content-list__sort-label" },
              sorter.label
            ),
            sorter.direction && _react2.default.createElement(
              "span",
              { className: "content-list__sort-dir" },
              _react2.default.createElement(
                "button",
                { type: "button", className: activeSortAscClass(sorter) },
                _react2.default.createElement(
                  "svg",
                  { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", version: "1.1", width: "24", height: "24", viewBox: "0 0 24 24" },
                  _react2.default.createElement("path", { fill: "#424242", d: "M6.984 14.016l5.016-5.016 5.016 5.016h-10.031z" })
                )
              ),
              _react2.default.createElement(
                "button",
                { type: "button", className: activeSortDescClass(sorter) },
                _react2.default.createElement(
                  "svg",
                  { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", version: "1.1", width: "24", height: "24", viewBox: "0 0 24 24" },
                  _react2.default.createElement("path", { fill: "#424242", d: "M6.984 9.984h10.031l-5.016 5.016z" })
                )
              )
            )
          );
        }
      }),
      _react2.default.createElement(
        "li",
        { className: "content-list__sorter content-list__filter" },
        _react2.default.createElement(
          "span",
          { className: "content-list__sort-label" },
          "Years"
        ),
        _react2.default.createElement(_YearFilter2.default, { yearsFacets: yearsFacets, onSelected: filterUpdate, selectedOption: query.year })
      ),
      _react2.default.createElement(
        "li",
        { className: "content-list__sorter content-list__filter" },
        _react2.default.createElement(_SearchBox2.default, {
          handleEntry: function handleEntry(value) {
            filterUpdate({ search: value });
          },
          dictionary: {
            searchBoxPlaceholder: dictionary.searchBoxPlaceholder,
            searchBoxLabel: dictionary.searchBoxLabel
          },
          hideIcon: true,
          keywords: query.q
        })
      )
    )
  );
};

var _React$PropTypes = _react2.default.PropTypes,
    shape = _React$PropTypes.shape,
    func = _React$PropTypes.func,
    number = _React$PropTypes.number,
    string = _React$PropTypes.string,
    bool = _React$PropTypes.bool,
    oneOfType = _React$PropTypes.oneOfType,
    object = _React$PropTypes.object,
    arrayOf = _React$PropTypes.arrayOf,
    array = _React$PropTypes.array;


SortBar.propTypes = {
  sorters: arrayOf(shape({
    id: oneOfType([number, string]).isRequired,
    label: string.isRequired,
    value: string.isRequired,
    direction: oneOfType([bool, string]),
    isActive: bool.isRequired
  })).isRequired,
  handleSortClick: func.isRequired,
  yearsFacets: array,
  query: object,
  dictionary: object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    dictionary: state.dictionary
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SortBar);

},{"./SearchBox.jsx":9,"./YearFilter.jsx":12,"classnames":"classnames","ramda":"ramda","react":"react","react-redux":"react-redux"}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YearFilter = function YearFilter(_ref) {
    var yearsFacets = _ref.yearsFacets,
        onSelected = _ref.onSelected,
        selectedOption = _ref.selectedOption;

    function onChangeHandler(event) {
        onSelected({ year: event.target.value });
    }

    function renderOptions() {
        if (!yearsFacets || !yearsFacets.length) return null;

        return yearsFacets.map(function (year) {
            return _react2.default.createElement(
                "option",
                { value: year.name, key: year.id },
                year.name
            );
        });
    }

    return _react2.default.createElement(
        "select",
        { className: "content-list__year-filter", onChange: onChangeHandler, value: selectedOption },
        _react2.default.createElement(
            "option",
            { value: "" },
            "All"
        ),
        renderOptions()
    );
};
var _React$PropTypes = _react2.default.PropTypes,
    array = _React$PropTypes.array,
    func = _React$PropTypes.func,
    string = _React$PropTypes.string;

YearFilter.propTypes = {
    yearsFacets: array,
    onSelected: func,
    selectedOption: string
};

exports.default = YearFilter;

},{"react":"react"}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require("react-redux");

var _FacetList = require("../components/FacetList.jsx");

var _FacetList2 = _interopRequireDefault(_FacetList);

var _search = require("../redux/search/search.actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    title: state.dictionary.facetsTitle,
    facets: state.facets,
    numOpenGroups: state.numOpenGroups,
    mobileFacetsShown: state.mobileFacetsShown
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleFacetChange: function handleFacetChange(facetId, facetValue) {
      dispatch((0, _search.loadFacetChange)(facetId, facetValue));
    },

    handleClearGroup: function handleClearGroup(group) {
      dispatch((0, _search.loadClearFacetGroup)(group));
    },

    handleClearAll: function handleClearAll() {
      dispatch((0, _search.loadClearAllFacets)());
    },

    hideMobileFacets: function hideMobileFacets() {
      dispatch(_search.hideMobileFacets);
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FacetList2.default);

},{"../components/FacetList.jsx":3,"../redux/search/search.actions":25,"react-redux":"react-redux"}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require("react-redux");

var _SearchBox = require("../components/SearchBox.jsx");

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _search = require("../redux/search/search.actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    keywords: state.query.q,
    dictionary: state.dictionary,
    loading: state.loading
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleEntry: function handleEntry(value) {
      dispatch((0, _search.loadNewKeywords)(value));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SearchBox2.default);

},{"../components/SearchBox.jsx":9,"../redux/search/search.actions":25,"react-redux":"react-redux"}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require("react-redux");

var _ResultList = require("../components/ResultList.jsx");

var _ResultList2 = _interopRequireDefault(_ResultList);

var _search = require("../redux/search/search.actions");

var _facets = require("../redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    results: state.results,
    resultsDisplayStrategy: state.resultsDisplayStrategy,
    selectedFacets: (0, _facets.allSelectedFacets)(state.facets),
    totalResults: state.totalResults,
    loading: state.loading,
    isFirstLoad: state.isFirstLoad,
    sorters: state.sorters,
    query: state.query,
    pagination: state.pagination,
    dictionary: state.dictionary,
    yearsFacets: (0, _facets.getYearsFacet)(state.facets)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    nextPage: function nextPage() {
      dispatch((0, _search.loadNextPage)());
    },
    changeSort: function changeSort(sorters) {
      dispatch((0, _search.loadNewSort)(sorters));
    },
    gotoPage: function gotoPage(pageNum) {
      dispatch((0, _search.loadNewPage)(pageNum));
    },
    dismissFacet: function dismissFacet(facetId) {
      dispatch((0, _search.loadFacetChange)(facetId, false));
    },
    showMobileFacets: function showMobileFacets() {
      dispatch((0, _search.showMobileFacets)());
    },
    changeFilter: function changeFilter(filters) {
      dispatch((0, _search.loadNewFilter)(filters));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ResultList2.default);

},{"../components/ResultList.jsx":8,"../redux/facets":21,"../redux/search/search.actions":25,"react-redux":"react-redux"}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openFilters = openFilters;
exports.closeFilters = closeFilters;
exports.setFiltersOpenDirection = setFiltersOpenDirection;
exports.manageContainerWhitespace = manageContainerWhitespace;
// Open/Close for mobile sliding of filter bar.
// Involves working with elements outside the
// scope of React components, so logic kept here.

function openFilters() {
  // Note - this depends on page state outside of the React app
  var filters = filtersWrapper();
  if (filters && !filtersAreOpen(filters)) {
    filters.classList.add("is-open");
  }
}

function closeFilters() {
  var filters = filtersWrapper();
  if (filters) {
    filters.classList.remove("is-open");
  }
}

function setFiltersOpenDirection() {
  var direction = "is-right";
  var filters = filtersWrapper();

  if (filters.length) {
    var sibling = filters.closest(".container__col").nextElementSibling;
    if (sibling && sibling.className.indexOf("container__col") >= 0) {
      direction = "is-left";
    }
  }

  filters.classList.add(direction);
}

// when the facet column is 'lifted' absolutely from the container
// it leaves behind an empty stacked container with a bottom margin
// we want to remove that margin -- but only if facets are the
// only components in the column
function manageContainerWhitespace() {
  var filters = filtersWrapper();
  var parent = void 0;
  if (filters.length) {
    parent = filters.closest(".container__col");
  }
  var col = parent;
  if (parent.children.item(0).classList.contains("container__inner")) {
    parent = parent.children.item(0);
  }

  // cast from HTMLCollection to Array
  var children = Array.from(parent.children);
  var childCount = children.reduce(function (count, child) {
    if (!child.classList.contains("search__facets-wrapper")) {
      count = count + 1;
    }

    return count;
  }, 0);

  if (childCount === 0) {
    // remove the margin on the parent column
    col.style.marginBottom = 0;
  }
}

function filtersWrapper() {
  return document.querySelector(".search__facets-wrapper");
}

function filtersAreOpen(filtersWrapper) {
  return filtersWrapper.classList.contains("is-open");
}

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initListingApp = initListingApp;

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxThunk = require("redux-thunk");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactRedux = require("react-redux");

var _rootReducer = require("./redux/rootReducer");

var _rootReducer2 = _interopRequireDefault(_rootReducer);

var _search = require("./redux/search/search.reducer");

var _search2 = require("./redux/search/search.actions");

var _configureStore = require("./redux/configureStore");

var _configureStore2 = _interopRequireDefault(_configureStore);

var _createRoutingMiddleware = require("./redux/createRoutingMiddleware");

var _createRoutingMiddleware2 = _interopRequireDefault(_createRoutingMiddleware);

var _routing = require("./redux/routing");

var _resultsDisplay = require("./redux/resultsDisplay");

var _ResultsContainer = require("./containers/ResultsContainer.jsx");

var _ResultsContainer2 = _interopRequireDefault(_ResultsContainer);

var _QueryContainer = require("./containers/QueryContainer.jsx");

var _QueryContainer2 = _interopRequireDefault(_QueryContainer);

var _FacetsContainer = require("./containers/FacetsContainer.jsx");

var _FacetsContainer2 = _interopRequireDefault(_FacetsContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// the mount nodes are the elements we want to include
// as part of the search app
function initListingApp(mountNodes) {

  if (!mountNodes.length) {
    return;
  }

  // extract the searchId from the mountNodes
  // while also checking mountNodes share same id
  var searchId = mountNodes.reduce(function (id, node) {
    var nodeId = (0, _jquery2.default)(node).data("searchId");
    // if id is null, we want to set it
    // with the first node's value
    if (id === null) {
      return nodeId;
    }
    // if node id does not equal current
    // id value, it's invalid and return undefined
    if (id !== nodeId) {
      return;
    }

    return id;
  }, null);

  // if we have an invalid or non-matching id, raise an error
  if (!searchId) {
    throw new Error("Could not initialize Thread search app. searchId was either not present, or provided mount nodes did not share the same searchId");
  }

  // define the canonical inital state of our redux store here
  // including some value taken from the data-attrs of the
  // mount node.
  var config = window.drexelCOESearchConfigs.find(function (c) {
    return c.searchId === searchId;
  });
  if (!config) {
    throw new Error("Could not initialize Thread search app instance with id of \"" + searchId + "\". Configuration data not found.");
  }

  // create a starting state object,
  // which includes and intitial state
  // from individual reducers
  var initialState = _ramda2.default.merge(_search.initialState, {
    url: config.url,
    pagination: config.pagination,
    resultsDisplayStrategy: config.pagination ? _resultsDisplay.RESULTS_DISPLAY_REFRESH : _resultsDisplay.RESULTS_DISPLAY_APPEND,
    sorters: config.sorters,
    dictionary: config.dictionary,
    numOpenGroups: config.numOpenGroups,
    query: _ramda2.default.merge(_search.initialState.query, {
      pageId: config.pageId
    })
  });

  // determine if we want to load all page results in our cold load
  var doLoadAllPages = initialState.resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND && initialState.isFirstLoad;

  initialState = _ramda2.default.merge(initialState, {
    query: _ramda2.default.merge(initialState.query, {
      loadAllPages: doLoadAllPages
    })
  });

  var routingMiddleware = (0, _createRoutingMiddleware2.default)(_routing.mapStateToUrl, _routing.handleUrlChange);
  var store = (0, _configureStore2.default)(_rootReducer2.default, initialState, [_reduxThunk2.default, routingMiddleware]);

  store.dispatch((0, _search2.loadResults)());

  mountNodes.forEach(function (node) {
    if (node.className.indexOf("js-search-query") > -1) {
      _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_QueryContainer2.default, null)
      ), node);
    }

    if (node.className.indexOf("js-search-results") > -1) {
      _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_ResultsContainer2.default, null)
      ), node);
    }

    if (node.className.indexOf("js-search-facets") > -1) {
      _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_FacetsContainer2.default, null)
      ), node);
    }
  });
}

},{"./containers/FacetsContainer.jsx":13,"./containers/QueryContainer.jsx":14,"./containers/ResultsContainer.jsx":15,"./redux/configureStore":19,"./redux/createRoutingMiddleware":20,"./redux/resultsDisplay":22,"./redux/rootReducer":23,"./redux/routing":24,"./redux/search/search.actions":25,"./redux/search/search.reducer":26,"jquery":"jquery","ramda":"ramda","react":"react","react-dom":"react-dom","react-redux":"react-redux","redux-thunk":"redux-thunk"}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.totalPages = totalPages;
exports.isLastPage = isLastPage;
exports.isFirstPage = isFirstPage;
exports.pageBlock = pageBlock;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// number of page to show before and after current page
// if at first or last page, double the number will be shown
// either after or before
var PAGE_BLOCK_RANGE = 3;

function totalPages(totalResults, resultsPerPage) {
  return Math.ceil(totalResults / resultsPerPage);
}
function isLastPage(totalResults, resultsPerPage, currentPage) {
  var numPages = totalPages(totalResults, resultsPerPage);
  return currentPage >= numPages;
}

function isFirstPage(currentPage) {
  return currentPage === 1;
}

// returns a block of page numbers appropriately
// adjacent to the currently selected page
function pageBlock(totalResults, resultsPerPage, currentPage) {
  var numPages = totalPages(totalResults, resultsPerPage);
  var numPagesVisible = Math.min(numPages, PAGE_BLOCK_RANGE * 2 + 1);
  var start = Math.max(1, currentPage - PAGE_BLOCK_RANGE);

  if (currentPage + PAGE_BLOCK_RANGE > numPages) {
    // (desired page range) - (Size of current page range)
    start -= numPagesVisible - (numPages - (start - 1));
  }

  var pages = _ramda2.default.range(start, start + numPagesVisible);

  return _ramda2.default.map(function (page) {
    return { num: page, label: page, current: page == currentPage
    };
  }, pages);
}

},{"ramda":"ramda"}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = configureStore;

var _redux = require("redux");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function configureStore(rootReducer) {
    var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var middlewares = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var middlewareEnhancer = _redux.applyMiddleware.apply(undefined, _toConsumableArray(middlewares));

    // https://github.com/zalmoxisus/redux-devtools-extension#1-with-redux
    // Apply devToolsExtension if present on client, otherwise, just pass through an Identity function
    var devToolEnhancer = window.devToolsExtension ? window.devToolsExtension() : function (x) {
        return x;
    };

    // build our store!
    return (0, _redux.createStore)(rootReducer, initialState, (0, _redux.compose)(middlewareEnhancer, devToolEnhancer));
}

},{"redux":"redux"}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createRoutingMiddleware;

var _urijs = require("urijs");

var _urijs2 = _interopRequireDefault(_urijs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var URL_INIT = "ROUTING/URL_INIT";

/**
 * mapStateToUrl: User provided function to get the URL parameters out of the redux state.
 *                The middleware will use this to update the URL when the redux state changes.
 * @callback mapStateToUrl
 * @param  {Object} state: the current redux state
 * @return {Object} An object with key/value pairs of the parameters to go in the url.
 *                  This object will be passed to URI.search()
 *                  https://medialize.github.io/URI.js/docs.html#accessors-search
 *                  eg { location: state.location.slug } => my-url.com/?location=united-states
 */

/**
 * hangleUrlChange: User provided function to handle updating the state when the url changes
 * @callback hangleUrlChange
 * @param  {Object} urlParams: the current url params
 * @param  {Object} store    : the current redux store.  Use store.getState() and store.dispatch
 * @param  {Object} event    : the popstate event
 * @return {Promise|Any} Return a promise if something in handleUrlChange is disptached async.
 *                       Otherwise, it doesn't matter
 */

/**
 * createRoutingMiddleware: creates a middleware function to be passed to applyMiddleware
 *                          and attaches a window popstate listener
 * @param  {Function} mapStateToUrl   : callback function, see above
 * @param  {Function} handleUrlChange : callback function, see above
 * @param  {Boolean}  handleLoad      : if true, it will call handleUrlChange when the page loads
 * @return {Function} redux middleware
 */
// http://redux.js.org/docs/advanced/Middleware.html
function createRoutingMiddleware(mapStateToUrl, handleUrlChange) {
    var handleLoad = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


    // return the middlware
    // "next" is the next dispatch function
    return function (store) {
        return function (next) {

            // flags are a code smell, but maybe this is ok in the situation.
            // use replaceState instead of pushState if this dispatch came from the popstate
            var shouldReplace = false;

            // function to run the user-provided handleUrlChange
            var executeUrlChange = function executeUrlChange(event) {

                var urlParams = (0, _urijs2.default)(window.location).search(true);

                // set the flag that lets the dispatch function know that it should use replaceState
                shouldReplace = true;

                // call user function to handle the url change.  This function will probably call store.dispatch
                var change = handleUrlChange(urlParams, store, event);

                // if handleUrlChange returns a promise, revert the flag only after it's done
                if (change && typeof change.then === "function") {
                    change.then(function () {
                        shouldReplace = false;
                    });
                }
                // otherwise, revert it after handleUrlChange is done
                else {
                        shouldReplace = false;
                    }
            };

            // execute handleUrlChange on load if specified
            if (handleLoad) {
                executeUrlChange();
            }

            // when the url changes...
            window.addEventListener("popstate", function (event) {
                event.preventDefault();
                executeUrlChange(event);
            });

            // our augmented dispatch function
            var dispatch = function dispatch(action) {

                // result is the action itself, this will also update the state
                // http://redux.js.org/docs/api/Store.html#dispatch
                var result = next(action);

                // execute the user function to get the url params out of the newly updated redux state
                var params = mapStateToUrl(store.getState());

                // .search uses a ? in the url
                var url = _urijs2.default.decode((0, _urijs2.default)(window.location.href).search(params).toString());

                // if the url is different, pushState/replaceState the new url
                if (!(0, _urijs2.default)(url).equals(window.location.href)) {
                    // if we're initializing the url params, replace the url state instead of push
                    // eg. /profile?loc=27 > /profile?loc=27&breakdown=...
                    // when the browser navigates "back", we don't want to go back to just /profile?loc=27
                    // we want all the breakdown=... stuff
                    if (action.type === URL_INIT || shouldReplace === true) {
                        history.replaceState(null, null, url);
                    } else {
                        history.pushState(null, null, url);
                    }
                }

                return result;
            };

            // dispatch immediately to populate the url params
            // (this only happens when createRoutingMiddleware is called)
            dispatch({ type: URL_INIT });

            // return the new dispatch function
            return dispatch;
        };
    };
}

},{"urijs":"urijs"}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allFacetValuesFromGroup = allFacetValuesFromGroup;
exports.selectedFacetsByGroup = selectedFacetsByGroup;
exports.selectedFacetIdsByGroup = selectedFacetIdsByGroup;
exports.selectedFacetsFromValues = selectedFacetsFromValues;
exports.selectedFacetsFromGroup = selectedFacetsFromGroup;
exports.allSelectedFacets = allSelectedFacets;
exports.groupHasSelectedChildren = groupHasSelectedChildren;
exports.valueHasSelectedChildren = valueHasSelectedChildren;
exports.valuesWithSelectedChildren = valuesWithSelectedChildren;
exports.pathFromValueId = pathFromValueId;
exports.setSelectedOnFacetValues = setSelectedOnFacetValues;
exports.getYearsFacet = getYearsFacet;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function allFacetValuesFromGroup(group) {
  var allValues = [];

  var grabAllValues = function grabAllValues(value) {
    allValues.push(value);
    if (value.childValues.length > 0) {
      value.childValues.forEach(function (cv) {
        return grabAllValues(cv);
      });
    }
  };

  group.values.forEach(function (value) {
    return grabAllValues(value);
  });

  if (group.hasOwnProperty("childGroups")) {
    group.childGroups.forEach(function (childGroup) {
      childGroup.values.forEach(function (value) {
        return grabAllValues(value);
      });
    });
  }

  return allValues;
}

// Returns an object with arrays of selected facet value objects, using
// their root group name as a key
function selectedFacetsByGroup(facets) {
  var facetsByGroup = {};
  facets.forEach(function (group) {
    var selectedFacets = selectedFacetsFromGroup(group);
    if (selectedFacets.length) {
      facetsByGroup[group.id] = selectedFacetsFromGroup(group);
    }
  });

  return facetsByGroup;
}

// Returns an object with arrays of selected facet ids, using
// their root group name as a key
function selectedFacetIdsByGroup(facets) {
  var selectedFacets = selectedFacetsByGroup(facets);
  Object.keys(selectedFacets).forEach(function (k) {
    selectedFacets[k] = selectedFacets[k].map(function (f) {
      return f.id;
    });
  });

  return selectedFacets;
}

// Given an array of facet value objects, return an
// a flat array of selected facet value object, including
// selected child values.
function selectedFacetsFromValues(values) {
  var selected = values.filter(function (v) {
    return v.selected === true;
  });
  values.forEach(function (value) {
    if (value.hasOwnProperty("childValues")) {
      selected = selected.concat(selectedFacetsFromValues(value.childValues));
    }
  });

  return selected;
}

// Given a facet group, return a flat array of selected
// facets value object, including child groups and all child values.
function selectedFacetsFromGroup(group) {
  var selected = selectedFacetsFromValues(group.values);
  if (group.hasOwnProperty("childGroups")) {
    group.childGroups.forEach(function (childGroup) {
      selected = selected.concat(selectedFacetsFromGroup(childGroup));
    });
  }

  return selected;
}

function allSelectedFacets(facets) {
  return facets.reduce(function (all, group) {
    return all.concat(selectedFacetsFromGroup(group));
  }, []);
}

function groupHasSelectedChildren(group) {
  return selectedFacetsFromGroup(group).length > 0;
}

function valueHasSelectedChildren(value) {
  // does not include selection state of group itself
  var selectedChildren = [];
  if (value.hasOwnProperty("childValues")) {
    selectedChildren = selectedFacetsFromValues(value.childValues);
  }

  return selectedChildren.length > 0;
}

// An array of values who have a child value
// selected. Does not require the value itself
// be selected.
function valuesWithSelectedChildren(group) {
  var all = allFacetValuesFromGroup(group);
  return all.reduce(function (hasSelected, value) {
    if (valueHasSelectedChildren(value)) {
      hasSelected.push(value);
    }

    return hasSelected;
  }, []);
}

// Returns an array of object path segments that
// resolves to the facet value object in the
// provided facets state object. This is useful
// when needing to make immutable changes using
// R.assocPath or R.lensPath

// TODO: This performs acceptably for now
// but is definitely not optimal for very large data sets.
// Should consider a different approach to setting deeply nested data.
function pathFromValueId(valueId, facets) {

  // First, flatten the facets object into k,v pairs of properties
  // and stringified "path" keys. Then use the paths to
  // lookup the facet value
  var facetLookup = _ramda2.default.invertObj((0, _util.flattenObj)(facets));
  var delimitedPath = facetLookup[valueId];

  // Our paths are in format "a.b.0.c', so convert into ["a", "b", 0, "c"].
  // Then pop off the last path segment so it points to the entire value
  // object, instead of just the id.
  var pathArr = delimitedPath.split(".");
  pathArr.pop();

  // Finally, ensure numerical "keys" are properly cast to Numbers
  // or else Ramda will treat them as object keys and
  // convert arrays to objects when using assocPath or lens methods.
  pathArr = pathArr.map(function (segment) {
    var numberified = parseInt(segment, 10);
    return isNaN(numberified) ? segment : numberified;
  });

  return pathArr;
}

// Return a new facets object with the give facet value selected
function setSelectedOnFacetValues(valueIds, selected, facets) {
  // Lookup the path for the given facetId
  // and change it using assocPath

  if (!valueIds.length) {
    return facets;
  }

  var paths = valueIds.map(function (valueId) {
    var pathArr = pathFromValueId(valueId, facets);
    // add "selected" to the end of our path
    pathArr.push("selected");

    return pathArr;
  });

  return paths.reduce(function (newFacets, path) {
    // NOTE: Using numerical indexes in assocPath only work in
    // Ramda 0.23.0+
    return _ramda2.default.assocPath(path, selected, newFacets);
  }, facets);
}

function getYearsFacet(facets) {
  var result = [];
  var years = facets.filter(function (facet) {
    return facet.id === "year";
  });

  if (years && years.length) {
    result = years[0].values;
    result = result.sort(function (a, b) {
      return a.count > b.count ? -1 : 1;
    });
  }

  return result;
}

},{"../util":28,"ramda":"ramda"}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// flags to determine how to handle
// showing a new result set
var RESULTS_DISPLAY_REFRESH = exports.RESULTS_DISPLAY_REFRESH = 0;
var RESULTS_DISPLAY_APPEND = exports.RESULTS_DISPLAY_APPEND = 1;

},{}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _search = require("./search/search.reducer");

var _search2 = _interopRequireDefault(_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// For now, this application only has a single reducer
// Additional reducers can be added here by using
// combineReducers() from redux or rolling your
// own: http://redux.js.org/docs/recipes/reducers/BeyondCombineReducers.html

exports.default = _search2.default;

},{"./search/search.reducer":26}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToUrl = mapStateToUrl;
exports.handleUrlChange = handleUrlChange;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _search = require("./search/search.actions");

var _facets = require("./facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToUrl(state) {
    // choose which parts of the query
    // state we want exposed in the
    // url query string
    var exposedParams = ["q", "sortBy", "sortOrder", "page", "year"];

    // if we're in pagination mode,
    // we also want to expose the page num
    if (state.pagination) {
        exposedParams.push("page");
    }

    var selectedFacets = void 0;
    if (state.facets.length > 0) {
        selectedFacets = (0, _facets.selectedFacetIdsByGroup)(state.facets);

        // turn selected facets ids into comma delimited string
        Object.keys(selectedFacets).forEach(function (k) {
            selectedFacets[k] = selectedFacets[k].join(",");
        });
    } else {
        selectedFacets = state.preSelectedFacets;
    }

    return _ramda2.default.merge(selectedFacets, _ramda2.default.pick(exposedParams, state.query));
}

function handleUrlChange(urlParams, store) {
    // a list of parameters that we know aren't
    // bound to facet group names
    var nonFacetParams = ["q", "sortOrder", "sortBy", "page", "year"];

    var facets = store.getState().facets;

    // separate out the param types
    var queryParams = _ramda2.default.pick(nonFacetParams, urlParams);
    var facetParams = _ramda2.default.omit(nonFacetParams, urlParams);

    var newFacets = [];
    var preSelectedFacets = {};
    if (facets.length > 0) {
        // get an array of valueIds from { group: valueId, valueId } format
        // and set them to selected. If
        newFacets = (0, _facets.setSelectedOnFacetValues)(_ramda2.default.values(facetParams), true, facets);
    } else {
        // if facets is empty, it's because we haven't gotten
        // a response yet. So we'll also pass an object of
        // pre-selected facets we can pass to the query
        // Note: transforms comma-delimited strings to array

        preSelectedFacets = _ramda2.default.map(_ramda2.default.split(","), facetParams);
    }

    // Anytime we expose a number value to the query
    // string it will be sent back to us as a string.
    // Make sure to cast it back to a number here.
    var castToInt = _ramda2.default.curry(parseInt)(_ramda2.default.__, 10);
    queryParams = _ramda2.default.evolve({
        page: castToInt
    }, queryParams);

    // Provide a new facets object.
    // First, just grab all facets ids from
    // from the facetParams
    //pickIds = R.values();

    return store.dispatch((0, _search.mergeQueryParams)(queryParams, newFacets, preSelectedFacets));
}

},{"./facets":21,"./search/search.actions":25,"ramda":"ramda"}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILTER_CHANGED = exports.TOGGLE_MOBILE_FACETS = exports.CLEAR_ALL_FACETS = exports.CLEAR_FACET_GROUP = exports.FACET_CHANGED = exports.SORT_CHANGED = exports.CHANGE_PAGE = exports.INCREMENT_PAGE = exports.KEYWORDS_CHANGED = exports.MERGE_QUERY_PARAMS = exports.LOAD_RESULTS_SUCCESS = exports.LOAD_RESULTS_FAIL = exports.LOAD_RESULTS_START = undefined;
exports.mergeQueryParams = mergeQueryParams;
exports.loadStart = loadStart;
exports.loadSuccess = loadSuccess;
exports.loadFail = loadFail;
exports.sortChanged = sortChanged;
exports.filterChanged = filterChanged;
exports.incrementPage = incrementPage;
exports.changePage = changePage;
exports.keywordsChanged = keywordsChanged;
exports.facetChanged = facetChanged;
exports.clearFacetGroup = clearFacetGroup;
exports.clearAllFacets = clearAllFacets;
exports.showMobileFacets = showMobileFacets;
exports.hideMobileFacets = hideMobileFacets;
exports.loadResults = loadResults;
exports.loadNextPage = loadNextPage;
exports.loadNewPage = loadNewPage;
exports.loadNewSort = loadNewSort;
exports.loadNewFilter = loadNewFilter;
exports.loadNewKeywords = loadNewKeywords;
exports.loadFacetChange = loadFacetChange;
exports.loadClearFacetGroup = loadClearFacetGroup;
exports.loadClearAllFacets = loadClearAllFacets;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _service = require("../service");

var _resultsDisplay = require("../resultsDisplay");

var _facets = require("../facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Action Names
var LOAD_RESULTS_START = exports.LOAD_RESULTS_START = "SEARCH/LOAD_RESULTS_START";
var LOAD_RESULTS_FAIL = exports.LOAD_RESULTS_FAIL = "SEARCH/LOAD_RESULTS_FAIL";
var LOAD_RESULTS_SUCCESS = exports.LOAD_RESULTS_SUCCESS = "SEARCH/LOAD_RESULTS_SUCCESS";
var MERGE_QUERY_PARAMS = exports.MERGE_QUERY_PARAMS = "SEARCH/MERGE_QUERY_PARAMS";
var KEYWORDS_CHANGED = exports.KEYWORDS_CHANGED = "SEARCH/KEYWORDS_CHANGED";
var INCREMENT_PAGE = exports.INCREMENT_PAGE = "SEARCH/INCREMENT_PAGE";
var CHANGE_PAGE = exports.CHANGE_PAGE = "SEARCH/CHANGE_PAGE";
var SORT_CHANGED = exports.SORT_CHANGED = "SEARCH/SORT_CHANGED";
var FACET_CHANGED = exports.FACET_CHANGED = "SEARCH/FACET_CHANGED";
var CLEAR_FACET_GROUP = exports.CLEAR_FACET_GROUP = "SEARCH/CLEAR_FACET_GROUP";
var CLEAR_ALL_FACETS = exports.CLEAR_ALL_FACETS = "SEARCH/CLEAR_ALL_FACETS";
var TOGGLE_MOBILE_FACETS = exports.TOGGLE_MOBILE_FACETS = "SEARCH/TOGGLE_MOBILE_FACETS";
var FILTER_CHANGED = exports.FILTER_CHANGED = "SEARCH/FILTER_CHANGED";

// Single-dispatch Action Creators
function mergeQueryParams(params, facets, preSelectedFacets) {
  return {
    type: MERGE_QUERY_PARAMS,
    payload: { params: params, facets: facets, preSelectedFacets: preSelectedFacets }
  };
}

function loadStart() {
  return {
    type: LOAD_RESULTS_START,
    payload: null
  };
}

function loadSuccess(response, resultsDisplay) {
  return {
    type: LOAD_RESULTS_SUCCESS,
    payload: { response: response, resultsDisplay: resultsDisplay }
  };
}

function loadFail(err) {
  return {
    type: LOAD_RESULTS_FAIL,
    payload: err
  };
}

function sortChanged(sorters) {
  return {
    type: SORT_CHANGED,
    payload: sorters
  };
}

function filterChanged(filters) {
  return {
    type: FILTER_CHANGED,
    payload: filters
  };
}

function incrementPage() {
  return {
    type: INCREMENT_PAGE,
    payload: null
  };
}

function changePage(pageNum) {
  return {
    type: CHANGE_PAGE,
    payload: pageNum
  };
}

function keywordsChanged(keywords) {
  return {
    type: KEYWORDS_CHANGED,
    payload: keywords
  };
}

function facetChanged(facetId, facetValue) {
  return {
    type: FACET_CHANGED,
    payload: { facetId: facetId, facetValue: facetValue }
  };
}

function clearFacetGroup(group) {
  return {
    type: CLEAR_FACET_GROUP,
    payload: group
  };
}

function clearAllFacets() {
  return {
    type: CLEAR_ALL_FACETS,
    payload: null
  };
}

function showMobileFacets() {
  return {
    type: TOGGLE_MOBILE_FACETS,
    payload: true
  };
}

function hideMobileFacets() {
  return {
    type: TOGGLE_MOBILE_FACETS,
    payload: false
  };
}

// Multi-dispatch Action Creators
// Note that multiple dispatches inside an
// action creator only work when using the
// redux-thunk middleware. These action
// creators MUST return a function.
// https://github.com/gaearon/redux-thunk

function loadResults() {
  var resultsDisplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _resultsDisplay.RESULTS_DISPLAY_APPEND;

  return function (dispatch, getState) {
    var state = getState();
    var url = state.url;

    // get our query params, and add any pre-selected facets we
    // might have
    var query = _ramda2.default.merge(state.query, state.preSelectedFacets);

    var facets = (0, _facets.selectedFacetIdsByGroup)(getState().facets);

    // merge with pre-selected facets
    _ramda2.default.merge(facets, state.preSelectedFacets);

    dispatch(loadStart());
    (0, _service.fetchSearchResults)(url, _ramda2.default.merge(query, facets)).then(function (response) {
      dispatch(loadSuccess(response, resultsDisplay));
    }).fail(function (error) {
      dispatch(loadFail(error));
    });
  };
}

function loadNextPage() {
  return function (dispatch) {
    dispatch(incrementPage());
    dispatch(loadResults());
  };
}

function loadNewPage(pageNum) {
  return function (dispatch) {
    dispatch(changePage(pageNum));
    dispatch(loadResults());
  };
}

function loadNewSort(sorters) {
  return function (dispatch) {
    dispatch(sortChanged(sorters));
    dispatch(loadResults());
  };
}

function loadNewFilter(filters) {
  return function (dispatch) {
    dispatch(filterChanged(filters));
    dispatch(changePage(1));
    dispatch(loadResults());
  };
}

function loadNewKeywords(keywords) {
  return function (dispatch) {
    dispatch(keywordsChanged(keywords));
    dispatch(loadResults());
  };
}

function loadFacetChange(facetId, facetValue) {
  return function (dispatch) {
    dispatch(facetChanged(facetId, facetValue));
    dispatch(loadResults());
  };
}

function loadClearFacetGroup(group) {
  return function (dispatch) {
    dispatch(clearFacetGroup(group));
    dispatch(loadResults());
  };
}

function loadClearAllFacets() {
  return function (dispatch) {
    dispatch(clearAllFacets());
    dispatch(loadResults());
  };
}

},{"../facets":21,"../resultsDisplay":22,"../service":27,"ramda":"ramda"}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _actionMap;

exports.default = searchReducer;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _service = require("../service");

var _facets = require("../facets");

var _resultsDisplay = require("../resultsDisplay");

var _search = require("./search.actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = {
  query: {
    q: null,
    sortBy: "relevance",
    sortOrder: "asc",
    page: 1,
    perPage: 10,
    pageId: "00000000-0000-0000-0000-000000000000",
    loadAllPages: true,
    year: ""
  },
  url: null,
  errorMsg: null,
  loading: true,
  pagination: false,
  totalResults: 0,
  results: [],
  resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_APPEND,
  sorters: [],
  dictionary: {},
  facets: [],
  numOpenGroups: null,
  preSelectedFacets: {},
  isFirstLoad: true,
  mobileFacetsShown: false
};

var actionMap = (_actionMap = {}, _defineProperty(_actionMap, _search.LOAD_RESULTS_START, loadStart), _defineProperty(_actionMap, _search.LOAD_RESULTS_SUCCESS, loadSuccess), _defineProperty(_actionMap, _search.LOAD_RESULTS_FAIL, loadError), _defineProperty(_actionMap, _search.SORT_CHANGED, updateSort), _defineProperty(_actionMap, _search.MERGE_QUERY_PARAMS, updateQueryParams), _defineProperty(_actionMap, _search.KEYWORDS_CHANGED, updateKeywords), _defineProperty(_actionMap, _search.INCREMENT_PAGE, incrementPage), _defineProperty(_actionMap, _search.CHANGE_PAGE, changePage), _defineProperty(_actionMap, _search.FACET_CHANGED, changeFacet), _defineProperty(_actionMap, _search.CLEAR_FACET_GROUP, clearFacetGroup), _defineProperty(_actionMap, _search.CLEAR_ALL_FACETS, clearAllFacets), _defineProperty(_actionMap, _search.TOGGLE_MOBILE_FACETS, toggleMobileFacets), _defineProperty(_actionMap, _search.FILTER_CHANGED, updateFilter), _actionMap);

function searchReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var actionType = actionMap[action.type];
  return actionType ? actionType(state, action) : state;
}

function loadStart(state, action) {
  return _ramda2.default.merge(state, {
    loading: true
  });
}

function loadSuccess(state, action) {
  var response = action.payload.response;

  return _ramda2.default.merge((0, _service.mapResponseToState)(response, state), {
    loading: false,
    isFirstLoad: false,
    preSelectedFacets: {}
  });
}

function loadError(state, action) {
  return _ramda2.default.merge(state, { loading: false, errorMsg: action.payload });
}

function updateSort(state, action) {
  var activeSorter = _ramda2.default.find(_ramda2.default.propEq("isActive", true), action.payload);

  return _ramda2.default.merge(state, {
    sorters: action.payload,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      sortBy: activeSorter.value,
      sortOrder: activeSorter.direction,
      page: 1
    })
  });
}

function updateFilter(state, action) {
  var result = _ramda2.default.merge(state, {
    query: _ramda2.default.merge(state.query, {
      year: action.payload.year !== undefined ? action.payload.year : state.query.year,
      q: action.payload.search !== undefined ? action.payload.search : state.query.q
    })
  });

  return result;
}

function updateQueryParams(state, action) {
  return _ramda2.default.merge(state, {
    query: _ramda2.default.merge(state.query, action.payload.params),
    facets: action.payload.facets,
    preSelectedFacets: action.payload.preSelectedFacets
  });
}

function incrementPage(state, action) {
  var pageNum = parseInt(state.query.page, 10) + 1;
  return _ramda2.default.merge(state, {
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_APPEND,
    query: _ramda2.default.merge(state.query, {
      page: pageNum
    })
  });
}

function changePage(state, action) {
  return _ramda2.default.merge(state, {
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      page: action.payload
    })
  });
}

function updateKeywords(state, action) {
  return _ramda2.default.merge(state, {
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      q: action.payload,
      page: 1
    })
  });
}

function changeFacet(state, action) {
  // We want to provide a new facet object to our
  // state with a single facet changed.

  // Lookup the path for the given facetId
  // and change it using assocPath
  var facetId = action.payload.facetId;
  var facetValue = action.payload.facetValue;
  var newFacets = (0, _facets.setSelectedOnFacetValues)([facetId], facetValue, state.facets);

  return _ramda2.default.merge(state, {
    facets: newFacets,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      page: 1
    })
  });
}

function clearFacetGroup(state, action) {
  var group = action.payload;
  var selectedFacetIds = (0, _facets.selectedFacetsFromGroup)(group).map(function (v) {
    return v.id;
  });
  var newFacets = (0, _facets.setSelectedOnFacetValues)(selectedFacetIds, false, state.facets);

  return _ramda2.default.merge(state, {
    facets: newFacets,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      page: 1
    })
  });
}

function clearAllFacets(state, action) {
  var facets = state.facets;
  var selectedFacetIds = facets.reduce(function (all, group) {
    return all.concat((0, _facets.selectedFacetsFromGroup)(group).map(function (v) {
      return v.id;
    }));
  }, []);

  var newFacets = (0, _facets.setSelectedOnFacetValues)(selectedFacetIds, false, facets);

  return _ramda2.default.merge(state, {
    facets: newFacets,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      page: 1
    })
  });
}

function toggleMobileFacets(state, action) {
  return _ramda2.default.merge({
    mobileFacetsShown: action.payload
  }, state);
}

},{"../facets":21,"../resultsDisplay":22,"../service":27,"./search.actions":25,"ramda":"ramda"}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSearchResults = fetchSearchResults;
exports.mapResponseToState = mapResponseToState;

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _resultsDisplay = require("./resultsDisplay");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newResults = _ramda2.default.curry(function (newResults, oldResults, strategy) {
    return strategy === _resultsDisplay.RESULTS_DISPLAY_APPEND ? _ramda2.default.concat(oldResults, newResults) : newResults;
});

function fetchSearchResults(url, query) {
    return _jquery2.default.ajax({
        url: url,
        data: query
    });
}

function mapResponseToState(response, state) {
    var request = response.request;
    var castToInt = _ramda2.default.curry(parseInt)(_ramda2.default.__, 10);
    return _ramda2.default.evolve({
        totalResults: function totalResults() {
            return parseInt(response.totalResults, 10);
        },
        results: newResults(response.results, _ramda2.default.__, state.resultsDisplayStrategy),
        facets: function facets() {
            return response.facets;
        },
        query: _ramda2.default.merge(_ramda2.default.__, {
            pageId: request.pageId,
            page: castToInt(request.page),
            perPage: castToInt(request.perPage),
            sortOrder: request.sortOrder,
            loadAllPages: false,
            q: request.q,
            year: request.year
        })
    }, state);
}

},{"./resultsDisplay":22,"jquery":"jquery","ramda":"ramda"}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.flattenObj = flattenObj;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utility function to map object paths to values
// See: https://github.com/ramda/ramda/wiki/Cookbook#flatten-a-nested-object-into-dot-separated-key--value-pairs
function flattenObj(obj) {
  var go = function go(obj_) {
    return _ramda2.default.chain(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];

      if ((typeof v === "undefined" ? "undefined" : _typeof(v)) == "object") {
        return _ramda2.default.map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              k_ = _ref4[0],
              v_ = _ref4[1];

          return [k + "." + k_, v_];
        }, go(v));
      } else {
        return [[k, v]];
      }
    }, _ramda2.default.toPairs(obj_));
  };

  return _ramda2.default.fromPairs(go(obj));
}

},{"ramda":"ramda"}],29:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
(function (factory) {
    'use strict';

    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }
})(function ($) {
    'use strict';

    var Slick = window.Slick || {};

    Slick = function () {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this,
                dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function customPaging(slider, i) {
                    return $('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;

            _.registerBreakpoints();
            _.init(true);
        }

        return Slick;
    }();

    Slick.prototype.activateADA = function () {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });
    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {

        var _ = this;

        if (typeof index === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || index >= _.slideCount) {
            return false;
        }

        _.unload();

        if (typeof index === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function (index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();
    };

    Slick.prototype.animateHeight = function () {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function (targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }
        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -_.currentLeft;
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function step(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' + now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' + now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function complete() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });
            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function () {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }
            }
        }
    };

    Slick.prototype.getNavTarget = function () {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if (asNavFor && asNavFor !== null) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;
    };

    Slick.prototype.asNavFor = function (index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if (asNavFor !== null && (typeof asNavFor === 'undefined' ? 'undefined' : _typeof(asNavFor)) === 'object') {
            asNavFor.each(function () {
                var target = $(this).slick('getSlick');
                if (!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }
    };

    Slick.prototype.applyTransition = function (slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }
    };

    Slick.prototype.autoPlay = function () {

        var _ = this;

        _.autoPlayClear();

        if (_.slideCount > _.options.slidesToShow) {
            _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
        }
    };

    Slick.prototype.autoPlayClear = function () {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }
    };

    Slick.prototype.autoPlayIterator = function () {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if (!_.paused && !_.interrupted && !_.focussed) {

            if (_.options.infinite === false) {

                if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
                    _.direction = 0;
                } else if (_.direction === 0) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if (_.currentSlide - 1 === 0) {
                        _.direction = 1;
                    }
                }
            }

            _.slideHandler(slideTo);
        }
    };

    Slick.prototype.buildArrows = function () {

        var _ = this;

        if (_.options.arrows === true) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if (_.slideCount > _.options.slidesToShow) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                }
            } else {

                _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
                    'aria-disabled': 'true',
                    'tabindex': '-1'
                });
            }
        }
    };

    Slick.prototype.buildDots = function () {

        var _ = this,
            i,
            dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');
        }
    };

    Slick.prototype.buildOut = function () {

        var _ = this;

        _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function (index, element) {
            $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }
    };

    Slick.prototype.buildRows = function () {

        var _ = this,
            a,
            b,
            c,
            newSlides,
            numOfSlides,
            originalSlides,
            slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if (_.options.rows > 1) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);

            for (a = 0; a < numOfSlides; a++) {
                var slide = document.createElement('div');
                for (b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for (c = 0; c < _.options.slidesPerRow; c++) {
                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children().css({
                'width': 100 / _.options.slidesPerRow + '%',
                'display': 'inline-block'
            });
        }
    };

    Slick.prototype.checkResponsive = function (initial, forceUpdate) {

        var _ = this,
            breakpoint,
            targetBreakpoint,
            respondToWidth,
            triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint = targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if (!initial && triggerBreakpoint !== false) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }
    };

    Slick.prototype.changeSlide = function (event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset,
            slideOffset,
            unevenOffset;

        // If target is a link, prevent default action.
        if ($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if (!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }
    };

    Slick.prototype.checkNavigable = function (index) {

        var _ = this,
            navigables,
            prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function () {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);
    };

    Slick.prototype.cleanUpSlideEvents = function () {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };

    Slick.prototype.cleanUpRows = function () {

        var _ = this,
            originalSlides;

        if (_.options.rows > 1) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }
    };

    Slick.prototype.clickHandler = function (event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    };

    Slick.prototype.destroy = function (refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.$prevArrow.length) {

            _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');

            if (_.htmlExpr.test(_.options.prevArrow)) {
                _.$prevArrow.remove();
            }
        }

        if (_.$nextArrow && _.$nextArrow.length) {

            _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');

            if (_.htmlExpr.test(_.options.nextArrow)) {
                _.$nextArrow.remove();
            }
        }

        if (_.$slides) {

            _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
                $(this).attr('style', $(this).data('originalStyling'));
            });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if (!refresh) {
            _.$slider.trigger('destroy', [_]);
        }
    };

    Slick.prototype.disableTransition = function (slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }
    };

    Slick.prototype.fadeSlide = function (slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);
        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function () {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }
        }
    };

    Slick.prototype.fadeSlideOut = function (slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);
        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });
        }
    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();
        }
    };

    Slick.prototype.focusHandler = function () {

        var _ = this;

        _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*:not(.slick-arrow)', function (event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function () {

                if (_.options.pauseOnFocus) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }
            }, 0);
        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {

        var _ = this;
        return _.currentSlide;
    };

    Slick.prototype.getDotCount = function () {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if (!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        } else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;
    };

    Slick.prototype.getLeft = function (slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
                verticalOffset = verticalHeight * _.options.slidesToShow * -1;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
                    } else {
                        _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
                        verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
                verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
        } else {
            targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft = 0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft = 0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;
    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {

        var _ = this;

        return _.options[option];
    };

    Slick.prototype.getNavigableIndexes = function () {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;
    };

    Slick.prototype.getSlick = function () {

        return this;
    };

    Slick.prototype.getSlideCount = function () {

        var _ = this,
            slidesTraversed,
            swipedSlide,
            centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function (index, slide) {
                if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;
        } else {
            return _.options.slidesToScroll;
        }
    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);
    };

    Slick.prototype.init = function (creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();
        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if (_.options.autoplay) {

            _.paused = false;
            _.autoPlay();
        }
    };

    Slick.prototype.initADA = function () {
        var _ = this;
        // VELIR - remove tabindex: -1
        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        _.$slideTrack.attr('role', 'listbox');

        _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
            $(this).attr({
                'role': 'option',
                'aria-describedby': 'slick-slide' + _.instanceUid + i + ''
            });
        });

        /* VELIR
            - removed adding tablish role to dots
            - removed adding role tab to li
            - removed adding aria-selected to li
            - removed adding aria-controls to li
         */

        if (_.$dots !== null) {
            _.$dots.find('li').each(function (i) {
                $(this).attr({
                    'id': 'slick-slide' + _.instanceUid + i + ''
                });
            }).find('button').attr('role', 'button').end().closest('div').attr('role', 'toolbar');
        }
        _.activateADA();
    };

    Slick.prototype.initArrowEvents = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.off('click.slick').on('click.slick', {
                message: 'previous'
            }, _.changeSlide);
            _.$nextArrow.off('click.slick').on('click.slick', {
                message: 'next'
            }, _.changeSlide);
        }
    };

    Slick.prototype.initDotEvents = function () {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true) {

            $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }
    };

    Slick.prototype.initSlideEvents = function () {

        var _ = this;

        if (_.options.pauseOnHover) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }
    };

    Slick.prototype.initializeEvents = function () {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);
    };

    Slick.prototype.initUI = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();
        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();
        }
    };

    Slick.prototype.keyHandler = function (event) {

        var _ = this;
        //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' : 'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }
    };

    Slick.prototype.lazyLoad = function () {

        var _ = this,
            loadRange,
            cloneRange,
            rangeStart,
            rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function () {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function () {

                    image.animate({ opacity: 0 }, 100, function () {
                        image.attr('src', imageSource).animate({ opacity: 1 }, 200, function () {
                            image.removeAttr('data-lazy').removeClass('slick-loading');
                        });
                        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                    });
                };

                imageToLoad.onerror = function () {

                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

                    _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
                };

                imageToLoad.src = imageSource;
            });
        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }
    };

    Slick.prototype.loadSlider = function () {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }
    };

    Slick.prototype.next = Slick.prototype.slickNext = function () {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });
    };

    Slick.prototype.orientationChange = function () {

        var _ = this;

        _.checkResponsive();
        _.setPosition();
    };

    Slick.prototype.pause = Slick.prototype.slickPause = function () {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;
    };

    Slick.prototype.play = Slick.prototype.slickPlay = function () {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;
    };

    Slick.prototype.postSlide = function (index) {

        var _ = this;

        if (!_.unslicked) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            _.setPosition();

            _.swipeLeft = null;

            if (_.options.autoplay) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();
            }
        }
    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function () {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });
    };

    Slick.prototype.preventDefault = function (event) {

        event.preventDefault();
    };

    Slick.prototype.progressiveLazyLoad = function (tryCount) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $('img[data-lazy]', _.$slider),
            image,
            imageSource,
            imageToLoad;

        if ($imgsToLoad.length) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function () {

                image.attr('src', imageSource).removeAttr('data-lazy').removeClass('slick-loading');

                if (_.options.adaptiveHeight === true) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                _.progressiveLazyLoad();
            };

            imageToLoad.onerror = function () {

                if (tryCount < 3) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout(function () {
                        _.progressiveLazyLoad(tryCount + 1);
                    }, 500);
                } else {

                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

                    _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

                    _.progressiveLazyLoad();
                }
            };

            imageToLoad.src = imageSource;
        } else {

            _.$slider.trigger('allImagesLoaded', [_]);
        }
    };

    Slick.prototype.refresh = function (initializing) {

        var _ = this,
            currentSlide,
            lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if (!initializing) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);
        }
    };

    Slick.prototype.registerBreakpoints = function () {

        var _ = this,
            breakpoint,
            currentBreakpoint,
            l,
            responsiveSettings = _.options.responsive || null;

        if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {

            _.respondTo = _.options.respondTo || 'window';

            for (breakpoint in responsiveSettings) {

                l = _.breakpoints.length - 1;
                currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while (l >= 0) {
                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
                            _.breakpoints.splice(l, 1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
                }
            }

            _.breakpoints.sort(function (a, b) {
                return _.options.mobileFirst ? a - b : b - a;
            });
        }
    };

    Slick.prototype.reinit = function () {

        var _ = this;

        _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);
    };

    Slick.prototype.resize = function () {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function () {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if (!_.unslicked) {
                    _.setPosition();
                }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {

        var _ = this;

        if (typeof index === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();
    };

    Slick.prototype.setCSS = function (position) {

        var _ = this,
            positionProps = {},
            x,
            y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }
    };

    Slick.prototype.setDimensions = function () {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: _.options.centerPadding
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: _.options.centerPadding + ' 0px'
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();

        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
    };

    Slick.prototype.setFade = function () {

        var _ = this,
            targetLeft;

        _.$slides.each(function (index, element) {
            targetLeft = _.slideWidth * index * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });
    };

    Slick.prototype.setHeight = function () {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }
    };

    Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this,
            l,
            item,
            option,
            value,
            refresh = false,
            type;

        if ($.type(arguments[0]) === 'object') {

            option = arguments[0];
            refresh = arguments[1];
            type = 'multiple';
        } else if ($.type(arguments[0]) === 'string') {

            option = arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {

                type = 'responsive';
            } else if (typeof arguments[1] !== 'undefined') {

                type = 'single';
            }
        }

        if (type === 'single') {

            _.options[option] = value;
        } else if (type === 'multiple') {

            $.each(option, function (opt, val) {

                _.options[opt] = val;
            });
        } else if (type === 'responsive') {

            for (item in value) {

                if ($.type(_.options.responsive) !== 'array') {

                    _.options.responsive = [value[item]];
                } else {

                    l = _.options.responsive.length - 1;

                    // loop through the responsive object and splice out duplicates.
                    while (l >= 0) {

                        if (_.options.responsive[l].breakpoint === value[item].breakpoint) {

                            _.options.responsive.splice(l, 1);
                        }

                        l--;
                    }

                    _.options.responsive.push(value[item]);
                }
            }
        }

        if (refresh) {

            _.unload();
            _.reinit();
        }
    };

    Slick.prototype.setPosition = function () {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);
    };

    Slick.prototype.setProps = function () {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if (_.options.fade) {
            if (typeof _.options.zIndex === 'number') {
                if (_.options.zIndex < 3) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
    };

    Slick.prototype.setSlideClasses = function (index) {

        var _ = this,
            centerOffset,
            allSlides,
            indexOffset,
            remainder;

        // VELIR - adding  tabindex: -1
        allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true').attr('tabindex', -1);

        // VELIR - adding tabindex: 0
        _.$slides.eq(index).addClass('slick-current').attr('tabindex', 0);

        if (_.options.centerMode === true) {

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {

                    _.$slides.slice(index - centerOffset, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides.slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
                }

                if (index === 0) {

                    allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
                } else if (index === _.slideCount - 1) {

                    allSlides.eq(_.options.slidesToShow).addClass('slick-center');
                }
            }

            _.$slides.eq(index).addClass('slick-center');
        } else {

            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {

                _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides.addClass('slick-active').attr('aria-hidden', 'false');
            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {

                    allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
                } else {

                    allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
                }
            }
        }

        if (_.options.lazyLoad === 'ondemand') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function () {

        var _ = this,
            i,
            slideIndex,
            infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
                    $(this).attr('id', '');
                });
            }
        }
    };

    Slick.prototype.interrupt = function (toggle) {

        var _ = this;

        if (!toggle) {
            _.autoPlay();
        }
        _.interrupted = toggle;
    };

    Slick.prototype.selectHandler = function (event) {

        var _ = this;

        var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.setSlideClasses(index);
            _.asNavFor(index);
            return;
        }

        _.slideHandler(index);
    };

    Slick.prototype.slideHandler = function (index, sync, dontAnimate) {

        var targetSlide,
            animSlide,
            oldSlide,
            slideLeft,
            targetLeft = null,
            _ = this,
            navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function () {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function () {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if (_.options.autoplay) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if (_.options.asNavFor) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if (navTarget.slideCount <= navTarget.options.slidesToShow) {
                navTarget.setSlideClasses(_.currentSlide);
            }
        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function () {
                    _.postSlide(animSlide);
                });
            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true) {
            _.animateSlide(targetLeft, function () {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }
    };

    Slick.prototype.startLoad = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();
        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();
        }

        _.$slider.addClass('slick-loading');
    };

    Slick.prototype.swipeDirection = function () {

        var xDist,
            yDist,
            r,
            swipeAngle,
            _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if (swipeAngle <= 45 && swipeAngle >= 0) {
            return _.options.rtl === false ? 'left' : 'right';
        }
        if (swipeAngle <= 360 && swipeAngle >= 315) {
            return _.options.rtl === false ? 'left' : 'right';
        }
        if (swipeAngle >= 135 && swipeAngle <= 225) {
            return _.options.rtl === false ? 'right' : 'left';
        }
        if (_.options.verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';
    };

    Slick.prototype.swipeEnd = function (event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.interrupted = false;
        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;

        if (_.touchObject.curX === undefined) {
            return false;
        }

        if (_.touchObject.edgeHit === true) {
            _.$slider.trigger('edge', [_, _.swipeDirection()]);
        }

        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {

            direction = _.swipeDirection();

            switch (direction) {

                case 'left':
                case 'down':

                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:

            }

            if (direction != 'vertical') {

                _.slideHandler(slideCount);
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction]);
            }
        } else {

            if (_.touchObject.startX !== _.touchObject.curX) {

                _.slideHandler(_.currentSlide);
                _.touchObject = {};
            }
        }
    };

    Slick.prototype.swipeHandler = function (event) {

        var _ = this;

        if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }
    };

    Slick.prototype.swipeMove = function (event) {

        var _ = this,
            edgeWasHit = false,
            curLeft,
            swipeDirection,
            swipeLength,
            positionOffset,
            touches;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        }

        swipeDirection = _.swipeDirection();

        if (swipeDirection === 'vertical') {
            return;
        }

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }

        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);
    };

    Slick.prototype.swipeStart = function (event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;
    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();
        }
    };

    Slick.prototype.unload = function () {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
    };

    Slick.prototype.unslick = function (fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();
    };

    Slick.prototype.updateArrows = function () {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            }
        }
    };

    Slick.prototype.updateDots = function () {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots.find('li').removeClass('slick-active').attr('aria-hidden', 'true');

            _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active').attr('aria-hidden', 'false');
        }
    };

    Slick.prototype.visibility = function () {

        var _ = this;

        if (_.options.autoplay) {

            if (document[_.hidden]) {

                _.interrupted = true;
            } else {

                _.interrupted = false;
            }
        }
    };

    $.fn.slick = function () {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if ((typeof opt === 'undefined' ? 'undefined' : _typeof(opt)) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);else ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };
});

},{"jquery":"jquery"}],30:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CenterModeSlider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('./../custom-vendor/slick-carousel/slick/slick');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CenterModeSlider = exports.CenterModeSlider = function () {
  function CenterModeSlider($el, conf) {
    _classCallCheck(this, CenterModeSlider);

    this.$el = $el;
    var slickConf = Object.assign(this.slickDefaults(), conf);
    var captionConf = Object.assign(this.slickCaption(), conf);

    // bind event prior to slick init
    //this.bindEvents();
    this.$el.find('.js-slider-centermode__slides').slick(slickConf);
    this.$el.find('.js-slider-centermode__captions').slick(captionConf);
  }

  /* bindEvents() {
    // bind an event on the arrows to de-focus them when
    // you mouse out, so the focus state doesn't get stuck
    this.$el.on('mouseleave', '.slick-next, .slick-prev', event => {
      event.currentTarget.blur();
    });
  } */

  _createClass(CenterModeSlider, [{
    key: 'slickDefaults',
    value: function slickDefaults() {
      return {
        //appendArrows: '.slider-centermode__slide',
        appendDots: '.js-slider-centermode__thumbnails',
        asNavFor: '.js-slider-centermode__captions',
        dots: true,
        infinite: true,
        speed: 300,
        slide: '.slider-centermode__slide',
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '30px 118px',
        customPaging: function customPaging(slider, i) {
          var thumb = (0, _jquery2.default)(slider.$slides[i]).data('thumb'),
              alt = (0, _jquery2.default)(slider.$slides[i]).find('img').attr('alt');
          return '<a style="background-image:url(' /sc_scripts/V3/+ thumb + ')" title="' + alt + '" aria-label="' + alt + '"></a>';
        },
        nextArrow: (0, _jquery2.default)('.slick-next'),
        prevArrow: (0, _jquery2.default)('.slick-prev'),
        responsive: [{
          breakpoint: 510,
          settings: {
            adaptiveHeight: true,
            appendDots: '.js-slider-centermode__slides',
            centerMode: false,
            customPaging: function customPaging(slider, i) {
              return i + 1 + '/' + slider.slideCount;
            },
            dotsClass: 'slider-centermode__count'
          }
        }]

      };
    }
  }, {
    key: 'slickCaption',
    value: function slickCaption() {
      return {
        arrows: false,
        asNavFor: '.js-slider-centermode__slides',
        centerMode: true,
        dots: false,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300
      };
    }
  }]);

  return CenterModeSlider;
}();

},{"./../custom-vendor/slick-carousel/slick/slick":29,"jquery":"jquery"}],31:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageSlider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('./../custom-vendor/slick-carousel/slick/slick');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImageSlider = exports.ImageSlider = function () {
  function ImageSlider($el, conf) {
    _classCallCheck(this, ImageSlider);

    this.$el = $el;
    var slickConf = Object.assign(this.slickDefaults(), conf);

    // bind event prior to slick init
    this.bindEvents();
    this.$el.slick(slickConf);
  }

  _createClass(ImageSlider, [{
    key: 'bindEvents',
    value: function bindEvents() {
      // bind an event on the arrows to de-focus them when
      // you mouse out, so the focus state doesn't get stuck
      this.$el.on('mouseleave', '.slick-next, .slick-prev', function (event) {
        event.currentTarget.blur();
      });
    }
  }, {
    key: 'slickDefaults',
    value: function slickDefaults() {
      return {
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      };
    }
  }]);

  return ImageSlider;
}();

},{"./../custom-vendor/slick-carousel/slick/slick":29,"jquery":"jquery"}],32:[function(require,module,exports){
'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $inputs = (0, _jquery2.default)('.input-with-filter__input');

if ($inputs.length) {
	init();
}

function init() {
	bindEvents();
}

function moveLabelUp() {
	var $activeInputParent = (0, _jquery2.default)(this).closest('.input-with-filter');
	$activeInputParent.addClass('is-active');
}

function moveLabelDown() {
	var $activeInput = (0, _jquery2.default)(this);
	var $activeInputParent = (0, _jquery2.default)(this).closest('.input-with-filter');

	if ($activeInput.val().length === 0) {
		$activeInputParent.removeClass('is-active');
	}
}

function bindEvents() {
	$inputs.on("focus", moveLabelUp);
	$inputs.on("blur", moveLabelDown);
}

},{"jquery":"jquery"}],33:[function(require,module,exports){
(function (global){
'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _mustache = require('mustache');

var _mustache2 = _interopRequireDefault(_mustache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

global.jQuery = _jquery2.default;
require("jquery-autocomplete");
require('es6-promise').polyfill();
require('isomorphic-fetch');
var $areaFilterInput = (0, _jquery2.default)('.js-listing-filter__input');
var $areaTemplate = (0, _jquery2.default)('.js-listing-template');
var $targetContainer = (0, _jquery2.default)("#js-listing");
var $template = (0, _jquery2.default)("#js-listing-template").html();
var dataUrl = $targetContainer.attr('data-url');
console.log(dataUrl);
console.log('' + dataUrl);
var tempData = {
  "listItems": [{
    "url": "#",
    "title": "Architectural Engineering",
    "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam impedit velit dolorem quam aut, sapiente cupiditate voluptate quidem placeat odit repellendus consequatur, perspiciatis, porro optio. Harum illum et commodi, dolorum!",
    "cta": "Learn more",
    "areas": ["Bachelor's", "Master's", "Online", "PhD"]
  }, {
    "url": "#",
    "title": "Computer Engineering",
    "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam impedit velit dolorem quam aut, sapiente cupiditate voluptate quidem placeat odit repellendus consequatur, perspiciatis, porro optio. Harum illum et commodi, dolorum!",
    "cta": "Learn more",
    "areas": ["Bachelor's", "Master's", "Online", "PhD"]
  }, {
    "url": "#",
    "title": "CYBERSECURITY",
    "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam impedit velit dolorem quam aut, sapiente cupiditate voluptate quidem placeat odit repellendus consequatur, perspiciatis, porro optio. Harum illum et commodi, dolorum!",
    "cta": "Learn more",
    "areas": ["Bachelor's", "Master's", "Online", "PhD"]
  }]
};

if ($areaFilterInput.length) {
  init();
}

function init() {
  getData();
}

function bindData(data) {
  var html = _mustache2.default.to_html($template, data);
  $targetContainer.html(html);
}

function initTypeahead(data) {
  var areasOfStudy = data.map(function (obj) {
    return obj.title;
  });

  $areaFilterInput.autocomplete({
    source: [areasOfStudy],
    openOnFocus: false,
    showHint: false
  }).on('selected.xdsoft', function () {
    var userInput = $areaFilterInput.val();
    var relevantAreas = getRelevantAreas(userInput, data);

    if (userInput.length > 0) {
      bindData(relevantAreas);
    } else if (userInput.length === 0) {
      bindData(data);
    }
  });
}

function getData() {
  fetch('' + dataUrl).then(function (response) {
    if (response.status !== 200) {
      console.log('Looks like there was a problem. Status Code: ' + response.status);
      return;
    }

    // Examine the text in the response
    response.json().then(function (d) {
      var data = d.listItems;
      bindData(data);
      watchUserInput(data);
      initTypeahead(data);
    });
  }).catch(function (err) {
    console.log('Fetch Error :-S', err);
  });
}

function getRelevantAreas(query, data) {
  var lowerCaseQuery = query.toLowerCase();

  var relevantItems = data.filter(function (area) {
    var titleMatch = area.title.toLowerCase().indexOf(lowerCaseQuery) != -1;
    var descriptionMatch = void 0;
    if (area.description) {
      descriptionMatch = area.description.indexOf(lowerCaseQuery) != -1;
    }

    if (titleMatch || descriptionMatch) {
      return area;
    }
  });

  return relevantItems;
}

function watchUserInput(data) {

  $areaFilterInput.on('keyup', function (event) {
    var userInput = this.value;
    var relevantAreas = getRelevantAreas(userInput, data);

    if (userInput.length > 0) {
      bindData(relevantAreas);
    } else if (userInput.length === 0) {
      bindData(data);
    }
  });
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"es6-promise":"es6-promise","isomorphic-fetch":"isomorphic-fetch","jquery":"jquery","jquery-autocomplete":"jquery-autocomplete","mustache":"mustache"}],34:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ReadMore;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ReadMore($element, readMoreLabel, readLessLabel, ellipsis, limit) {
    var originalContent = $element.html(),
        originalText = $element.text(),
        limitedText = originalText.substring(0, limit),

    // removes trailing hyphen, comma, period and whitespace and adds ellipsis
    limitedTextClean = limitedText.replace(/(-|,|\.|\s)$/g, "") + ellipsis,
        truncatedContent = limitedTextClean,
        readMore = readMoreLabel,
        readLess = readLessLabel;

    var toggleRead = function toggleRead() {
        if (originalText.length > limit) {
            $element.html(truncatedContent);
            var $trigger = (0, _jquery2.default)('<a href="#" class="readmoreless readmoreless--more js-readmoreless">' + readMore + '</a>').insertAfter($element);

            $trigger.on('click', function (event) {
                event.preventDefault();
                var $currentTrigger = (0, _jquery2.default)(this);
                if ($currentTrigger.hasClass('readmoreless--more')) {
                    $element.html(originalContent);
                    $currentTrigger.removeClass('readmoreless--more').addClass('readmoreless--less').text(readLess);
                } else {
                    $element.html(truncatedContent);
                    $currentTrigger.removeClass('readmoreless--less').addClass('readmoreless--more').text(readMore);
                }
            });
        }
    };

    var beforePrint = function beforePrint() {
        $element.html(originalContent);
        (0, _jquery2.default)('.js-readmoreless').detach();
    };
    var afterPrint = function afterPrint() {
        toggleRead();
    };

    if (window.matchMedia) {
        var mediaQueryList = window.matchMedia('print');
        mediaQueryList.addListener(function (mql) {
            if (mql.matches) {
                beforePrint();
            } else {
                afterPrint();
            }
        });
    }

    window.onbeforeprint = beforePrint;
    window.onafterprint = afterPrint;
    toggleRead();
}

},{"jquery":"jquery"}],35:[function(require,module,exports){
'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $searchDropdownContainer = (0, _jquery2.default)('.site-search');
var $searchDropdownInput = (0, _jquery2.default)('.site-search input');
var $searchDropdownToggle = (0, _jquery2.default)('.js-site-search__toggle');

if ($searchDropdownContainer.length) {
	init();
}

function init() {
	bindEvents();
}

function bindEvents() {
	$searchDropdownToggle.on('click', toggleDropdown);
	$searchDropdownToggle.on('keyup', toggleDropdownWithKeyboard);
	(0, _jquery2.default)(document).on('keydown', '.site-search input', inputHandler);

	$searchDropdownContainer.on('submit', function (event) {
		event.preventDefault();
	});
}

function toggleDropdown() {
	toggleTabIndexOnSearchInput();
	$searchDropdownContainer.toggleClass('is-open');
}

function toggleDropdownWithKeyboard(event) {
	toggleTabIndexOnSearchInput();

	if (event.keyCode === 13) {
		$searchDropdownContainer.addClass('is-open');
		setInputFocus();
	} else if (event.keyCode === 27) {
		$searchDropdownContainer.removeClass('is-open');
		$searchDropdownToggle.focus();
	}
	event.preventDefault();
}

function toggleTabIndexOnSearchInput() {
	if ($searchDropdownInput.attr("tabindex") == -1) {
		$searchDropdownInput.removeAttr("tabindex");
	} else {
		$searchDropdownInput.attr("tabindex", "-1");
	}
}

function inputHandler(event) {

	if (event.keyCode === 27) {
		$searchDropdownContainer.removeClass('is-open');
		event.preventDefault();
	} else if (event.keyCode === 13) {
		window.location = "http://" + window.location.hostname + _sr + "search?q=" + $searchDropdownInput.val();
		event.preventDefault();
	}
}

function setInputFocus() {
	$searchDropdownInput.focus();
}

},{"jquery":"jquery"}],36:[function(require,module,exports){
"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _search = require("../../drexel/search");

var _staffListing = require("../../drexel/staffListing");

var _studentListing = require("../../drexel/studentListing");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $tabContainer = (0, _jquery2.default)('.js-tabs');
var $tabs = (0, _jquery2.default)('.js-tab');
var $tabContent = (0, _jquery2.default)('.js-tab-content');

if ($tabContainer.length) {
	init();
}

function init() {
	openInitialTab();
	bindEvents();
}

function bindEvents() {
	$tabs.on('click', toggleTab);
}

function openInitialTab() {

	if (window.location.href.indexOf("#staff") >= 0) {
		$tabs.first().next().addClass('is-active');
		$tabContent.first().next().addClass('is-visible');
	} else if (window.location.href.indexOf("#student") >= 0) {
		$tabs.last().addClass('is-active');
		$tabContent.last().addClass('is-visible');
	} else if (window.location.href.indexOf("#department") >= 0) {
		$tabs.last().addClass('is-active');
		$tabContent.last().addClass('is-visible');
	} else {
		$tabs.first().addClass('is-active');
		$tabContent.first().addClass('is-visible');
	}

	// if ($(".js-tab-content .js-directory-results").length) {
	// 	initDirectoryApp($.makeArray($(".js-directory-results,.js-directory-facets")));
	// }
}

function toggleTab() {
	var $activeTab = (0, _jquery2.default)(this);
	var $activeIndex = $tabs.index($activeTab);
	var $activeContent = $tabContent.eq($activeIndex);
	var staffLoaded = false;
	var studentLoaded = false;

	$tabs.removeClass('is-active');
	$activeTab.addClass('is-active');

	$tabContent.removeClass('is-visible');
	$activeContent.addClass('is-visible');

	// if($activeTab.hasClass('js-tab--staff') && staffLoaded === false) {
	// 	if ($(".js-tab-content .js-staff-results").length) {
	// 		initStaffListingApp($.makeArray($(".js-staff-results,.js-staff-facets")));
	// 		staffLoaded = true;
	// 	}
	// }

	return false;
}

},{"../../drexel/search":54,"../../drexel/staffListing":81,"../../drexel/studentListing":108,"jquery":"jquery"}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryNav = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _breakpoint = require("../breakpoint");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KEY_CODES = {
  tab: 9,
  enter: 13,
  leftArrow: 37,
  rightArrow: 39,
  upArrow: 38,
  downArrow: 40,
  esc: 27,
  space: 32
};
var bookendMarkup = '<div tabindex="0" data-bookends />';
var bookendSelector = "[data-bookends]";
var focusableSelector = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";

var PrimaryNav = exports.PrimaryNav = function () {
  function PrimaryNav($el) {
    _classCallCheck(this, PrimaryNav);

    this.$el = $el;
    this.$navMenu = $el.find(".js-menu");
    this.$navItems = $el.find(".js-nav-item");
    this.$globalHeaderBottom = (0, _jquery2.default)(".global-header__bottom");
    this.$navToggle = this.$globalHeaderBottom.find(".js-nav-toggle");
    this.$searchBox = (0, _jquery2.default)(".site-search input");
    this.$searchContainer = (0, _jquery2.default)(".global-header__bottom .primary-nav .utility-nav nav .utility-nav__search");
    this.$searchNewHome = (0, _jquery2.default)(".global-header__bottom .primary-nav__menu-wrap__inner");
    this.$searchOldHome = (0, _jquery2.default)(".global-header__bottom .utility-nav nav");
    this.openClass = "is-open";

    this.bindEvents();

    this.$navItems.each(this.adjustFlyoutMenuAlignment);

    // run any breakpoint changes immediately
    this.onBreakpointChange((0, _breakpoint.breakpoint)());
  }

  _createClass(PrimaryNav, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      // Show sub menus on click
      this.$navItems.filter(".has-submenu").on("click", function (event) {
        return _this.onItemClick(event);
      });

      // Toggle entire navigation when hidden
      // in some viewports
      this.$navToggle.on("click", function (event) {
        return _this.onNavToggleClick(event);
      });

      this.$el.on("click", function (e) {
        return _this.toggleNavMenu(e);
      });

      this.$navMenu.on("click", function (event) {
        return _this.onMenuClick(event);
      });

      // bind keypress events for keyboard navigation
      this.$navMenu.on("keydown", function (event) {
        return _this.onKeyPress(event);
      });

      // Add a document click handler to detect clicks
      // with the intent to dismiss navigation
      (0, _jquery2.default)(document).on("click", function (event) {
        return _this.onOtherClick(event);
      });

      // tie in certain responsive behaviors to a throttled
      // resize event
      (0, _jquery2.default)(window).on("resize", function (event) {
        window.clearTimeout(throttler);
        var throttler = setTimeout(function () {
          _this.$navItems.each(_this.adjustFlyoutMenuAlignment);
          _this.onBreakpointChange((0, _breakpoint.breakpoint)());
        }, 400);
      });

      (0, _jquery2.default)(document).ready(function (evemt) {
        setTimeout(function () {
          _this.$navItems.each(_this.adjustFlyoutMenuAlignment);
        }, 0);
      });
    }
  }, {
    key: "onNavToggleClick",
    value: function onNavToggleClick(event) {
      // Prevent this click from being counted
      // as a document click
      event.stopPropagation();
      event.preventDefault();

      this.toggleNavMenu(event);
    }
  }, {
    key: "onMenuClick",
    value: function onMenuClick(event) {
      event.stopPropagation();
    }
  }, {
    key: "onItemClick",
    value: function onItemClick(event) {
      // Prevent this click from being counted
      // as a document click
      event.stopPropagation();
      var $clickedItem = (0, _jquery2.default)(event.target).closest(".js-nav-item");
      this.operateSubMenu($clickedItem);
    }
  }, {
    key: "onOtherClick",
    value: function onOtherClick(event) {
      if ((0, _breakpoint.breakpoint)() === "large") {
        this.toggleFlyoutMenus([this.$openItem()]);
      }
    }
  }, {
    key: "onBreakpointChange",
    value: function onBreakpointChange(bp) {
      switch (bp) {
        case "large":
          this.$navMenu.show();
          this.ariaExpand(this.$el);
          break;
        case "medium":
          this.ariaCollapse(this.$el);
          break;
        case "small":
        default:
          return;
      }
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(event) {
      switch (event.which) {
        case KEY_CODES.enter:
        case KEY_CODES.space:
          //this.toggleInContext(this.focusContext());
          break;
        case KEY_CODES.rightArrow:
          this.rightInContext(this.focusContext());
          event.stopPropagation();
          event.preventDefault();
          break;
        case KEY_CODES.leftArrow:
          this.leftInContext(this.focusContext());
          event.stopPropagation();
          event.preventDefault();
          break;
        case KEY_CODES.upArrow:
          this.upInContext(this.focusContext());
          event.stopPropagation();
          event.preventDefault();
          break;
        case KEY_CODES.downArrow:
          this.downInContext(this.focusContext());
          event.stopPropagation();
          event.preventDefault();
          break;
        case KEY_CODES.esc:
          this.collapseInContext(this.focusContext());
          break;
        default:
          return;
      }
    }
  }, {
    key: "operateSubMenu",
    value: function operateSubMenu($el) {
      // the behavior of the menus changes depending
      // on the active breakpoint
      switch ((0, _breakpoint.breakpoint)()) {
        case "large":
          this.toggleFlyoutMenus([$el, this.$openItem()]);
          break;
        case "medium":
        case "small":
          this.toggleCollapsingMenu($el);
          break;
        default:
          return;
      }
    }

    // explicity close a submenu

  }, {
    key: "closeSubMenu",
    value: function closeSubMenu($el) {
      switch ((0, _breakpoint.breakpoint)()) {
        case "large":
          this.closeFlyoutMenu($el);
          break;
        case "medium":
        case "small":
          this.closeCollapsingMenu($el);
          break;
        default:
          return;
      }
    }
  }, {
    key: "toggleNavMenu",
    value: function toggleNavMenu(event) {
      if (this.$el.hasClass(this.openClass)) {
        this.ariaCollapse(this.$el);
        this.$searchContainer.prependTo(this.$searchOldHome);
        this.$searchBox.attr("tabindex", "-1");
        this.destroyBookends();
      } else {
        this.ariaExpand(this.$el);
        this.$searchContainer.prependTo(this.$searchNewHome);
        this.$searchBox.removeAttr("tabindex");
        this.createBookends();
      }

      this.$navToggle.toggleClass(this.openClass);
      this.$el.toggleClass(this.openClass);
      (0, _jquery2.default)("body").toggleClass(this.openClass);
    }
  }, {
    key: "createBookends",
    value: function createBookends() {
      // Add bookends to trap tab user at mobile in nav
      this.$globalHeaderBottom.prepend(bookendMarkup);
      this.$globalHeaderBottom.append(bookendMarkup);

      // Logic to trap focus inside the open menu
      var $bookends = this.$globalHeaderBottom.find(bookendSelector),
          $focusableElements = this.$globalHeaderBottom.find(focusableSelector);

      if ($bookends.length !== 0) {
        $bookends.eq(0) // Focusing first bookend sends focus to last real focusable element
        .on("focus", function () {
          this.findFocusableElement($focusableElements, -2, -1).focus();
        }.bind(this)).end().eq(1) // Focusing last bookend sends focus to the first real focusable element
        .on("focus", function () {
          this.findFocusableElement($focusableElements).focus();
        }.bind(this));
      }
    }
  }, {
    key: "destroyBookends",
    value: function destroyBookends() {
      this.$globalHeaderBottom.find(bookendSelector).remove();
    }
  }, {
    key: "findFocusableElement",
    value: function findFocusableElement($focusableElements) {
      var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var inc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      if ($focusableElements.eq(start).attr("tabIndex") !== "-1") {
        return $focusableElements.eq(start);
      } else {
        return this.findFocusableElement($focusableElements, start + inc, inc);
      }
    }
  }, {
    key: "ariaExpand",
    value: function ariaExpand($el) {
      $el.attr("aria-expanded", true);
      $el.attr("aria-hidden", false);
    }
  }, {
    key: "ariaCollapse",
    value: function ariaCollapse($el) {
      $el.attr("aria-expanded", false);
      $el.attr("aria-hidden", true);
    }
  }, {
    key: "toggleFlyoutMenus",
    value: function toggleFlyoutMenus(items) {
      var _this2 = this;

      // In case the same item is added twice (by clicking on the currently open item, for example)
      // only apply behavior to each element once
      items.reduce(function ($toggled, $item) {
        if ($toggled.index($item) === -1) {
          if ($item.hasClass(_this2.openClass) || $item.parent().hasClass(_this2.openClass)) {
            _this2.closeFlyoutMenu($item);
            _this2.closeMenuAttributes($item);
            _this2.ariaCollapse($item.find(".js-submenu"));
          } else {
            _this2.openFlyoutMenu($item);
            _this2.openMenuAttributes($item);
            _this2.ariaExpand($item.find(".js-submenu"));
          }

          return $toggled.add($item);
        }
      }, (0, _jquery2.default)());
    }
  }, {
    key: "openFlyoutMenu",
    value: function openFlyoutMenu($item) {
      this.openMenuAttributes($item);
    }
  }, {
    key: "closeFlyoutMenu",
    value: function closeFlyoutMenu($item) {
      this.closeMenuAttributes($item);
    }
  }, {
    key: "toggleCollapsingMenu",
    value: function toggleCollapsingMenu($item) {
      if ($item.hasClass(this.openClass)) {
        this.closeCollapsingMenu($item);
        this.closeMenuAttributes($item);
      } else {
        this.openCollapsingMenu($item);
        this.openMenuAttributes($item);
      }
    }
  }, {
    key: "openCollapsingMenu",
    value: function openCollapsingMenu($item) {
      var $submenu = $item.find(".js-submenu");
      $submenu.slideDown(300);
    }
  }, {
    key: "closeCollapsingMenu",
    value: function closeCollapsingMenu($item) {
      var $submenu = $item.find(".js-submenu");
      $submenu.slideUp(300);
    }
  }, {
    key: "openMenuAttributes",
    value: function openMenuAttributes($item) {
      $item.addClass(this.openClass);
      $item.find(".primary-nav__subitem a").attr("tabindex", 0);
    }
  }, {
    key: "closeMenuAttributes",
    value: function closeMenuAttributes($item) {
      $item.removeClass(this.openClass);
      $item.find(".primary-nav__subitem a").attr("tabindex", -1);
    }
  }, {
    key: "adjustFlyoutMenuAlignment",
    value: function adjustFlyoutMenuAlignment(idx, item) {
      // if the menu is going to be rendered offscreen,
      // we need to push it back.
      var $item = (0, _jquery2.default)(item);
      var $menu = $item.find(".js-submenu");
      var left = $item.offset().left;
      var menuWidth = $menu.outerWidth();
      var windowWidth = (0, _jquery2.default)(window).width();
      var diff = windowWidth - (left + menuWidth);

      var newLeft = diff < 0 ? diff : 0;

      $menu.css({ left: newLeft + "px" });
    }
  }, {
    key: "$openItem",
    value: function $openItem() {
      return this.$el.find("." + this.openClass);
    }
  }, {
    key: "downInContext",
    value: function downInContext(context) {
      if (!context) {
        return;
      }

      if (!context.$parent && context.$el.hasClass("js-has-submenu")) {
        this.operateSubMenu(context.$el);
        context.$el.find("a:first").trigger("focus");
      } else if (context.$parent && context.$next) {
        context.$next.trigger("focus");
      }
    }
  }, {
    key: "upInContext",
    value: function upInContext(context) {
      if (!context) {
        return;
      }

      if (context.$parent && !context.$prev) {
        this.operateSubMenu(context.$el);
        context.$parent.trigger("focus");
      } else if (context.$parent && context.$prev) {
        context.$prev.trigger("focus");
      }
    }
  }, {
    key: "collapseInContext",
    value: function collapseInContext(context) {
      this.closeSubMenu(context.$el);
    }
  }, {
    key: "toggleInContext",
    value: function toggleInContext(context) {
      this.operateSubMenu(context.$el);
    }
  }, {
    key: "rightInContext",
    value: function rightInContext(context) {
      if (!context) {
        return;
      }

      if (context.$parent) {
        var $nextMenu = context.$parent.nextAll(".js-has-submenu").first();
        this.operateSubMenu($nextMenu);
        $nextMenu.find("li a").first().trigger("focus");
      } else if (context.$next) {
        context.$next.trigger("focus");
      }
    }
  }, {
    key: "leftInContext",
    value: function leftInContext(context) {
      if (!context) {
        return;
      }

      if (context.$parent) {
        var $prevMenu = context.$parent.prevAll(".js-has-submenu").first();
        this.operateSubMenu($prevMenu);
        $prevMenu.find("li a").first().trigger("focus");
      } else if (context.$prev) {
        context.$prev.trigger("focus");
      }
    }

    // Provides an object with the currently focused element,
    // prev and next focusable elements, and the menu parent
    // if applicable

  }, {
    key: "focusContext",
    value: function focusContext() {
      var $focusEl = (0, _jquery2.default)(document.activeElement);

      // return nothing if focus doesn"t exist, or is not in our menu
      if (!$focusEl.length || $focusEl.closest(".js-menu").length === 0) {
        return;
      }

      // get the next focusable item
      var $next = function $next($el) {
        // If we"re focused on an <a>, move up to parent <li>
        if ($el[0].nodeName === "A") {
          $el = $el.parent();
        }

        // get immediate sibling
        var $nextEl = $el.next();

        // if no tabindex defined, select the inner <a> instead
        if ($nextEl.attr("tabindex") === undefined) {
          $nextEl = $nextEl.children("a:first");
        }

        return $nextEl.length === 0 ? null : $nextEl;
      };

      // get the prev focusable item
      var $prev = function $prev($el) {
        // If we"re focused on an <a>, move up to parent <li>
        if ($el[0].nodeName === "A") {
          $el = $el.parent();
        }

        // Get the immediate sibling
        var $prevEl = $el.prev();

        // if no tabindex defined, select the inner <a> instead
        if ($prevEl.attr("tabindex") === undefined) {
          $prevEl = $prevEl.children("a:first");
        }

        return $prevEl.length === 0 ? null : $prevEl;
      };

      // get a parent
      var $parent = function $parent($el) {
        var $parentEl = $el.parents("ul").parents(".js-nav-item");
        return $parentEl.length === 0 ? null : $parentEl;
      };

      return {
        $el: $focusEl,
        $next: $next($focusEl),
        $prev: $prev($focusEl),
        $parent: $parent($focusEl)
      };
    }
  }]);

  return PrimaryNav;
}();

},{"../breakpoint":1,"jquery":"jquery"}],38:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryNav = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SecondaryNav = exports.SecondaryNav = function () {
  function SecondaryNav($el) {
    _classCallCheck(this, SecondaryNav);

    this.$el = $el;
    this.$menu = this.$el.find('.js-menu');
    this.$toggle = this.$el.find('.js-nav-toggle');

    this.bindEvents();
  }

  _createClass(SecondaryNav, [{
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;

      // the menu should expand/collapse on click
      // use mousedown as it will be handled before focus
      this.$toggle.on('mousedown', function (event) {
        _this.toggleNav(event);
      });

      // Still need to handle click to
      // prevent default
      this.$toggle.on('click', function (event) {
        event.preventDefault();
      });
    }
  }, {
    key: 'toggleNav',
    value: function toggleNav(event) {
      if (this.isOpen()) {
        this.closeNav(event);
      } else {
        this.openNav(event);
      }
    }
  }, {
    key: 'openNav',
    value: function openNav(event) {
      this.$menu.slideDown(250);
      this.$el.addClass('is-open');
    }
  }, {
    key: 'closeNav',
    value: function closeNav(event) {
      this.$menu.slideUp(250);
      this.$el.removeClass('is-open');
    }
  }, {
    key: 'isOpen',
    value: function isOpen() {
      return this.$el.hasClass('is-open');
    }
  }]);

  return SecondaryNav;
}();

},{"jquery":"jquery"}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _facets = require("../redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_FACETS_SHOWN = 5;

var FacetGroup = function (_React$Component) {
  _inherits(FacetGroup, _React$Component);

  function FacetGroup(props) {
    _classCallCheck(this, FacetGroup);

    var _this = _possibleConstructorReturn(this, (FacetGroup.__proto__ || Object.getPrototypeOf(FacetGroup)).call(this, props));

    _this.state = {
      isGroupOpen: true,
      isGroupExpanded: false,
      valuesExpanded: [],
      searchTerm: "",
      facetGroupClicked: false
    };

    _this.pageClickHandler = _this.pageClickHandler.bind(_this);
    return _this;
  }

  // Lifecycle

  _createClass(FacetGroup, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // if group is closed, but has selected
      // values, open it
      var group = this.props.group;

      var selected = (0, _facets.selectedFacetsFromGroup)(group);
      var shouldOpen = this.state.isGroupOpen;
      if (selected.length > 0) {
        shouldOpen = true;
      }

      // Some facets will be expanded by default due to
      // children being pre-selected
      var hasSelected = (0, _facets.valuesWithSelectedChildren)(group);
      var selectedIds = hasSelected.map(function (v) {
        return v.id;
      });

      // similarly, if group's values or value children
      // are selected, auto-expand that group
      var tailValues = _ramda2.default.drop(MAX_FACETS_SHOWN, group.values);
      var shouldExpand = tailValues.reduce(function (should, tv) {
        if (tv.selected === true || selectedIds.indexOf(tv.id) >= 0) {
          should = true;
        }

        return should;
      }, false);

      window.addEventListener('mousedown', this.pageClickHandler, false);

      this.setState({
        isGroupOpen: shouldOpen,
        isGroupExpanded: true,
        valuesExpanded: selectedIds
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.pageClickHandler, false);
    }
  }, {
    key: "pageClickHandler",
    value: function pageClickHandler() {
      if (!this.state.facetGroupClicked) {
        this.setState({ showFacetDropdown: false });
      }
    }
  }, {
    key: "facetRefinementMenuHandler",
    value: function facetRefinementMenuHandler(event) {
      var wasEscapePressed = event.keyCode === 27;

      if (wasEscapePressed) {
        this.pageClickHandler();
        this.restoreArrowKeyScrolling();
      }
    }
  }, {
    key: "chunkValues",
    value: function chunkValues(values) {
      // divide the values into two arrays, the first for the Top X facets
      // and the second for overflow. If recursion level is over zero, put
      // all values in first array.
      return values.length > MAX_FACETS_SHOWN ? _ramda2.default.splitAt(MAX_FACETS_SHOWN, values) : [values, []];
    }
  }, {
    key: "showExpandButton",
    value: function showExpandButton() {
      return !this.state.isGroupExpanded;
    }
  }, {
    key: "shouldRenderTailValues",
    value: function shouldRenderTailValues(tailValues) {
      return this.state.isGroupExpanded && tailValues.length > 0;
    }
  }, {
    key: "shouldRenderChildGroups",
    value: function shouldRenderChildGroups(group) {
      return group.isOpen && !!group.childGroups && group.childGroups.length > 0;
    }
  }, {
    key: "toggleGroup",
    value: function toggleGroup() {
      var isOpen = !this.state.isGroupOpen;
      this.setState({ isGroupOpen: isOpen });
    }
  }, {
    key: "toggleExpand",
    value: function toggleExpand() {
      var isExpanded = !this.state.isGroupExpanded;
      this.setState({ isGroupExpanded: isExpanded });
    }
  }, {
    key: "toggleValueExpand",
    value: function toggleValueExpand(valueId) {
      // check if the valueId is in the list. Remove it
      // if found, add it if not.
      var valueIdx = this.state.valuesExpanded.indexOf(valueId);
      var selectedValues = valueIdx >= 0 ? _ramda2.default.remove(valueIdx, 1, this.state.valuesExpanded) : _ramda2.default.append(valueId, this.state.valuesExpanded);

      this.setState({ valuesExpanded: selectedValues });
    }
  }, {
    key: "valueIsExpanded",
    value: function valueIsExpanded(value) {
      return this.state.valuesExpanded.indexOf(value.id) >= 0;
    }
  }, {
    key: "onFacetChange",
    value: function onFacetChange(event, value) {
      var group = this.props.group;
      var selected = (0, _facets.selectedFacetsFromGroup)(group);
      var hasselections = selected.length > 0;

      if (hasselections) this.props.handleClearGroup(this.props.group);

      this.setState({ activeDescendant: event.target.id });
      this.props.updateSelectedFacets(value, event.target.checked);
      this.props.handleFacetChange(value.id, event.target.checked);

      //hack delay to prevent flashing
      if (hasselections) {
        var start = new Date().getTime();
        for (var i = 0; i < 1e7; i++) {
          if (new Date().getTime() - start > 700) {
            break;
          }
        }
      }

      this.restoreArrowKeyScrolling();
    }
  }, {
    key: "onFacetKeyUp",
    value: function onFacetKeyUp(event) {
      var visibleFacetsDropdownId = this.getFilteredFacets(this.state.searchTerm).id + '_dropdown';
      var keyPressed = event.keyCode;
      var initialFocusHolder = this.getPositionInParentElement(visibleFacetsDropdownId, event.target);
      var isFocusAtBeginning = initialFocusHolder === 0;
      var isFocusAtEnd = initialFocusHolder === this.getNumberOfSiblings(visibleFacetsDropdownId);
      var nextFocusIndex = 0;
      event.stopPropagation();

      if (keyPressed === 38) {
        if (isFocusAtBeginning) {
          nextFocusIndex = this.getNumberOfSiblings(visibleFacetsDropdownId);
        } else {
          nextFocusIndex = initialFocusHolder - 1;
        }
        this.setFacetFocus(visibleFacetsDropdownId, nextFocusIndex);
      } else if (keyPressed === 40) {
        if (isFocusAtEnd) {
          nextFocusIndex = 0;
        } else {
          nextFocusIndex = initialFocusHolder + 1;
        }
        this.setFacetFocus(visibleFacetsDropdownId, nextFocusIndex);
      }

      if (keyPressed === 13) {
        this.handleFacetEnterPress(event);
      }

      this.facetRefinementMenuHandler(event);
    }
  }, {
    key: "onFacetParentKeyUp",
    value: function onFacetParentKeyUp(event) {
      var keyPressed = event.keyCode;
      var triggerKeys = [13, 38, 40];
      var shouldFocusOnChild = triggerKeys.indexOf(keyPressed) != -1;
      var wasInputEmpty = event.target.value.length === 1;
      var wasSpacebarPressed = keyPressed === 32;
      var relatedDropdownId = event.target.dataset.filterid;

      if (shouldFocusOnChild || wasSpacebarPressed && wasInputEmpty) {
        this.handleFacetInputClick();
        this.setFacetFocusFromParent(relatedDropdownId, 0);
      }

      this.facetRefinementMenuHandler(event);
    }
  }, {
    key: "getNumberOfSiblings",
    value: function getNumberOfSiblings(id) {
      var facetDropdownItems = this.getRelatedFacetGroupElements(id);
      return facetDropdownItems.length - 1;
    }
  }, {
    key: "getPositionInParentElement",
    value: function getPositionInParentElement(id, node) {
      var facetDropdownItems = this.getRelatedFacetGroupElements(id);
      return Array.prototype.indexOf.call(facetDropdownItems, node);
    }
  }, {
    key: "setFacetFocus",
    value: function setFacetFocus(element, index) {
      var nextElementToFocus = this.getAdjacentFacetGroupElement(element, index);
      if (typeof nextElementToFocus != 'undefined') {
        nextElementToFocus.focus();
      }
    }
  }, {
    key: "setFacetFocusFromParent",
    value: function setFacetFocusFromParent(id, index) {
      var activeFacets = this.getRelatedFacetGroupElements(id);
      if (typeof activeFacets[index] != 'undefined') {
        activeFacets[index].focus();
      }
    }
  }, {
    key: "getAdjacentFacetGroupElement",
    value: function getAdjacentFacetGroupElement(id, index) {
      var facetDropdownItems = this.getRelatedFacetGroupElements(id);
      return facetDropdownItems[index];
    }
  }, {
    key: "getRelatedFacetGroupElements",
    value: function getRelatedFacetGroupElements(id) {
      return document.getElementById(id).getElementsByTagName('li');
    }
  }, {
    key: "handleFacetEnterPress",
    value: function handleFacetEnterPress(event) {
      event.target.getElementsByClassName('search-facets__toggle')[0].click();
    }
  }, {
    key: "disableArrowKeyScrolling",
    value: function disableArrowKeyScrolling() {
      var arrowKeyHandler = function arrowKeyHandler(e) {
        if ([13, 37, 38, 39, 40].indexOf(e.keyCode) > -1) {
          e.preventDefault();
        }
      };
      window.addEventListener("keydown", arrowKeyHandler, false);
    }
  }, {
    key: "restoreArrowKeyScrolling",
    value: function restoreArrowKeyScrolling() {
      if (typeof arrowKeyHandler != 'undefined') {
        window.removeEventListener("keydown", arrowKeyHandler, false);
      }
    }
  }, {
    key: "notNull",
    value: function notNull(object) {
      return !!object;
    }
  }, {
    key: "isMatch",
    value: function isMatch(input) {
      return input.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) >= 0;
    }
  }, {
    key: "applyHighlighting",
    value: function applyHighlighting(text) {
      var highlightedText,
          strIndex = text.toLowerCase().indexOf(this.state.searchTerm.toLowerCase());

      if (strIndex >= 0) {
        var substrLength = this.state.searchTerm.length,
            titleLength = text.length,
            endSpan = "</span>",
            startSpan = "<span class='highlighted'>";

        highlightedText = text.slice(0, strIndex) + startSpan + text.slice(strIndex, strIndex + substrLength) + endSpan + text.slice(strIndex + substrLength, titleLength);
      }

      return highlightedText;
    }
  }, {
    key: "getFilteredFacets",
    value: function getFilteredFacets(searchTerm) {
      if (!this.state.searchTerm) {
        return this.props.group;
      }

      var facets = Object.assign({}, this.props.group);

      facets.values = this.mapChildFacetMatch(facets.values);
      facets.childGroups = this.mapFacetMatches(facets.childGroups);

      var hasChildGroupMatch = !!facets.childGroups && facets.childGroups.length;
      var hasValuesMatch = !!facets.values && facets.values.length;

      if (hasChildGroupMatch || hasValuesMatch || this.isMatch(facets.label)) {
        return facets;
      } else {
        // facet filter has no results
        var emptyFacets = Object.assign({ emptyFacets: true }, facets);
        return emptyFacets;
      }
    }
  }, {
    key: "mapFacetMatches",
    value: function mapFacetMatches(facetCollection) {
      var _this2 = this;

      if (!facetCollection) {
        return;
      }
      return facetCollection.map(function (facet) {
        return _this2.mapFacetOrChildMatch(facet, "label", "values");
      }).filter(this.notNull);
    }
  }, {
    key: "mapChildFacetMatch",
    value: function mapChildFacetMatch(childFacet) {
      var _this3 = this;

      if (!childFacet) {
        return;
      }
      return childFacet.map(function (facet) {
        return _this3.mapFacetOrChildMatch(facet, "name", "childValues");
      }).filter(this.notNull);
    }
  }, {
    key: "mapFacetOrChildMatch",
    value: function mapFacetOrChildMatch(childFacet, nameField, childrenField) {
      var newChildFacets = Object.assign({}, childFacet);
      newChildFacets[childrenField] = this.mapChildFacetMatch(newChildFacets[childrenField]);

      if (newChildFacets[childrenField] && newChildFacets[childrenField].length) {
        if (this.isMatch(newChildFacets[nameField])) {
          newChildFacets = Object.assign({ displayName: this.applyHighlighting(newChildFacets[nameField]) }, newChildFacets);
        }
        return newChildFacets;
      }

      if (newChildFacets[nameField]) {
        if (this.isMatch(newChildFacets[nameField])) {
          newChildFacets = Object.assign({ displayName: this.applyHighlighting(newChildFacets[nameField]) }, newChildFacets);
          return newChildFacets;
        }
      }

      return null;
    }
  }, {
    key: "handleFacetFilterChange",
    value: function handleFacetFilterChange(e) {
      this.setState({ showFacetDropdown: true });
      this.setState({ searchTerm: e.target.value });
    }
  }, {
    key: "handleFacetInputClick",
    value: function handleFacetInputClick(e) {
      this.setState({ showFacetDropdown: true });
    }
  }, {
    key: "handleFacetDropdownClick",
    value: function handleFacetDropdownClick(e) {
      // toggle dropdown open or closed
      var shouldShowDropdown = this.state.showFacetDropdown ? false : true;
      this.setState({ showFacetDropdown: shouldShowDropdown });
    }

    // Handle closing dropdown when clicking outside

  }, {
    key: "mouseDownHandler",
    value: function mouseDownHandler(e) {
      this.setState({ facetGroupClicked: true });
    }
  }, {
    key: "mouseUpHandler",
    value: function mouseUpHandler(e) {
      this.setState({ facetGroupClicked: false });
      this.setState({ showFacetDropdown: false });
    }
  }, {
    key: "onClearGroup",
    value: function onClearGroup() {
      var group = this.props.group;
      this.props.handleClearGroup(group);
    }

    // Rendering

  }, {
    key: "renderValueItem",
    value: function renderValueItem(value, recursionLevel) {
      var _this4 = this;

      var childValues = value.childValues;
      var hasChildValues = !!childValues && childValues.length > 0;
      var isExpanded = this.valueIsExpanded(value);
      var renderChildValues = hasChildValues && isExpanded;
      var toggleClass = "search-facets__value-expand is-open";
      var labelClass = value.selected ? "search-facets__title search-facet__selected" : "search-facets__title";
      var valueID = value.id.replace(/ /g, '_');

      return _react2.default.createElement(
        "li",
        { key: value.id, className: "search-facets__group-value", tabIndex: "0", onFocus: this.disableArrowKeyScrolling(), onKeyUp: function onKeyUp(e) {
            return _this4.onFacetKeyUp(e);
          } },
        _react2.default.createElement("input", {
          className: "search-facets__toggle",
          checked: value.selected,
          "aria-controls": "search-results",
          "aria-selected": value.selected,
          id: value.id,
          onChange: function onChange(e) {
            return _this4.onFacetChange(e, value);
          },
          type: "checkbox" }),
        _react2.default.createElement("label", { htmlFor: value.id, className: labelClass, dangerouslySetInnerHTML: { __html: value.displayName ? value.displayName : value.name } }),
        hasChildValues && this.renderValues(childValues, recursionLevel + 1)
      );
    }
  }, {
    key: "renderFlatValues",
    value: function renderFlatValues(values) {
      var _this5 = this;

      var renderValue = function renderValue(value) {
        return _react2.default.createElement(
          "li",
          { key: value.id, tabIndex: "0" },
          _react2.default.createElement("input", { id: value.id, checked: value.selected, onChange: function onChange(e) {
              return _this5.onFacetChange(e, value);
            }, type: "checkbox" }),
          _react2.default.createElement(
            "label",
            { htmlFor: value.id },
            value.name,
            " (",
            value.count,
            ")"
          )
        );
      };

      return _react2.default.createElement(
        "ul",
        { className: "search-facets__group-values" },
        values.map(function (value) {
          return renderValue(value);
        })
      );
    }
  }, {
    key: "renderValues",
    value: function renderValues(values, recursionLevel) {
      var _this6 = this;

      var chunkedValues = void 0;
      if (recursionLevel === 0) {
        chunkedValues = this.chunkValues(values);
      } else {
        chunkedValues = [values, []];
      }

      var headValues = chunkedValues[0];
      var tailValues = chunkedValues[1];

      var stateClass = "search-facets__group-values is-level-" + recursionLevel;
      var shouldRenderTailValues = this.shouldRenderTailValues(tailValues);

      return _react2.default.createElement(
        "div",
        { className: "search-facets__values-wrapper" },
        _react2.default.createElement(
          "ul",
          { className: stateClass },
          headValues.map(function (val) {
            return _this6.renderValueItem(val, recursionLevel);
          })
        ),
        shouldRenderTailValues && _react2.default.createElement(
          "ul",
          { className: (0, _classnames2.default)(stateClass, "is-overflow") },
          tailValues.map(function (val) {
            return _this6.renderValueItem(val, recursionLevel);
          })
        )
      );
    }
  }, {
    key: "renderChildGroups",
    value: function renderChildGroups(group) {
      var _this7 = this;

      if (this.state.isGroupOpen && group.childGroups && group.childGroups.length) {

        return group.childGroups.map(function (childGroup) {
          return _react2.default.createElement(FacetGroup, { key: childGroup.id,
            isChildGroup: "true",
            group: childGroup,
            dupeSelected: false,
            handleFacetChange: _this7.props.handleFacetChange,
            updateSelectedFacets: _this7.props.updateSelectedFacets,
            handleClearGroup: _this7.props.handleClearGroup });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var dictionary = this.props.dictionary;

      var visibleFacets = this.getFilteredFacets(this.state.searchTerm);
      var isChildGroup = this.props.isChildGroup;
      var noResultsText = 'No results match "' + this.state.searchTerm + '"';
      var groupWrapperClass = this.state.showFacetDropdown ? "search-facets__group-wrapper search-facets__dropdown-active " : "search-facets__group-wrapper";
      var group = this.props.group;
      var selectedValues = (0, _facets.selectedFacetsFromGroup)(group);
      var showDupeSelected = selectedValues.length > 0 && this.props.dupeSelected;
      var dropdownID = visibleFacets.id + '_dropdown';
      var activeDescendant = this.state.activeDescendant;
      var isFacetVisible = !this.state.showFacetDropdown;

      return _react2.default.createElement(
        "div",
        { className: "search-facets__group", "aria-live": "polite", onMouseDown: function onMouseDown(e) {
            return _this8.mouseDownHandler(e);
          }, onMouseUp: function onMouseUp(e) {
            return _this8.mouseUpHandler(e);
          } },
        _react2.default.createElement(
          "div",
          { className: "search-facets__group-heading" },
          _react2.default.createElement("label", { className: "search-facets__group-title", htmlFor: visibleFacets.id, dangerouslySetInnerHTML: { __html: visibleFacets.label } }),
          !isChildGroup && _react2.default.createElement(
            "div",
            { className: "search-facets__input-wrapper" },
            _react2.default.createElement("input", { type: "text",
              placeholder: dictionary.facetGroupPlaceholder,
              onClick: function onClick(e) {
                return _this8.handleFacetInputClick(e);
              },
              onChange: function onChange(e) {
                return _this8.handleFacetFilterChange(e);
              },
              onKeyUp: function onKeyUp(e) {
                return _this8.onFacetParentKeyUp(e);
              },
              id: visibleFacets.id,
              role: "combobox",
              "aria-autocomplete": "list",
              "aria-expanded": "true",
              "aria-owns": dropdownID,
              "aria-activedescendant": activeDescendant,
              "aria-controls": "search-results",
              "aria-haspopup": "true",
              "data-filterid": dropdownID,
              className: "search-facets__text-field" }),
            _react2.default.createElement("span", { className: "search-facets__dropdown-toggle", onClick: function onClick(e) {
                return _this8.handleFacetDropdownClick(e);
              } })
          )
        ),
        !visibleFacets.emptyFacets && _react2.default.createElement(
          "div",
          { className: groupWrapperClass,
            id: dropdownID,
            "aria-hidden": isFacetVisible,
            ref: function ref(wrap) {
              return _this8.groupWrapper = wrap;
            } },
          _react2.default.createElement(
            "div",
            { className: "search-facets__group-body" },
            this.renderValues(visibleFacets.values, 0),
            this.renderChildGroups(visibleFacets)
          )
        ),
        visibleFacets.emptyFacets && _react2.default.createElement(
          "div",
          { className: "search-facets__no-results" },
          noResultsText
        )
      );
    }
  }]);

  return FacetGroup;
}(_react2.default.Component);

exports.default = FacetGroup;
var _React$PropTypes = _react2.default.PropTypes,
    func = _React$PropTypes.func,
    shape = _React$PropTypes.shape,
    bool = _React$PropTypes.bool,
    number = _React$PropTypes.number,
    string = _React$PropTypes.string,
    oneOfType = _React$PropTypes.oneOfType,
    arrayOf = _React$PropTypes.arrayOf;

// allows us to define propTypes recursively
// https://github.com/facebook/react/issues/5676

var lazyF = function lazyF(f) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return f().apply(undefined, args);
  };
};

var facetValueShape = shape({
  id: oneOfType([number, string]).isRequired,
  name: string.isRequired,
  count: number.isRequired,
  selected: bool.isRequired,
  childValues: arrayOf(lazyF(function () {
    return facetValueShape;
  }))
});

var facetGroupShape = shape({
  id: oneOfType([number, string]).isRequired,
  label: string.isRequired,
  values: arrayOf(facetValueShape).isRequired,
  childGroups: arrayOf(lazyF(function () {
    return facetGroupShape;
  }))
});

FacetGroup.propTypes = {
  isOpen: bool,
  dupeSelected: bool,
  handleFacetChange: func.isRequired,
  updateSelectedFacets: func.isRequired,
  handleClearGroup: func.isRequired,
  group: facetGroupShape,
  dictionary: shape({
    facetGroupPlaceholder: string,
    facetGroupNoResults: string
  })
};

FacetGroup.defaultProps = {
  isOpen: true,
  dupeSelected: true
};

},{"../redux/facets":58,"classnames":"classnames","ramda":"ramda","react":"react"}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _FacetGroup = require("./FacetGroup.jsx");

var _FacetGroup2 = _interopRequireDefault(_FacetGroup);

var _FacetTag = require("./FacetTag.jsx");

var _FacetTag2 = _interopRequireDefault(_FacetTag);

var _filterSlider = require("../filterSlider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FacetList = function (_React$Component) {
  _inherits(FacetList, _React$Component);

  function FacetList(props) {
    _classCallCheck(this, FacetList);

    var _this = _possibleConstructorReturn(this, (FacetList.__proto__ || Object.getPrototypeOf(FacetList)).call(this, props));

    _this.state = {
      selectedFacets: [],
      pageLoadFacetsSet: false // on page load populate selected facets
    };
    return _this;
  }

  _createClass(FacetList, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // only set initial selected facets on page load
      if (nextProps.facets.length > 0 && !this.state.pageLoadFacetsSet) {
        var selectedFacets = this.props.getSelectedFacets(nextProps.facets);
        this.setState({ selectedFacets: [].concat(this.state.selectedFacets, selectedFacets) });
        this.setState({ pageLoadFacetsSet: true });
      }
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this.setState({ selectedFacets: [] });
      this.props.handleClearAll();
    }
  }, {
    key: "hideFilters",
    value: function hideFilters() {
      (0, _filterSlider.closeFilters)();
    }

    // maintain a list of selected facets in order to preserve the order
    // of selection for facet tags

  }, {
    key: "updateSelectedFacets",
    value: function updateSelectedFacets(facet, toggle) {
      var newFacetList = this.state.selectedFacets;
      if (toggle) {
        this.setState({ selectedFacets: [].concat(newFacetList, facet) });
      } else {
        // remove the facet from the selectedFacets
        var filteredFacetList = newFacetList.filter(function (e) {
          return e.id !== facet.id;
        });
        this.setState({ selectedFacets: filteredFacetList });
      }
    }
  }, {
    key: "renderFacetGroups",
    value: function renderFacetGroups() {
      var _this2 = this;

      return this.props.facets.map(function (group, i) {
        var numOpenGroups = _this2.props.numOpenGroups;
        var isOpen = typeof numOpenGroups !== "undefined" && numOpenGroups !== null && i < numOpenGroups;
        var dictionary = _this2.props.dictionary;

        return _react2.default.createElement(_FacetGroup2.default, { key: group.id,
          handleFacetChange: _this2.props.handleFacetChange,
          updateSelectedFacets: _this2.updateSelectedFacets.bind(_this2),
          handleClearGroup: _this2.props.handleClearGroup,
          isOpen: isOpen,
          group: group,
          dictionary: dictionary });
      });
    }
  }, {
    key: "renderFacetTags",
    value: function renderFacetTags() {
      var _this3 = this;

      var allSelectedFacets = this.state.selectedFacets;
      return allSelectedFacets.map(function (facet) {
        return _react2.default.createElement(_FacetTag2.default, { key: facet.id, facet: facet, updateSelectedFacets: _this3.updateSelectedFacets.bind(_this3), handleFacetChange: _this3.props.handleFacetChange });
      });
    }
  }, {
    key: "renderClearAll",
    value: function renderClearAll() {
      var _this4 = this;

      var dictionary = this.props.dictionary;

      return _react2.default.createElement(
        "button",
        { className: "btn btn--primary", onClick: function onClick() {
            return _this4.clearAll();
          } },
        dictionary.facetsClearAllLabel
      );
    }
  }, {
    key: "render",
    value: function render() {
      var facetGroups = this.renderFacetGroups();
      var facetTags = this.renderFacetTags();
      var hasSelectedFacets = this.state.selectedFacets.length > 0 ? true : false;

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "search-full-width" },
          _react2.default.createElement(
            "div",
            { className: "search-facets" },
            facetGroups
          )
        ),
        hasSelectedFacets && _react2.default.createElement(
          "section",
          { className: "search-tags__container" },
          _react2.default.createElement(
            "div",
            { className: "search-tags" },
            facetTags
          ),
          this.renderClearAll()
        )
      );
    }
  }]);

  return FacetList;
}(_react2.default.Component);

exports.default = FacetList;
var _React$PropTypes = _react2.default.PropTypes,
    string = _React$PropTypes.string,
    arrayOf = _React$PropTypes.arrayOf,
    shape = _React$PropTypes.shape,
    number = _React$PropTypes.number,
    oneOfType = _React$PropTypes.oneOfType,
    func = _React$PropTypes.func;

FacetList.propTypes = {
  facets: arrayOf(shape({ id: oneOfType([number, string]) })),
  numOpenGroups: number,
  handleFacetChange: func.isRequired,
  handleClearGroup: func.isRequired,
  handleClearAll: func.isRequired,
  dictionary: shape({
    facetsClearAllLabel: string,
    facetGroupPlaceholder: string,
    facetGroupNoResults: string
  })
};

FacetList.defaultProps = {
  facets: [],
  numOpenGroups: null
};

},{"../filterSlider":53,"./FacetGroup.jsx":39,"./FacetTag.jsx":41,"react":"react"}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _facets = require("../redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_FACETS_SHOWN = 5;

var facetTag = function (_React$Component) {
  _inherits(facetTag, _React$Component);

  function facetTag(props) {
    _classCallCheck(this, facetTag);

    return _possibleConstructorReturn(this, (facetTag.__proto__ || Object.getPrototypeOf(facetTag)).call(this, props));
  }

  _createClass(facetTag, [{
    key: "handleTagClick",
    value: function handleTagClick(event, clickedFacet) {
      this.props.updateSelectedFacets(clickedFacet, false);
      this.props.handleFacetChange(clickedFacet.id, false);
    }
  }, {
    key: "handleTagEnter",
    value: function handleTagEnter(event, clickedFacet) {
      if (event.keyCode === 13) {
        handleTagClick(event, clickedFacet);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var facet = this.props.facet;

      return _react2.default.createElement(
        "div",
        { className: "search-tags__tag",
          tabIndex: "0",
          role: "button",
          onKeyUp: function onKeyUp(e) {
            return _this2.handleTagEnter(e, facet);
          },
          onClick: function onClick(e) {
            return _this2.handleTagClick(e, facet);
          } },
        facet.name
      );
    }
  }]);

  return facetTag;
}(_react2.default.Component);

exports.default = facetTag;
var _React$PropTypes = _react2.default.PropTypes,
    func = _React$PropTypes.func,
    shape = _React$PropTypes.shape,
    bool = _React$PropTypes.bool,
    number = _React$PropTypes.number,
    string = _React$PropTypes.string,
    oneOfType = _React$PropTypes.oneOfType,
    arrayOf = _React$PropTypes.arrayOf;

// allows us to define propTypes recursively
// https://github.com/facebook/react/issues/5676

var lazyF = function lazyF(f) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return f().apply(undefined, args);
  };
};

var facetTagShape = shape({
  id: oneOfType([number, string]).isRequired,
  name: string.isRequired,
  count: number.isRequired,
  selected: bool.isRequired,
  childValues: arrayOf(lazyF(function () {
    return facetTagShape;
  }))
});

facetTag.propTypes = {
  isOpen: bool,
  handleFacetChange: func.isRequired,
  updateSelectedFacets: func.isRequired,
  facet: facetTagShape
};

},{"../redux/facets":58,"classnames":"classnames","ramda":"ramda","react":"react"}],42:[function(require,module,exports){
arguments[4][4][0].apply(exports,arguments)
},{"./LoadingSpinner.jsx":43,"dup":4,"react":"react"}],43:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    "div",
    { className: "directory-results__spinner" },
    _react2.default.createElement("img", { src: window._ir + "svg-sprite/loading-squares" })
  );
};

},{"react":"react"}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _paging = require("../paging");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pagination = function Pagination(_ref) {
  var totalResults = _ref.totalResults,
      resultsPerPage = _ref.resultsPerPage,
      currentPage = _ref.currentPage,
      handlePageChange = _ref.handlePageChange;


  var block = (0, _paging.pageBlock)(totalResults, resultsPerPage, currentPage);
  var isLast = (0, _paging.isLastPage)(totalResults, resultsPerPage, currentPage);
  var isFirst = (0, _paging.isFirstPage)(currentPage);
  var lastPage = (0, _paging.totalPages)(totalResults, resultsPerPage);

  /* function getPage(label, value, isDisabled) {
    return (
      <li>
        <button
          className="pagination__item"
          type="button"
          onClick={() => onPageClick(value, isDisabled)}
          disabled={isDisabled}>{label}</button>
      </li>
    );
  } */

  function onPageClick(pageNum, isDisabled) {
    if (!isDisabled) {
      handlePageChange(pageNum);
    }
  }

  return _react2.default.createElement(
    "div",
    { className: "directory-results__pagination pagination" },
    _react2.default.createElement(
      "button",
      { type: "button", className: "pagination__jump pagination__jump--back", onClick: function onClick() {
          return onPageClick(currentPage - 1, isFirst);
        }, disabled: isFirst },
      "Back"
    ),
    _react2.default.createElement(
      "ul",
      { className: "pagination__list" },
      block.map(function (page) {
        return _react2.default.createElement(
          "li",
          { key: page.label },
          _react2.default.createElement(
            "button",
            {
              className: "pagination__item",
              type: "button",
              onClick: function onClick() {
                return onPageClick(page.num, page.current);
              },
              disabled: page.current },
            page.label
          )
        );
      })
    ),
    _react2.default.createElement(
      "button",
      { type: "button", className: "pagination__jump pagination__jump--next", onClick: function onClick() {
          return onPageClick(currentPage + 1, isLast);
        }, disabled: isLast },
      "Next"
    )
  );
};

var _React$PropTypes = _react2.default.PropTypes,
    number = _React$PropTypes.number,
    func = _React$PropTypes.func;


Pagination.propTypes = {
  totalResults: number.isRequired,
  resultsPerPage: number.isRequired,
  currentPage: number.isRequired,
  handlePageChange: func.isRequired
};

exports.default = Pagination;

},{"../paging":55,"react":"react"}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResultItem = function (_React$Component) {
  _inherits(ResultItem, _React$Component);

  function ResultItem(props) {
    _classCallCheck(this, ResultItem);

    var _this = _possibleConstructorReturn(this, (ResultItem.__proto__ || Object.getPrototypeOf(ResultItem)).call(this, props));

    _this.itemWrapper = null;
    _this.sectionName = null;
    _this.sections = [];
    _this.state = { sectionsBelow: [] };

    //https://facebook.github.io/react/docs/react-without-es6.html
    _this.handleResultSectionLayout = _this.handleResultSectionLayout.bind(_this);
    return _this;
  }

  _createClass(ResultItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.itemWrapper.className = this.itemWrapper.className + " is-visible";

      this.handleResultSectionLayout();

      window.addEventListener("resize", this.handleResultSectionLayout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleResultSectionLayout);
    }
  }, {
    key: "getSectionClasses",
    value: function getSectionClasses(key) {
      return (0, _classnames2.default)("directory-result__section", "directory-result__section--" + key, {
        'is-below': this.state.sectionsBelow.includes(key)
      });
    }
  }, {
    key: "handleResultSectionLayout",
    value: function handleResultSectionLayout() {
      var _this2 = this;

      var sectionsBelow = this.sections.map(function (_ref) {
        var key = _ref.key,
            el = _ref.el;

        if (el.offsetTop > _this2.sectionName.offsetTop) {
          return key;
        } else {
          return '';
        }
      });
      this.setState({
        sectionsBelow: sectionsBelow
      });
    }
  }, {
    key: "addSectionRef",
    value: function addSectionRef(key) {
      var _this3 = this;

      return function (el) {
        // https://facebook.github.io/react/docs/refs-and-the-dom.html
        // see caveats
        if (el !== null) {
          _this3.sections.push({ key: key, el: el });
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          profileUrl = _props.profileUrl,
          image = _props.image,
          name = _props.name,
          title = _props.title,
          department = _props.department,
          contactInfo = _props.contactInfo,
          researchAreas = _props.researchAreas;


      return _react2.default.createElement(
        "section",
        { className: "directory-result", ref: function ref(el) {
            return _this4.itemWrapper = el;
          } },
        _react2.default.createElement(
          "section",
          { className: "directory-result__section directory-result__section--name", ref: function ref(el) {
              return _this4.sectionName = el;
            } },
          image ? _react2.default.createElement("img", { src: image, alt: name, className: "directory-result__image" }) : _react2.default.createElement("img", { src: "/default", alt: name, className: "directory-result__image" }),
          _react2.default.createElement(
            "div",
            { className: "directory-result__name-wrapper" },
            profileUrl ? _react2.default.createElement(
              "h1",
              { className: "directory-result__name" },
              _react2.default.createElement(
                "a",
                { href: profileUrl },
                name
              )
            ) : _react2.default.createElement(
              "h1",
              { className: "directory-result__name" },
              name
            ),
            _react2.default.createElement(
              "div",
              { className: "directory-result__title" },
              title
            )
          )
        ),
        _react2.default.createElement(
          "section",
          { className: this.getSectionClasses("department"), ref: this.addSectionRef("department") },
          _react2.default.createElement(
            "h6",
            { className: "directory-result__section-header" },
            "Department"
          ),
          department.map(function (item, index) {
            return _react2.default.createElement(
              "span",
              { key: index },
              item
            );
          })
        ),
        _react2.default.createElement(
          "section",
          { className: this.getSectionClasses("contact"), ref: this.addSectionRef("contact") },
          _react2.default.createElement(
            "h6",
            { className: "directory-result__section-header" },
            "Contact"
          ),
          _react2.default.createElement(
            "ul",
            { className: "directory-result__contact-card" },
            contactInfo.email ? _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement(
                "a",
                { href: "mailto:" + contactInfo.email },
                contactInfo.email
              )
            ) : null,
            contactInfo.phone ? _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement(
                "a",
                { href: "tel:" + contactInfo.phone },
                contactInfo.phone
              )
            ) : null,
            contactInfo.building ? _react2.default.createElement(
              "li",
              null,
              contactInfo.building
            ) : null
          )
        ),
        _react2.default.createElement(
          "section",
          { className: this.getSectionClasses("research-areas"), ref: this.addSectionRef("research-areas") },
          _react2.default.createElement(
            "h6",
            { className: "directory-result__section-header" },
            "Research Areas"
          ),
          _react2.default.createElement(
            "ul",
            { className: "directory-result__research-areas" },
            researchAreas.map(function (item, index) {
              return _react2.default.createElement(
                "li",
                { key: item.label },
                _react2.default.createElement(
                  "a",
                  { href: item.href },
                  item.label
                )
              );
            })
          )
        )
      );
    }
  }]);

  return ResultItem;
}(_react2.default.Component);

exports.default = ResultItem;
var _React$PropTypes = _react2.default.PropTypes,
    arrayOf = _React$PropTypes.arrayOf,
    string = _React$PropTypes.string,
    object = _React$PropTypes.object;

ResultItem.propTypes = {
  profileUrl: string,
  image: string,
  name: string.isRequired,
  title: string.isRequired,
  department: arrayOf(string).isRequired,
  contactInfo: object,
  researchAreas: arrayOf(object).isRequired
};

},{"classnames":"classnames","react":"react"}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _paging = require("../paging");

var _filterSlider = require("../filterSlider");

var _ResultItem = require("./ResultItem.jsx");

var _ResultItem2 = _interopRequireDefault(_ResultItem);

var _LoadMore = require("./LoadMore.jsx");

var _LoadMore2 = _interopRequireDefault(_LoadMore);

var _LoadingSpinner = require("./LoadingSpinner.jsx");

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _SortBar = require("./SortBar.jsx");

var _SortBar2 = _interopRequireDefault(_SortBar);

var _SearchStatus = require("./SearchStatus.jsx");

var _SearchStatus2 = _interopRequireDefault(_SearchStatus);

var _Pagination = require("./Pagination.jsx");

var _Pagination2 = _interopRequireDefault(_Pagination);

var _resultsDisplay = require("../redux/resultsDisplay");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResultList = function ResultList(_ref) {
  var results = _ref.results,
      resultsDisplayStrategy = _ref.resultsDisplayStrategy,
      selectedFacets = _ref.selectedFacets,
      totalResults = _ref.totalResults,
      loading = _ref.loading,
      isFirstLoad = _ref.isFirstLoad,
      sorters = _ref.sorters,
      nextPage = _ref.nextPage,
      gotoPage = _ref.gotoPage,
      dismissFacet = _ref.dismissFacet,
      changeSort = _ref.changeSort,
      query = _ref.query,
      pagination = _ref.pagination,
      dictionary = _ref.dictionary,
      showMobileFacets = _ref.showMobileFacets;


  var isLast = (0, _paging.isLastPage)(totalResults, query.perPage, query.page);
  var shouldShowNoResults = results.length === 0 && !isFirstLoad;
  var shouldShowPager = totalResults > query.perPage;

  function showFilters() {
    (0, _filterSlider.openFilters)(); // DOM ops
    showMobileFacets(); // action creator
  }

  function wrapperClass() {
    var isRefreshing = loading && resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_REFRESH;
    var isAppending = loading && resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND;
    return (0, _classnames2.default)("directory-results", { "is-refreshing": isRefreshing, "is-appending": isAppending });
  }

  function resultsRange() {
    // Upper bound of visible results
    var ceiling = query.page * query.perPage;

    // Lower bound of visible results
    var floor = ceiling - query.perPage + 1;

    // make sure the ceiling does not exceed total results
    if (ceiling > totalResults) {
      ceiling = totalResults;
    }

    // if results are only one page, eschew the range entirely
    if (totalResults <= query.perPage) {
      return "" + totalResults;
    }

    // if we're using load more, we want to show only
    // the ceiling of results displayed
    if (resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND) {
      return "" + ceiling;
    }

    // otherwise, return the full range
    return floor + " - " + ceiling;
  }

  function renderPagingControl() {
    if (pagination) {
      return _react2.default.createElement(_Pagination2.default, {
        totalResults: totalResults,
        resultsPerPage: query.perPage,
        currentPage: query.page,
        handlePageChange: gotoPage });
    }

    if (!pagination && !isLast) {
      return _react2.default.createElement(_LoadMore2.default, { handleClick: nextPage, dictionary: dictionary, loading: loading });
    }
  }

  function renderFilterToggle() {
    /* return (
      <button type="button"
              className="directory-results__filter-open btn--primary"
              onClick={ () => showFilters() }>
        Filter Your Results
        <svg className="icon">
          <use xlinkhref="/assets/build/img/svg-sprite.svg#equalizer"></use>
        </svg>
      </button>
    ); */
  }

  return _react2.default.createElement(
    "section",
    { className: wrapperClass() },
    renderFilterToggle(),
    _react2.default.createElement(_SearchStatus2.default, {
      resultsRange: resultsRange(),
      totalResults: totalResults,
      keywords: query.q,
      selectedFacets: selectedFacets,
      handleFacetDismiss: dismissFacet
    }),
    _react2.default.createElement(_SortBar2.default, { sorters: sorters, handleSortClick: changeSort }),
    _react2.default.createElement(
      "div",
      { className: "directory-results__item-wrapper" },
      loading && _react2.default.createElement(
        "div",
        { className: "directory-results__loader" },
        _react2.default.createElement(_LoadingSpinner2.default, null)
      ),
      _react2.default.createElement(
        "div",
        { className: "directory-results__items" },
        shouldShowNoResults ? _react2.default.createElement(
          "p",
          null,
          "No results found to match your query."
        ) : null,
        results.map(function (item) {
          return _react2.default.createElement(_ResultItem2.default, _extends({ key: item.id }, item));
        })
      )
    ),
    shouldShowPager ? renderPagingControl() : null
  );
};

var _React$PropTypes = _react2.default.PropTypes,
    arrayOf = _React$PropTypes.arrayOf,
    string = _React$PropTypes.string,
    object = _React$PropTypes.object,
    func = _React$PropTypes.func,
    bool = _React$PropTypes.bool,
    number = _React$PropTypes.number,
    shape = _React$PropTypes.shape,
    oneOfType = _React$PropTypes.oneOfType;


ResultList.propTypes = {
  results: arrayOf(shape({
    id: oneOfType([number, string])
  })),
  resultsDisplayStrategy: number,
  selectedFacets: arrayOf(object).isRequired,
  totalResults: number.isRequired,
  sorters: arrayOf(shape({
    id: oneOfType([number, string]).isRequired,
    label: string.isRequired,
    value: string.isRequired,
    direction: oneOfType([bool, string]),
    isActive: bool.isRequired
  })),
  loading: bool,
  isFirstLoad: bool,
  nextPage: func,
  gotoPage: func,
  changeSort: func,
  showMobileFacets: func,
  dismissFacet: func,
  query: shape({
    q: string,
    sortBy: string,
    page: number,
    perPage: number,
    pageId: string
  }),
  pagination: bool,
  dictionary: object
};

ResultList.defaultProps = {
  selectedFacets: []
};

exports.default = ResultList;

},{"../filterSlider":53,"../paging":55,"../redux/resultsDisplay":59,"./LoadMore.jsx":42,"./LoadingSpinner.jsx":43,"./Pagination.jsx":44,"./ResultItem.jsx":45,"./SearchStatus.jsx":48,"./SortBar.jsx":49,"classnames":"classnames","react":"react"}],47:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _LoadingSpinner = require("./LoadingSpinner.jsx");

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchBox = function (_React$Component) {
  _inherits(SearchBox, _React$Component);

  function SearchBox(props) {
    _classCallCheck(this, SearchBox);

    var _this = _possibleConstructorReturn(this, (SearchBox.__proto__ || Object.getPrototypeOf(SearchBox)).call(this, props));

    _this.state = {
      initiatedLoad: false
    };
    return _this;
  }

  _createClass(SearchBox, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.loading) {
        this.setState({ initiatedLoad: false });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      event.preventDefault();
      this.props.handleEntry(this.keywordInput.value);
      this.setState({ initiatedLoad: true });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          dictionary = _props.dictionary,
          keywords = _props.keywords,
          loading = _props.loading;

      var shouldShowSpinner = this.state.initiatedLoad && loading;
      return _react2.default.createElement(
        "form",
        { className: "search-box", onSubmit: function onSubmit(e) {
            return _this2.handleSubmit(e);
          }, noValidate: true },
        _react2.default.createElement(
          "div",
          { className: "search-box__input" },
          _react2.default.createElement(
            "label",
            { htmlFor: "site-search", className: "u-visuallyhidden" },
            dictionary.searchBoxLabel
          ),
          _react2.default.createElement("input", { id: "site-search",
            type: "text",
            placeholder: dictionary.searchBoxPlaceholder,
            defaultValue: keywords || "",
            ref: function ref(input) {
              return _this2.keywordInput = input;
            }
          }),
          _react2.default.createElement(
            "div",
            { className: "search-box__loader" },
            shouldShowSpinner ? _react2.default.createElement(_LoadingSpinner2.default, null) : null
          ),
          _react2.default.createElement(
            "button",
            { type: "submit", className: "search-box__button" },
            _react2.default.createElement(
              "span",
              { className: "u-visuallyhidden" },
              "Submit Search"
            ),
            _react2.default.createElement(
              "svg",
              { className: "icon", role: "img", "aria-label": "maginfying glass icon" },
              _react2.default.createElement(
                "title",
                null,
                "magnifying glass icon"
              ),
              _react2.default.createElement("use", { xlinkhref: window._ir + "svg-sprite/search" })
            )
          )
        )
      );
    }
  }]);

  return SearchBox;
}(_react2.default.Component);

exports.default = SearchBox;
var _React$PropTypes = _react2.default.PropTypes,
    string = _React$PropTypes.string,
    func = _React$PropTypes.func,
    shape = _React$PropTypes.shape,
    bool = _React$PropTypes.bool;


SearchBox.propTypes = {
  keywords: string,
  handleEntry: func.isRequired,
  loading: bool,
  dictionary: shape({
    searchBoxPlaceholder: string,
    searchBoxLabel: string
  }).isRequired
};

},{"./LoadingSpinner.jsx":43,"react":"react"}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchStatus = function SearchStatus(_ref) {
  var resultsRange = _ref.resultsRange,
      totalResults = _ref.totalResults,
      keywords = _ref.keywords,
      selectedFacets = _ref.selectedFacets,
      handleFacetDismiss = _ref.handleFacetDismiss;


  var shouldRenderFacets = selectedFacets.length > 0;
  var shouldRenderKeywords = !!keywords;

  var onFacetClick = function onFacetClick(value) {
    handleFacetDismiss(value.id);
  };

  var resultLabel = totalResults === 1 ? "result" : "results";

  var renderSelectedFacets = function renderSelectedFacets() {
    return _react2.default.createElement(
      "div",
      { className: "directory-results__active-facets" },
      _react2.default.createElement(
        "span",
        null,
        "with filters"
      ),
      _react2.default.createElement(
        "ul",
        null,
        selectedFacets.map(function (value) {
          return _react2.default.createElement(
            "li",
            { key: value.id, className: "btn btn--secondary search-tags__tag" },
            _react2.default.createElement(
              "span",
              null,
              value.name
            ),
            _react2.default.createElement(
              "button",
              { onClick: function onClick() {
                  return onFacetClick(value);
                } },
              _react2.default.createElement(
                "svg",
                { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", version: "1.1", width: "17", height: "17", viewBox: "0 0 17 17" },
                _react2.default.createElement("path", { fill: "#424242", d: "M11.984,5.71739l-2.78261,2.78261l2.78261,2.78261l-0.70139,0.70139l-2.78261,-2.78261l-2.78261,2.78261l-0.70139,-0.70139l2.78261,-2.78261l-2.78261,-2.78261l0.70139,-0.70139l2.78261,2.78261l2.78261,-2.78261l0.70139,0.70139z" })
              )
            )
          );
        })
      )
    );
  };

  return _react2.default.createElement(
    "div",
    { className: "directory-results__status" },
    _react2.default.createElement(
      "strong",
      null,
      totalResults
    ),
    "\xA0",
    _react2.default.createElement(
      "span",
      null,
      resultLabel
    ),
    "\xA0",
    shouldRenderKeywords && _react2.default.createElement(
      "span",
      null,
      "for \"",
      keywords,
      "\"\xA0"
    ),
    shouldRenderFacets && renderSelectedFacets()
  );
};

var _React$PropTypes = _react2.default.PropTypes,
    string = _React$PropTypes.string,
    number = _React$PropTypes.number,
    object = _React$PropTypes.object,
    arrayOf = _React$PropTypes.arrayOf,
    func = _React$PropTypes.func;


SearchStatus.propTypes = {
  resultsRange: string.isRequired,
  totalResults: number.isRequired,
  keywords: string,
  selectedFacets: arrayOf(object).isRequired,
  handleFacetDismiss: func.isRequired
};

SearchStatus.defaultProps = {
  selectedFacets: []
};

exports.default = SearchStatus;

},{"react":"react"}],49:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activeSortAscClass(sorter) {
  return (0, _classnames2.default)({ "is-selected": sorter.isActive && sorter.direction === "asc" });
}

function activeSortDescClass(sorter) {
  return (0, _classnames2.default)({ "is-selected": sorter.isActive && sorter.direction === "desc" });
}

function activateOrToggleSorter(sorterId, sorters, handleSortClick) {
  var toggleDir = function toggleDir(dir) {
    if (!dir) {
      return null;
    } else {
      return dir === "asc" ? "desc" : "asc";
    }
  };

  // this is like a 'bookmark' to the direction property
  var dirLens = _ramda2.default.lensProp("direction");

  // each argument array supplies a condition predicate, and an action
  // 1) if clicked sorter and active, toggle the sort direction
  // 2) if clicked sorter and not active, make active
  // 3) if not clicked sorter, and active, make inactive
  // 4) all other cases, do nothing
  var adjustSorters = _ramda2.default.cond([[_ramda2.default.whereEq({ id: sorterId, isActive: true }), _ramda2.default.over(dirLens, toggleDir)], [_ramda2.default.whereEq({ id: sorterId, isActive: false }), _ramda2.default.assoc("isActive", true)], [_ramda2.default.whereEq({ isActive: true }), _ramda2.default.assoc("isActive", false)], [_ramda2.default.T, _ramda2.default.identity]]);

  var newSorters = _ramda2.default.map(adjustSorters, sorters);
  handleSortClick(newSorters);
}

var SortBar = function SortBar(_ref) {
  var sorters = _ref.sorters,
      handleSortClick = _ref.handleSortClick;


  return _react2.default.createElement(
    "div",
    { className: "directory-results__sort-bar" },
    _react2.default.createElement(
      "ul",
      null,
      _react2.default.createElement(
        "li",
        { className: "directory-results__sort-title" },
        "Sort By:"
      ),
      sorters.map(function (sorter) {
        var uniqueClass = "directory-results__sorter--" + sorter.label.split(' ').join('-').toLowerCase();
        var sorterClass = (0, _classnames2.default)("directory-results__sorter", uniqueClass, { "is-active": sorter.isActive }, { "is-label-only": sorter.labelOnly });
        return _react2.default.createElement(
          "li",
          {
            key: sorter.id,
            className: sorterClass,
            onClick: function onClick() {
              return !sorter.labelOnly ? activateOrToggleSorter(sorter.id, sorters, handleSortClick) : '';
            } },
          sorter.direction && _react2.default.createElement(
            "span",
            { className: "directory-results__sort-dir" },
            _react2.default.createElement(
              "button",
              { type: "button", className: activeSortAscClass(sorter) },
              _react2.default.createElement(
                "svg",
                { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", version: "1.1", width: "24", height: "24", viewBox: "0 0 24 24" },
                _react2.default.createElement("path", { fill: "#424242", d: "M6.984 14.016l5.016-5.016 5.016 5.016h-10.031z" })
              )
            ),
            _react2.default.createElement(
              "button",
              { type: "button", className: activeSortDescClass(sorter) },
              _react2.default.createElement(
                "svg",
                { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", version: "1.1", width: "24", height: "24", viewBox: "0 0 24 24" },
                _react2.default.createElement("path", { fill: "#424242", d: "M6.984 9.984h10.031l-5.016 5.016z" })
              )
            )
          ),
          _react2.default.createElement(
            "span",
            { className: "directory-results__sort-label" },
            sorter.label
          )
        );
      })
    )
  );
};

var _React$PropTypes = _react2.default.PropTypes,
    shape = _React$PropTypes.shape,
    func = _React$PropTypes.func,
    number = _React$PropTypes.number,
    string = _React$PropTypes.string,
    bool = _React$PropTypes.bool,
    oneOfType = _React$PropTypes.oneOfType,
    arrayOf = _React$PropTypes.arrayOf;


SortBar.propTypes = {
  sorters: arrayOf(shape({
    id: oneOfType([number, string]).isRequired,
    label: string.isRequired,
    value: string.isRequired,
    direction: oneOfType([bool, string]),
    isActive: bool.isRequired,
    labelOnly: string.isRequired
  })).isRequired,
  dictionary: shape({
    sortByLabel: string
  }),
  handleSortClick: func.isRequired
};

exports.default = SortBar;

},{"classnames":"classnames","ramda":"ramda","react":"react"}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require("react-redux");

var _FacetList = require("../components/FacetList.jsx");

var _FacetList2 = _interopRequireDefault(_FacetList);

var _search = require("../redux/search/search.actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    title: state.dictionary.facetsTitle,
    facets: state.facets,
    numOpenGroups: state.numOpenGroups,
    mobileFacetsShown: state.mobileFacetsShown,
    getSelectedFacets: _search.getSelectedFacets,
    dictionary: state.dictionary
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleFacetChange: function handleFacetChange(facetId, facetValue) {
      dispatch((0, _search.loadFacetChange)(facetId, facetValue));
    },

    handleClearGroup: function handleClearGroup(group) {
      dispatch((0, _search.loadClearFacetGroup)(group));
    },

    handleClearAll: function handleClearAll() {
      dispatch((0, _search.loadClearAllFacets)());
    },

    hideMobileFacets: function hideMobileFacets() {
      dispatch(_search.hideMobileFacets);
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FacetList2.default);

},{"../components/FacetList.jsx":40,"../redux/search/search.actions":62,"react-redux":"react-redux"}],51:[function(require,module,exports){
arguments[4][14][0].apply(exports,arguments)
},{"../components/SearchBox.jsx":47,"../redux/search/search.actions":62,"dup":14,"react-redux":"react-redux"}],52:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require("react-redux");

var _ResultList = require("../components/ResultList.jsx");

var _ResultList2 = _interopRequireDefault(_ResultList);

var _search = require("../redux/search/search.actions");

var _facets = require("../redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    results: state.results,
    resultsDisplayStrategy: state.resultsDisplayStrategy,
    selectedFacets: (0, _facets.allSelectedFacets)(state.facets),
    totalResults: state.totalResults,
    loading: state.loading,
    isFirstLoad: state.isFirstLoad,
    sorters: state.sorters,
    query: state.query,
    pagination: state.pagination,
    dictionary: state.dictionary
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    nextPage: function nextPage() {
      dispatch((0, _search.loadNextPage)());
    },
    changeSort: function changeSort(sorters) {
      dispatch((0, _search.loadNewSort)(sorters));
    },
    gotoPage: function gotoPage(pageNum) {
      dispatch((0, _search.loadNewPage)(pageNum));
    },
    dismissFacet: function dismissFacet(facetId) {
      dispatch((0, _search.loadFacetChange)(facetId, false));
    },
    showMobileFacets: function showMobileFacets() {
      dispatch((0, _search.showMobileFacets)());
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ResultList2.default);

},{"../components/ResultList.jsx":46,"../redux/facets":58,"../redux/search/search.actions":62,"react-redux":"react-redux"}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openFilters = openFilters;
exports.closeFilters = closeFilters;
exports.setFiltersOpenDirection = setFiltersOpenDirection;
exports.manageContainerWhitespace = manageContainerWhitespace;
// Open/Close for mobile sliding of filter bar.
// Involves working with elements outside the
// scope of React components, so logic kept here.

function openFilters() {
  // Note - this depends on page state outside of the React app
  var filters = filtersWrapper();
  if (filters && !filtersAreOpen(filters)) {
    filters.classList.add("is-open");
  }
}

function closeFilters() {
  var filters = filtersWrapper();
  if (filters) {
    filters.classList.remove("is-open");
  }
}

function setFiltersOpenDirection() {
  var direction = "is-right";
  var filters = filtersWrapper();

  if (filters) {
    var sibling = filters.closest(".container__col").nextElementSibling;
    if (sibling && sibling.className.indexOf("container__col") >= 0) {
      direction = "is-left";
    }
  }

  filters.classList.add(direction);
}

// when the facet column is 'lifted' absolutely from the container
// it leaves behind an empty stacked container with a bottom margin
// we want to remove that margin -- but only if facets are the
// only components in the column
function manageContainerWhitespace() {
  var parent = filtersWrapper().closest(".container__col");
  var col = parent;
  if (parent.children.item(0).classList.contains("container__inner")) {
    parent = parent.children.item(0);
  }

  // cast from HTMLCollection to Array
  var children = Array.from(parent.children);
  var childCount = children.reduce(function (count, child) {
    if (!child.classList.contains("search__facets-wrapper")) {
      count = count + 1;
    }

    return count;
  }, 0);

  if (childCount === 0) {
    // remove the margin on the parent column
    col.style.marginBottom = 0;
  }
}

function filtersWrapper() {
  return document.querySelector(".search__facets-wrapper");
}

function filtersAreOpen(filtersWrapper) {
  return filtersWrapper.classList.contains("is-open");
}

},{}],54:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initDirectoryApp = initDirectoryApp;

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxThunk = require("redux-thunk");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactRedux = require("react-redux");

var _rootReducer = require("./redux/rootReducer");

var _rootReducer2 = _interopRequireDefault(_rootReducer);

var _search = require("./redux/search/search.reducer");

var _search2 = require("./redux/search/search.actions");

var _configureStore = require("./redux/configureStore");

var _configureStore2 = _interopRequireDefault(_configureStore);

var _createRoutingMiddleware = require("./redux/createRoutingMiddleware");

var _createRoutingMiddleware2 = _interopRequireDefault(_createRoutingMiddleware);

var _routing = require("./redux/routing");

var _resultsDisplay = require("./redux/resultsDisplay");

var _ResultsContainer = require("./containers/ResultsContainer.jsx");

var _ResultsContainer2 = _interopRequireDefault(_ResultsContainer);

var _QueryContainer = require("./containers/QueryContainer.jsx");

var _QueryContainer2 = _interopRequireDefault(_QueryContainer);

var _FacetsContainer = require("./containers/FacetsContainer.jsx");

var _FacetsContainer2 = _interopRequireDefault(_FacetsContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// the mount nodes are the elements we want to include
// as part of the search app
function initDirectoryApp(mountNodes) {

  if (!mountNodes.length) {
    return;
  }
  console.log('mountNodes', mountNodes);
  // extract the searchId from the mountNodes
  // while also checking mountNodes share same id
  var searchId = mountNodes.reduce(function (id, node) {
    var nodeId = (0, _jquery2.default)(node).data("searchId");
    // if id is null, we want to set it
    // with the first node's value
    if (id === null) {
      return nodeId;
    }
    // if node id does not equal current
    // id value, it's invalid and return undefined
    if (id !== nodeId) {
      return;
    }

    return id;
  }, null);

  // if we have an invalid or non-matching id, raise an error
  if (!searchId) {
    throw new Error("Could not initialize Thread search app. searchId was either not present, or provided mount nodes did not share the same searchId");
  }

  // define the canonical inital state of our redux store here
  // including some value taken from the data-attrs of the
  // mount node.
  var config = window.drexelCOESearchConfigs.find(function (c) {
    return c.searchId === searchId;
  });
  if (!config) {
    throw new Error("Could not initialize Thread search app instance with id of \"" + searchId + "\". Configuration data not found.");
  }

  // create a starting state object,
  // which includes and intitial state
  // from individual reducers
  var initialState = _ramda2.default.merge(_search.initialState, {
    url: config.url,
    pagination: config.pagination,
    resultsDisplayStrategy: config.pagination ? _resultsDisplay.RESULTS_DISPLAY_REFRESH : _resultsDisplay.RESULTS_DISPLAY_APPEND,
    sorters: config.sorters,
    dictionary: config.dictionary,
    numOpenGroups: config.numOpenGroups,
    query: _ramda2.default.merge(_search.initialState.query, {
      pageId: config.pageId
    }),
    initialFacets: config.preSelectedFacets
  });

  // determine if we want to load all page results in our cold load
  var doLoadAllPages = initialState.resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND && initialState.isFirstLoad;

  initialState = _ramda2.default.merge(initialState, {
    query: _ramda2.default.merge(initialState.query, {
      loadAllPages: doLoadAllPages
    })
  });

  var routingMiddleware = (0, _createRoutingMiddleware2.default)(_routing.mapStateToUrl, _routing.handleUrlChange);
  var store = (0, _configureStore2.default)(_rootReducer2.default, initialState, [_reduxThunk2.default, routingMiddleware]);

  store.dispatch((0, _search2.loadResults)());

  mountNodes.forEach(function (node) {
    if (node.className.indexOf("js-search-query") > -1) {
      _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_QueryContainer2.default, null)
      ), node);
    }

    if (node.className.indexOf("js-search-results") > -1) {
      _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_ResultsContainer2.default, null)
      ), node);
    }

    if (node.className.indexOf("js-search-facets") > -1) {
      _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_FacetsContainer2.default, null)
      ), node);
    }
  });
}

},{"./containers/FacetsContainer.jsx":50,"./containers/QueryContainer.jsx":51,"./containers/ResultsContainer.jsx":52,"./redux/configureStore":56,"./redux/createRoutingMiddleware":57,"./redux/resultsDisplay":59,"./redux/rootReducer":60,"./redux/routing":61,"./redux/search/search.actions":62,"./redux/search/search.reducer":63,"jquery":"jquery","ramda":"ramda","react":"react","react-dom":"react-dom","react-redux":"react-redux","redux-thunk":"redux-thunk"}],55:[function(require,module,exports){
arguments[4][18][0].apply(exports,arguments)
},{"dup":18,"ramda":"ramda"}],56:[function(require,module,exports){
arguments[4][19][0].apply(exports,arguments)
},{"dup":19,"redux":"redux"}],57:[function(require,module,exports){
arguments[4][20][0].apply(exports,arguments)
},{"dup":20,"urijs":"urijs"}],58:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allFacetValuesFromGroup = allFacetValuesFromGroup;
exports.selectedFacetsByGroup = selectedFacetsByGroup;
exports.selectedFacetIdsByGroup = selectedFacetIdsByGroup;
exports.selectedFacetsFromValues = selectedFacetsFromValues;
exports.selectedFacetsFromGroup = selectedFacetsFromGroup;
exports.allSelectedFacets = allSelectedFacets;
exports.groupHasSelectedChildren = groupHasSelectedChildren;
exports.valueHasSelectedChildren = valueHasSelectedChildren;
exports.valuesWithSelectedChildren = valuesWithSelectedChildren;
exports.pathFromValueId = pathFromValueId;
exports.setSelectedOnFacetValues = setSelectedOnFacetValues;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function allFacetValuesFromGroup(group) {
  var allValues = [];

  var grabAllValues = function grabAllValues(value) {
    allValues.push(value);
    if (value.childValues.length > 0) {
      value.childValues.forEach(function (cv) {
        return grabAllValues(cv);
      });
    }
  };

  group.values.forEach(function (value) {
    return grabAllValues(value);
  });

  if (group.hasOwnProperty("childGroups")) {
    group.childGroups.forEach(function (childGroup) {
      childGroup.values.forEach(function (value) {
        return grabAllValues(value);
      });
    });
  }

  return allValues;
}

// Returns an object with arrays of selected facet value objects, using
// their root group name as a key
function selectedFacetsByGroup(facets) {
  var facetsByGroup = {};
  facets.forEach(function (group) {
    var selectedFacets = selectedFacetsFromGroup(group);
    if (selectedFacets.length) {
      facetsByGroup[group.id] = selectedFacetsFromGroup(group);
    }
  });

  return facetsByGroup;
}

// Returns an object with arrays of selected facet ids, using
// their root group name as a key
function selectedFacetIdsByGroup(facets) {
  var selectedFacets = selectedFacetsByGroup(facets);
  Object.keys(selectedFacets).forEach(function (k) {
    selectedFacets[k] = selectedFacets[k].map(function (f) {
      return f.id;
    });
  });

  return selectedFacets;
}

// Given an array of facet value objects, return an
// a flat array of selected facet value object, including
// selected child values.
function selectedFacetsFromValues(values) {
  var selected = values.filter(function (v) {
    return v.selected === true;
  });
  values.forEach(function (value) {
    if (value.hasOwnProperty("childValues")) {
      selected = selected.concat(selectedFacetsFromValues(value.childValues));
    }
  });

  return selected;
}

// Given a facet group, return a flat array of selected
// facets value object, including child groups and all child values.
function selectedFacetsFromGroup(group) {
  var selected = selectedFacetsFromValues(group.values);
  if (group.hasOwnProperty("childGroups")) {
    group.childGroups.forEach(function (childGroup) {
      selected = selected.concat(selectedFacetsFromGroup(childGroup));
    });
  }

  return selected;
}

function allSelectedFacets(facets) {
  return facets.reduce(function (all, group) {
    return all.concat(selectedFacetsFromGroup(group));
  }, []);
}

function groupHasSelectedChildren(group) {
  return selectedFacetsFromGroup(group).length > 0;
}

function valueHasSelectedChildren(value) {
  // does not include selection state of group itself
  var selectedChildren = [];
  if (value.hasOwnProperty("childValues")) {
    selectedChildren = selectedFacetsFromValues(value.childValues);
  }

  return selectedChildren.length > 0;
}

// An array of values who have a child value
// selected. Does not require the value itself
// be selected.
function valuesWithSelectedChildren(group) {
  var all = allFacetValuesFromGroup(group);
  return all.reduce(function (hasSelected, value) {
    if (valueHasSelectedChildren(value)) {
      hasSelected.push(value);
    }

    return hasSelected;
  }, []);
}

// Returns an array of object path segments that
// resolves to the facet value object in the
// provided facets state object. This is useful
// when needing to make immutable changes using
// R.assocPath or R.lensPath

// TODO: This performs acceptably for now
// but is definitely not optimal for very large data sets.
// Should consider a different approach to setting deeply nested data.
function pathFromValueId(valueId, facets) {

  // First, flatten the facets object into k,v pairs of properties
  // and stringified "path" keys. Then use the paths to
  // lookup the facet value
  var facetLookup = _ramda2.default.invertObj((0, _util.flattenObj)(facets));
  var delimitedPath = facetLookup[valueId];

  // Our paths are in format "a.b.0.c', so convert into ["a", "b", 0, "c"].
  // Then pop off the last path segment so it points to the entire value
  // object, instead of just the id.
  var pathArr = delimitedPath.split(".");
  pathArr.pop();

  // Finally, ensure numerical "keys" are properly cast to Numbers
  // or else Ramda will treat them as object keys and
  // convert arrays to objects when using assocPath or lens methods.
  pathArr = pathArr.map(function (segment) {
    var numberified = parseInt(segment, 10);
    return isNaN(numberified) ? segment : numberified;
  });

  return pathArr;
}

// Return a new facets object with the give facet value selected
function setSelectedOnFacetValues(valueIds, selected, facets) {
  // Lookup the path for the given facetId
  // and change it using assocPath

  if (!valueIds.length) {
    return facets;
  }

  var paths = valueIds.map(function (valueId) {
    var pathArr = pathFromValueId(valueId, facets);
    // add "selected" to the end of our path
    pathArr.push("selected");

    return pathArr;
  });

  return paths.reduce(function (newFacets, path) {
    // NOTE: Using numerical indexes in assocPath only work in
    // Ramda 0.23.0+
    return _ramda2.default.assocPath(path, selected, newFacets);
  }, facets);
}

},{"../util":65,"ramda":"ramda"}],59:[function(require,module,exports){
arguments[4][22][0].apply(exports,arguments)
},{"dup":22}],60:[function(require,module,exports){
arguments[4][23][0].apply(exports,arguments)
},{"./search/search.reducer":63,"dup":23}],61:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToUrl = mapStateToUrl;
exports.handleUrlChange = handleUrlChange;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _search = require("./search/search.actions");

var _facets = require("./facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToUrl(state) {
    // choose which parts of the query
    // state we want exposed in the
    // url query string
    var exposedParams = ["q", "sortBy", "sortOrder", "page"];

    // if we're in pagination mode,
    // we also want to expose the page num
    if (state.pagination) {
        exposedParams.push("page");
    }

    var selectedFacets = void 0;
    if (state.facets.length > 0) {
        selectedFacets = (0, _facets.selectedFacetIdsByGroup)(state.facets);

        // turn selected facets ids into comma delimited string
        Object.keys(selectedFacets).forEach(function (k) {
            selectedFacets[k] = selectedFacets[k].join(",");
        });
    } else {
        selectedFacets = state.preSelectedFacets;
    }

    return _ramda2.default.merge(selectedFacets, _ramda2.default.pick(exposedParams, state.query));
}

function handleUrlChange(urlParams, store) {
    // a list of parameters that we know aren't
    // bound to facet group names
    var nonFacetParams = ["q", "sortOrder", "sortBy", "page"];

    var facets = store.getState().facets;

    // separate out the param types
    var queryParams = _ramda2.default.pick(nonFacetParams, urlParams);
    var facetParams = _ramda2.default.omit(nonFacetParams, urlParams);

    var newFacets = [];
    var preSelectedFacets = {};
    if (facets.length > 0) {
        // get an array of valueIds from { group: valueId, valueId } format
        // and set them to selected. If
        newFacets = (0, _facets.setSelectedOnFacetValues)(_ramda2.default.values(facetParams), true, facets);
    } else {
        // if facets is empty, it's because we haven't gotten
        // a response yet. So we'll also pass an object of
        // pre-selected facets we can pass to the query
        // Note: transforms comma-delimited strings to array

        preSelectedFacets = _ramda2.default.map(_ramda2.default.split(","), facetParams);
    }

    // Anytime we expose a number value to the query
    // string it will be sent back to us as a string.
    // Make sure to cast it back to a number here.
    var castToInt = _ramda2.default.curry(parseInt)(_ramda2.default.__, 10);
    queryParams = _ramda2.default.evolve({
        page: castToInt
    }, queryParams);

    // Provide a new facets object.
    // First, just grab all facets ids from
    // from the facetParams
    //pickIds = R.values();

    return store.dispatch((0, _search.mergeQueryParams)(queryParams, newFacets, preSelectedFacets));
}

},{"./facets":58,"./search/search.actions":62,"ramda":"ramda"}],62:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOGGLE_MOBILE_FACETS = exports.CLEAR_ALL_FACETS = exports.CLEAR_FACET_GROUP = exports.FACET_CHANGED = exports.SORT_CHANGED = exports.CHANGE_PAGE = exports.INCREMENT_PAGE = exports.KEYWORDS_CHANGED = exports.MERGE_QUERY_PARAMS = exports.LOAD_RESULTS_SUCCESS = exports.LOAD_RESULTS_FAIL = exports.LOAD_RESULTS_START = undefined;
exports.mergeQueryParams = mergeQueryParams;
exports.loadStart = loadStart;
exports.loadSuccess = loadSuccess;
exports.loadFail = loadFail;
exports.sortChanged = sortChanged;
exports.incrementPage = incrementPage;
exports.changePage = changePage;
exports.keywordsChanged = keywordsChanged;
exports.facetChanged = facetChanged;
exports.clearFacetGroup = clearFacetGroup;
exports.clearAllFacets = clearAllFacets;
exports.showMobileFacets = showMobileFacets;
exports.hideMobileFacets = hideMobileFacets;
exports.loadResults = loadResults;
exports.loadNextPage = loadNextPage;
exports.loadNewPage = loadNewPage;
exports.loadNewSort = loadNewSort;
exports.loadNewKeywords = loadNewKeywords;
exports.loadFacetChange = loadFacetChange;
exports.loadClearFacetGroup = loadClearFacetGroup;
exports.loadClearAllFacets = loadClearAllFacets;
exports.getSelectedFacets = getSelectedFacets;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _service = require("../service");

var _resultsDisplay = require("../resultsDisplay");

var _facets = require("../facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Action Names
var LOAD_RESULTS_START = exports.LOAD_RESULTS_START = "SEARCH/LOAD_RESULTS_START";
var LOAD_RESULTS_FAIL = exports.LOAD_RESULTS_FAIL = "SEARCH/LOAD_RESULTS_FAIL";
var LOAD_RESULTS_SUCCESS = exports.LOAD_RESULTS_SUCCESS = "SEARCH/LOAD_RESULTS_SUCCESS";
var MERGE_QUERY_PARAMS = exports.MERGE_QUERY_PARAMS = "SEARCH/MERGE_QUERY_PARAMS";
var KEYWORDS_CHANGED = exports.KEYWORDS_CHANGED = "SEARCH/KEYWORDS_CHANGED";
var INCREMENT_PAGE = exports.INCREMENT_PAGE = "SEARCH/INCREMENT_PAGE";
var CHANGE_PAGE = exports.CHANGE_PAGE = "SEARCH/CHANGE_PAGE";
var SORT_CHANGED = exports.SORT_CHANGED = "SEARCH/SORT_CHANGED";
var FACET_CHANGED = exports.FACET_CHANGED = "SEARCH/FACET_CHANGED";
var CLEAR_FACET_GROUP = exports.CLEAR_FACET_GROUP = "SEARCH/CLEAR_FACET_GROUP";
var CLEAR_ALL_FACETS = exports.CLEAR_ALL_FACETS = "SEARCH/CLEAR_ALL_FACETS";
var TOGGLE_MOBILE_FACETS = exports.TOGGLE_MOBILE_FACETS = "SEARCH/TOGGLE_MOBILE_FACETS";

// Single-dispatch Action Creators
function mergeQueryParams(params, facets, preSelectedFacets) {
  return {
    type: MERGE_QUERY_PARAMS,
    payload: { params: params, facets: facets, preSelectedFacets: preSelectedFacets }
  };
}

function loadStart() {
  return {
    type: LOAD_RESULTS_START,
    payload: null
  };
}

function loadSuccess(response, resultsDisplay) {
  return {
    type: LOAD_RESULTS_SUCCESS,
    payload: { response: response, resultsDisplay: resultsDisplay }
  };
}

function loadFail(err) {
  return {
    type: LOAD_RESULTS_FAIL,
    payload: err
  };
}

function sortChanged(sorters) {
  return {
    type: SORT_CHANGED,
    payload: sorters
  };
}

function incrementPage() {
  return {
    type: INCREMENT_PAGE,
    payload: null
  };
}

function changePage(pageNum) {
  return {
    type: CHANGE_PAGE,
    payload: pageNum
  };
}

function keywordsChanged(keywords) {
  return {
    type: KEYWORDS_CHANGED,
    payload: keywords
  };
}

function facetChanged(facetId, facetValue) {
  return {
    type: FACET_CHANGED,
    payload: { facetId: facetId, facetValue: facetValue }
  };
}

function clearFacetGroup(group) {
  return {
    type: CLEAR_FACET_GROUP,
    payload: group
  };
}

function clearAllFacets() {
  return {
    type: CLEAR_ALL_FACETS,
    payload: null
  };
}

function showMobileFacets() {
  return {
    type: TOGGLE_MOBILE_FACETS,
    payload: true
  };
}

function hideMobileFacets() {
  return {
    type: TOGGLE_MOBILE_FACETS,
    payload: false
  };
}

// Multi-dispatch Action Creators
// Note that multiple dispatches inside an
// action creator only work when using the
// redux-thunk middleware. These action
// creators MUST return a function.
// https://github.com/gaearon/redux-thunk

function loadResults() {
  var resultsDisplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _resultsDisplay.RESULTS_DISPLAY_APPEND;

  return function (dispatch, getState) {
    var state = getState();
    var url = state.url;

    // get our query params, and add any pre-selected facets we
    // might have
    var query = _ramda2.default.merge(state.query, state.preSelectedFacets);

    var facets = (0, _facets.selectedFacetIdsByGroup)(getState().facets);

    // merge with pre-selected facets
    _ramda2.default.merge(facets, state.preSelectedFacets);

    if (state.isFirstLoad && _ramda2.default.equals({}, state.preSelectedFacets)) {
      query = _ramda2.default.merge(query, state.initialFacets);
    }

    dispatch(loadStart());
    (0, _service.fetchSearchResults)(url, _ramda2.default.merge(query, facets)).then(function (response) {
      dispatch(loadSuccess(response, resultsDisplay));
    }).fail(function (error) {
      dispatch(loadFail(error));
    });
  };
}

function loadNextPage() {
  return function (dispatch) {
    dispatch(incrementPage());
    dispatch(loadResults());
  };
}

function loadNewPage(pageNum) {
  return function (dispatch) {
    dispatch(changePage(pageNum));
    dispatch(loadResults());
  };
}

function loadNewSort(sorters) {
  return function (dispatch) {
    dispatch(sortChanged(sorters));
    dispatch(loadResults());
  };
}

function loadNewKeywords(keywords) {
  return function (dispatch) {
    dispatch(keywordsChanged(keywords));
    dispatch(loadResults());
  };
}

function loadFacetChange(facetId, facetValue) {
  return function (dispatch) {
    dispatch(facetChanged(facetId, facetValue));
    dispatch(loadResults());
  };
}

function loadClearFacetGroup(group) {
  return function (dispatch) {
    dispatch(clearFacetGroup(group));
    dispatch(loadResults());
  };
}

function loadClearAllFacets() {
  return function (dispatch) {
    dispatch(clearAllFacets());
    dispatch(loadResults());
  };
}

function getSelectedFacets(facets) {
  return (0, _facets.allSelectedFacets)(facets);
}

},{"../facets":58,"../resultsDisplay":59,"../service":64,"ramda":"ramda"}],63:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _actionMap;

exports.default = searchReducer;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _service = require("../service");

var _facets = require("../facets");

var _resultsDisplay = require("../resultsDisplay");

var _search = require("./search.actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = {
  query: {
    q: null,
    sortBy: "relevance",
    sortOrder: "asc",
    page: 1,
    perPage: 10,
    pageId: "00000000-0000-0000-0000-000000000000",
    loadAllPages: true
  },
  url: null,
  errorMsg: null,
  loading: true,
  pagination: false,
  totalResults: 0,
  results: [],
  resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_APPEND,
  sorters: [],
  dictionary: {},
  facets: [],
  numOpenGroups: null,
  preSelectedFacets: {},
  isFirstLoad: true,
  mobileFacetsShown: false,
  initialFacets: {}
};

var actionMap = (_actionMap = {}, _defineProperty(_actionMap, _search.LOAD_RESULTS_START, loadStart), _defineProperty(_actionMap, _search.LOAD_RESULTS_SUCCESS, loadSuccess), _defineProperty(_actionMap, _search.LOAD_RESULTS_FAIL, loadError), _defineProperty(_actionMap, _search.SORT_CHANGED, updateSort), _defineProperty(_actionMap, _search.MERGE_QUERY_PARAMS, updateQueryParams), _defineProperty(_actionMap, _search.KEYWORDS_CHANGED, updateKeywords), _defineProperty(_actionMap, _search.INCREMENT_PAGE, incrementPage), _defineProperty(_actionMap, _search.CHANGE_PAGE, changePage), _defineProperty(_actionMap, _search.FACET_CHANGED, changeFacet), _defineProperty(_actionMap, _search.CLEAR_FACET_GROUP, clearFacetGroup), _defineProperty(_actionMap, _search.CLEAR_ALL_FACETS, clearAllFacets), _defineProperty(_actionMap, _search.TOGGLE_MOBILE_FACETS, toggleMobileFacets), _actionMap);

function searchReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var actionType = actionMap[action.type];
  return actionType ? actionType(state, action) : state;
}

function loadStart(state, action) {
  return _ramda2.default.merge(state, {
    loading: true
  });
}

function loadSuccess(state, action) {
  var response = action.payload.response;

  return _ramda2.default.merge((0, _service.mapResponseToState)(response, state), {
    loading: false,
    isFirstLoad: false,
    preSelectedFacets: {}
  });
}

function loadError(state, action) {
  return _ramda2.default.merge(state, { loading: false, errorMsg: action.payload });
}

function updateSort(state, action) {
  var activeSorter = _ramda2.default.find(_ramda2.default.propEq("isActive", true), action.payload);

  return _ramda2.default.merge(state, {
    sorters: action.payload,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      sortBy: activeSorter.value,
      sortOrder: activeSorter.direction,
      page: 1
    })
  });
}

function updateQueryParams(state, action) {
  return _ramda2.default.merge(state, {
    query: _ramda2.default.merge(state.query, action.payload.params),
    facets: action.payload.facets,
    preSelectedFacets: action.payload.preSelectedFacets
  });
}

function incrementPage(state, action) {
  var pageNum = parseInt(state.query.page, 10) + 1;
  return _ramda2.default.merge(state, {
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_APPEND,
    query: _ramda2.default.merge(state.query, {
      page: pageNum
    })
  });
}

function changePage(state, action) {
  return _ramda2.default.merge(state, {
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      page: action.payload
    })
  });
}

function updateKeywords(state, action) {
  return _ramda2.default.merge(state, {
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      q: action.payload,
      page: 1
    })
  });
}

function changeFacet(state, action) {
  // We want to provide a new facet object to our
  // state with a single facet changed.

  // Lookup the path for the given facetId
  // and change it using assocPath
  var facetId = action.payload.facetId;
  var facetValue = action.payload.facetValue;
  var newFacets = (0, _facets.setSelectedOnFacetValues)([facetId], facetValue, state.facets);

  return _ramda2.default.merge(state, {
    facets: newFacets,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      page: 1
    })
  });
}

function clearFacetGroup(state, action) {
  var group = action.payload;
  var selectedFacetIds = (0, _facets.selectedFacetsFromGroup)(group).map(function (v) {
    return v.id;
  });
  var newFacets = (0, _facets.setSelectedOnFacetValues)(selectedFacetIds, false, state.facets);

  return _ramda2.default.merge(state, {
    facets: newFacets,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      page: 1
    })
  });
}

function clearAllFacets(state, action) {
  var facets = state.facets;
  var selectedFacetIds = facets.reduce(function (all, group) {
    return all.concat((0, _facets.selectedFacetsFromGroup)(group).map(function (v) {
      return v.id;
    }));
  }, []);

  var newFacets = (0, _facets.setSelectedOnFacetValues)(selectedFacetIds, false, facets);

  return _ramda2.default.merge(state, {
    facets: newFacets,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      page: 1
    })
  });
}

function toggleMobileFacets(state, action) {
  return _ramda2.default.merge({
    mobileFacetsShown: action.payload
  }, state);
}

},{"../facets":58,"../resultsDisplay":59,"../service":64,"./search.actions":62,"ramda":"ramda"}],64:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSearchResults = fetchSearchResults;
exports.mapResponseToState = mapResponseToState;

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _resultsDisplay = require("./resultsDisplay");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newResults = _ramda2.default.curry(function (newResults, oldResults, strategy) {
    return strategy === _resultsDisplay.RESULTS_DISPLAY_APPEND ? _ramda2.default.concat(oldResults, newResults) : newResults;
});

function fetchSearchResults(url, query) {
    return _jquery2.default.ajax({
        url: url,
        data: query
    });
}

function mapResponseToState(response, state) {
    var request = response.request;
    var castToInt = _ramda2.default.curry(parseInt)(_ramda2.default.__, 10);
    return _ramda2.default.evolve({
        totalResults: function totalResults() {
            return parseInt(response.totalResults, 10);
        },
        results: newResults(response.results, _ramda2.default.__, state.resultsDisplayStrategy),
        facets: function facets() {
            return response.facets;
        },
        query: _ramda2.default.merge(_ramda2.default.__, {
            pageId: request.pageId,
            page: castToInt(request.page),
            perPage: castToInt(request.perPage),
            sortOrder: request.sortOrder,
            loadAllPages: false
        })
    }, state);
}

},{"./resultsDisplay":59,"jquery":"jquery","ramda":"ramda"}],65:[function(require,module,exports){
arguments[4][28][0].apply(exports,arguments)
},{"dup":28,"ramda":"ramda"}],66:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _facets = require("../redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_FACETS_SHOWN = 5;

var FacetGroup = function (_React$Component) {
  _inherits(FacetGroup, _React$Component);

  function FacetGroup(props) {
    _classCallCheck(this, FacetGroup);

    var _this = _possibleConstructorReturn(this, (FacetGroup.__proto__ || Object.getPrototypeOf(FacetGroup)).call(this, props));

    _this.state = {
      isGroupOpen: true,
      isGroupExpanded: false,
      valuesExpanded: [],
      searchTerm: "",
      facetGroupClicked: false
    };

    _this.pageClickHandler = _this.pageClickHandler.bind(_this);
    return _this;
  }

  // Lifecycle

  _createClass(FacetGroup, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // if group is closed, but has selected
      // values, open it
      var group = this.props.group;

      var selected = (0, _facets.selectedFacetsFromGroup)(group);
      var shouldOpen = this.state.isGroupOpen;
      if (selected.length > 0) {
        shouldOpen = true;
      }

      // Some facets will be expanded by default due to
      // children being pre-selected
      var hasSelected = (0, _facets.valuesWithSelectedChildren)(group);
      var selectedIds = hasSelected.map(function (v) {
        return v.id;
      });

      // similarly, if group's values or value children
      // are selected, auto-expand that group
      var tailValues = _ramda2.default.drop(MAX_FACETS_SHOWN, group.values);
      var shouldExpand = tailValues.reduce(function (should, tv) {
        if (tv.selected === true || selectedIds.indexOf(tv.id) >= 0) {
          should = true;
        }

        return should;
      }, false);

      window.addEventListener('mousedown', this.pageClickHandler, false);

      this.setState({
        isGroupOpen: shouldOpen,
        isGroupExpanded: true,
        valuesExpanded: selectedIds
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.pageClickHandler, false);
    }
  }, {
    key: "pageClickHandler",
    value: function pageClickHandler() {
      if (!this.state.facetGroupClicked) {
        this.setState({ showFacetDropdown: false });
      }
    }
  }, {
    key: "facetRefinementMenuHandler",
    value: function facetRefinementMenuHandler(event) {
      var wasEscapePressed = event.keyCode === 27;

      if (wasEscapePressed) {
        this.pageClickHandler();
        this.restoreArrowKeyScrolling();
      }
    }
  }, {
    key: "chunkValues",
    value: function chunkValues(values) {
      // divide the values into two arrays, the first for the Top X facets
      // and the second for overflow. If recursion level is over zero, put
      // all values in first array.
      return values.length > MAX_FACETS_SHOWN ? _ramda2.default.splitAt(MAX_FACETS_SHOWN, values) : [values, []];
    }
  }, {
    key: "showExpandButton",
    value: function showExpandButton() {
      return !this.state.isGroupExpanded;
    }
  }, {
    key: "shouldRenderTailValues",
    value: function shouldRenderTailValues(tailValues) {
      return this.state.isGroupExpanded && tailValues.length > 0;
    }
  }, {
    key: "shouldRenderChildGroups",
    value: function shouldRenderChildGroups(group) {
      return group.isOpen && !!group.childGroups && group.childGroups.length > 0;
    }
  }, {
    key: "toggleGroup",
    value: function toggleGroup() {
      var isOpen = !this.state.isGroupOpen;
      this.setState({ isGroupOpen: isOpen });
    }
  }, {
    key: "toggleExpand",
    value: function toggleExpand() {
      var isExpanded = !this.state.isGroupExpanded;
      this.setState({ isGroupExpanded: isExpanded });
    }
  }, {
    key: "toggleValueExpand",
    value: function toggleValueExpand(valueId) {
      // check if the valueId is in the list. Remove it
      // if found, add it if not.
      var valueIdx = this.state.valuesExpanded.indexOf(valueId);
      var selectedValues = valueIdx >= 0 ? _ramda2.default.remove(valueIdx, 1, this.state.valuesExpanded) : _ramda2.default.append(valueId, this.state.valuesExpanded);

      this.setState({ valuesExpanded: selectedValues });
    }
  }, {
    key: "valueIsExpanded",
    value: function valueIsExpanded(value) {
      return this.state.valuesExpanded.indexOf(value.id) >= 0;
    }
  }, {
    key: "onFacetChange",
    value: function onFacetChange(event, value) {
      var group = this.props.group;
      var selected = (0, _facets.selectedFacetsFromGroup)(group);
      var hasselections = selected.length > 0;

      if (hasselections) this.props.handleClearGroup(this.props.group);

      this.setState({ activeDescendant: event.target.id });
      this.props.updateSelectedFacets(value, event.target.checked);
      this.props.handleFacetChange(value.id, event.target.checked);

      //hack delay to prevent flashing
      if (hasselections) {
        var start = new Date().getTime();
        for (var i = 0; i < 1e7; i++) {
          if (new Date().getTime() - start > 700) {
            break;
          }
        }
      }

      this.restoreArrowKeyScrolling();
    }
  }, {
    key: "onFacetKeyUp",
    value: function onFacetKeyUp(event) {
      var visibleFacetsDropdownId = this.getFilteredFacets(this.state.searchTerm).id + '_dropdown';
      var keyPressed = event.keyCode;
      var initialFocusHolder = this.getPositionInParentElement(visibleFacetsDropdownId, event.target);
      var isFocusAtBeginning = initialFocusHolder === 0;
      var isFocusAtEnd = initialFocusHolder === this.getNumberOfSiblings(visibleFacetsDropdownId);
      var nextFocusIndex = 0;
      event.stopPropagation();

      if (keyPressed === 38) {
        if (isFocusAtBeginning) {
          nextFocusIndex = this.getNumberOfSiblings(visibleFacetsDropdownId);
        } else {
          nextFocusIndex = initialFocusHolder - 1;
        }
        this.setFacetFocus(visibleFacetsDropdownId, nextFocusIndex);
      } else if (keyPressed === 40) {
        if (isFocusAtEnd) {
          nextFocusIndex = 0;
        } else {
          nextFocusIndex = initialFocusHolder + 1;
        }
        this.setFacetFocus(visibleFacetsDropdownId, nextFocusIndex);
      }

      if (keyPressed === 13) {
        this.handleFacetEnterPress(event);
      }

      this.facetRefinementMenuHandler(event);
    }
  }, {
    key: "onFacetParentKeyUp",
    value: function onFacetParentKeyUp(event) {
      var keyPressed = event.keyCode;
      var triggerKeys = [13, 38, 40];
      var shouldFocusOnChild = triggerKeys.indexOf(keyPressed) != -1;
      var wasInputEmpty = event.target.value.length === 1;
      var wasSpacebarPressed = keyPressed === 32;
      var relatedDropdownId = event.target.dataset.filterid;

      if (shouldFocusOnChild || wasSpacebarPressed && wasInputEmpty) {
        this.handleFacetInputClick();
        this.setFacetFocusFromParent(relatedDropdownId, 0);
      }

      this.facetRefinementMenuHandler(event);
    }
  }, {
    key: "getNumberOfSiblings",
    value: function getNumberOfSiblings(id) {
      var facetDropdownItems = this.getRelatedFacetGroupElements(id);
      return facetDropdownItems.length - 1;
    }
  }, {
    key: "getPositionInParentElement",
    value: function getPositionInParentElement(id, node) {
      var facetDropdownItems = this.getRelatedFacetGroupElements(id);
      return Array.prototype.indexOf.call(facetDropdownItems, node);
    }
  }, {
    key: "setFacetFocus",
    value: function setFacetFocus(element, index) {
      var nextElementToFocus = this.getAdjacentFacetGroupElement(element, index);
      if (typeof nextElementToFocus != 'undefined') {
        nextElementToFocus.focus();
      }
    }
  }, {
    key: "setFacetFocusFromParent",
    value: function setFacetFocusFromParent(id, index) {
      var activeFacets = this.getRelatedFacetGroupElements(id);
      if (typeof activeFacets[index] != 'undefined') {
        activeFacets[index].focus();
      }
    }
  }, {
    key: "getAdjacentFacetGroupElement",
    value: function getAdjacentFacetGroupElement(id, index) {
      var facetDropdownItems = this.getRelatedFacetGroupElements(id);
      return facetDropdownItems[index];
    }
  }, {
    key: "getRelatedFacetGroupElements",
    value: function getRelatedFacetGroupElements(id) {
      return document.getElementById(id).getElementsByTagName('li');
    }
  }, {
    key: "handleFacetEnterPress",
    value: function handleFacetEnterPress(event) {
      event.target.getElementsByClassName('search-facets__toggle')[0].click();
    }
  }, {
    key: "disableArrowKeyScrolling",
    value: function disableArrowKeyScrolling() {
      var arrowKeyHandler = function arrowKeyHandler(e) {
        if ([13, 37, 38, 39, 40].indexOf(e.keyCode) > -1) {
          e.preventDefault();
        }
      };
      window.addEventListener("keydown", arrowKeyHandler, false);
    }
  }, {
    key: "restoreArrowKeyScrolling",
    value: function restoreArrowKeyScrolling() {
      if (typeof arrowKeyHandler != 'undefined') {
        window.removeEventListener("keydown", arrowKeyHandler, false);
      }
    }
  }, {
    key: "notNull",
    value: function notNull(object) {
      return !!object;
    }
  }, {
    key: "isMatch",
    value: function isMatch(input) {
      return input.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) >= 0;
    }
  }, {
    key: "applyHighlighting",
    value: function applyHighlighting(text) {
      var highlightedText,
          strIndex = text.toLowerCase().indexOf(this.state.searchTerm.toLowerCase());

      if (strIndex >= 0) {
        var substrLength = this.state.searchTerm.length,
            titleLength = text.length,
            endSpan = "</span>",
            startSpan = "<span class='highlighted'>";

        highlightedText = text.slice(0, strIndex) + startSpan + text.slice(strIndex, strIndex + substrLength) + endSpan + text.slice(strIndex + substrLength, titleLength);
      }

      return highlightedText;
    }
  }, {
    key: "getFilteredFacets",
    value: function getFilteredFacets(searchTerm) {
      if (!this.state.searchTerm) {
        return this.props.group;
      }

      var facets = Object.assign({}, this.props.group);

      facets.values = this.mapChildFacetMatch(facets.values);
      facets.childGroups = this.mapFacetMatches(facets.childGroups);

      var hasChildGroupMatch = !!facets.childGroups && facets.childGroups.length;
      var hasValuesMatch = !!facets.values && facets.values.length;

      if (hasChildGroupMatch || hasValuesMatch || this.isMatch(facets.label)) {
        return facets;
      } else {
        // facet filter has no results
        var emptyFacets = Object.assign({ emptyFacets: true }, facets);
        return emptyFacets;
      }
    }
  }, {
    key: "mapFacetMatches",
    value: function mapFacetMatches(facetCollection) {
      var _this2 = this;

      if (!facetCollection) {
        return;
      }
      return facetCollection.map(function (facet) {
        return _this2.mapFacetOrChildMatch(facet, "label", "values");
      }).filter(this.notNull);
    }
  }, {
    key: "mapChildFacetMatch",
    value: function mapChildFacetMatch(childFacet) {
      var _this3 = this;

      if (!childFacet) {
        return;
      }
      return childFacet.map(function (facet) {
        return _this3.mapFacetOrChildMatch(facet, "name", "childValues");
      }).filter(this.notNull);
    }
  }, {
    key: "mapFacetOrChildMatch",
    value: function mapFacetOrChildMatch(childFacet, nameField, childrenField) {
      var newChildFacets = Object.assign({}, childFacet);
      newChildFacets[childrenField] = this.mapChildFacetMatch(newChildFacets[childrenField]);

      if (newChildFacets[childrenField] && newChildFacets[childrenField].length) {
        if (this.isMatch(newChildFacets[nameField])) {
          newChildFacets = Object.assign({ displayName: this.applyHighlighting(newChildFacets[nameField]) }, newChildFacets);
        }
        return newChildFacets;
      }

      if (newChildFacets[nameField]) {
        if (this.isMatch(newChildFacets[nameField])) {
          newChildFacets = Object.assign({ displayName: this.applyHighlighting(newChildFacets[nameField]) }, newChildFacets);
          return newChildFacets;
        }
      }

      return null;
    }
  }, {
    key: "handleFacetFilterChange",
    value: function handleFacetFilterChange(e) {
      this.setState({ showFacetDropdown: true });
      this.setState({ searchTerm: e.target.value });
    }
  }, {
    key: "handleFacetInputClick",
    value: function handleFacetInputClick(e) {
      this.setState({ showFacetDropdown: true });
    }
  }, {
    key: "handleFacetDropdownClick",
    value: function handleFacetDropdownClick(e) {
      // toggle dropdown open or closed
      var shouldShowDropdown = this.state.showFacetDropdown ? false : true;
      this.setState({ showFacetDropdown: shouldShowDropdown });
    }

    // Handle closing dropdown when clicking outside

  }, {
    key: "mouseDownHandler",
    value: function mouseDownHandler(e) {
      this.setState({ facetGroupClicked: true });
    }
  }, {
    key: "mouseUpHandler",
    value: function mouseUpHandler(e) {
      this.setState({ facetGroupClicked: false });
      this.setState({ showFacetDropdown: false });
    }
  }, {
    key: "onClearGroup",
    value: function onClearGroup() {
      var group = this.props.group;
      this.props.handleClearGroup(group);
    }

    // Rendering

  }, {
    key: "renderValueItem",
    value: function renderValueItem(value, recursionLevel) {
      var _this4 = this;

      var childValues = value.childValues;
      var hasChildValues = !!childValues && childValues.length > 0;
      var isExpanded = this.valueIsExpanded(value);
      var renderChildValues = hasChildValues && isExpanded;
      var toggleClass = "search-facets__value-expand is-open";
      var labelClass = value.selected ? "search-facets__title search-facet__selected" : "search-facets__title";
      var valueID = value.id + "__staff";

      return _react2.default.createElement(
        "li",
        { key: valueID, className: "search-facets__group-value", tabIndex: "0", onFocus: this.disableArrowKeyScrolling(), onKeyUp: function onKeyUp(e) {
            return _this4.onFacetKeyUp(e);
          } },
        _react2.default.createElement("input", {
          className: "search-facets__toggle",
          checked: value.selected,
          "aria-controls": "search-results",
          "aria-selected": value.selected,
          id: valueID,
          onChange: function onChange(e) {
            return _this4.onFacetChange(e, value);
          },
          type: "checkbox" }),
        _react2.default.createElement("label", { htmlFor: valueID, className: labelClass, dangerouslySetInnerHTML: { __html: value.displayName ? value.displayName : value.name } }),
        hasChildValues && this.renderValues(childValues, recursionLevel + 1)
      );
    }
  }, {
    key: "renderFlatValues",
    value: function renderFlatValues(values) {
      var _this5 = this;

      var renderValue = function renderValue(value) {
        return _react2.default.createElement(
          "li",
          { key: valueID, tabIndex: "0" },
          _react2.default.createElement("input", { id: valueID, checked: value.selected, onChange: function onChange(e) {
              return _this5.onFacetChange(e, value);
            }, type: "checkbox" }),
          _react2.default.createElement(
            "label",
            { htmlFor: valueID },
            value.name,
            " (",
            value.count,
            ")"
          )
        );
      };

      return _react2.default.createElement(
        "ul",
        { className: "search-facets__group-values" },
        values.map(function (value) {
          return renderValue(value);
        })
      );
    }
  }, {
    key: "renderValues",
    value: function renderValues(values, recursionLevel) {
      var _this6 = this;

      var chunkedValues = void 0;
      if (recursionLevel === 0) {
        chunkedValues = this.chunkValues(values);
      } else {
        chunkedValues = [values, []];
      }

      var headValues = chunkedValues[0];
      var tailValues = chunkedValues[1];

      var stateClass = "search-facets__group-values is-level-" + recursionLevel;
      var shouldRenderTailValues = this.shouldRenderTailValues(tailValues);

      return _react2.default.createElement(
        "div",
        { className: "search-facets__values-wrapper" },
        _react2.default.createElement(
          "ul",
          { className: stateClass },
          headValues.map(function (val) {
            return _this6.renderValueItem(val, recursionLevel);
          })
        ),
        shouldRenderTailValues && _react2.default.createElement(
          "ul",
          { className: (0, _classnames2.default)(stateClass, "is-overflow") },
          tailValues.map(function (val) {
            return _this6.renderValueItem(val, recursionLevel);
          })
        )
      );
    }
  }, {
    key: "renderChildGroups",
    value: function renderChildGroups(group) {
      var _this7 = this;

      if (this.state.isGroupOpen && group.childGroups && group.childGroups.length) {

        return group.childGroups.map(function (childGroup) {
          return _react2.default.createElement(FacetGroup, { key: childGroup.id,
            isChildGroup: "true",
            group: childGroup,
            dupeSelected: false,
            handleFacetChange: _this7.props.handleFacetChange,
            updateSelectedFacets: _this7.props.updateSelectedFacets,
            handleClearGroup: _this7.props.handleClearGroup });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var dictionary = this.props.dictionary;

      var visibleFacets = this.getFilteredFacets(this.state.searchTerm);
      var isChildGroup = this.props.isChildGroup;
      var noResultsText = 'No results match "' + this.state.searchTerm + '"';
      var groupWrapperClass = this.state.showFacetDropdown ? "search-facets__group-wrapper search-facets__dropdown-active " : "search-facets__group-wrapper";
      var group = this.props.group;
      var selectedValues = (0, _facets.selectedFacetsFromGroup)(group);
      var showDupeSelected = selectedValues.length > 0 && this.props.dupeSelected;
      var inputID = visibleFacets.id + '--staff';
      var dropdownID = visibleFacets.id + '_dropdown--staff';
      var activeDescendant = this.state.activeDescendant;
      var isFacetVisible = !this.state.showFacetDropdown;

      return _react2.default.createElement(
        "div",
        { className: "search-facets__group", "aria-live": "polite", onMouseDown: function onMouseDown(e) {
            return _this8.mouseDownHandler(e);
          }, onMouseUp: function onMouseUp(e) {
            return _this8.mouseUpHandler(e);
          } },
        _react2.default.createElement(
          "div",
          { className: "search-facets__group-heading" },
          _react2.default.createElement("label", { className: "search-facets__group-title", htmlFor: visibleFacets.id, dangerouslySetInnerHTML: { __html: visibleFacets.label } }),
          !isChildGroup && _react2.default.createElement(
            "div",
            { className: "search-facets__input-wrapper" },
            _react2.default.createElement("input", { type: "text",
              placeholder: dictionary.facetGroupPlaceholder,
              onClick: function onClick(e) {
                return _this8.handleFacetInputClick(e);
              },
              onChange: function onChange(e) {
                return _this8.handleFacetFilterChange(e);
              },
              onKeyUp: function onKeyUp(e) {
                return _this8.onFacetParentKeyUp(e);
              },
              id: inputID,
              role: "combobox",
              "aria-autocomplete": "list",
              "aria-expanded": "true",
              "aria-owns": dropdownID,
              "aria-activedescendant": activeDescendant,
              "aria-controls": "search-results",
              "aria-haspopup": "true",
              "data-filterid": dropdownID,
              className: "search-facets__text-field" }),
            _react2.default.createElement("span", { className: "search-facets__dropdown-toggle", onClick: function onClick(e) {
                return _this8.handleFacetDropdownClick(e);
              } })
          )
        ),
        !visibleFacets.emptyFacets && _react2.default.createElement(
          "div",
          { className: groupWrapperClass,
            id: dropdownID,
            "aria-hidden": isFacetVisible,
            ref: function ref(wrap) {
              return _this8.groupWrapper = wrap;
            } },
          _react2.default.createElement(
            "div",
            { className: "search-facets__group-body" },
            this.renderValues(visibleFacets.values, 0),
            this.renderChildGroups(visibleFacets)
          )
        ),
        visibleFacets.emptyFacets && _react2.default.createElement(
          "div",
          { className: "search-facets__no-results" },
          noResultsText
        )
      );
    }
  }]);

  return FacetGroup;
}(_react2.default.Component);

exports.default = FacetGroup;
var _React$PropTypes = _react2.default.PropTypes,
    func = _React$PropTypes.func,
    shape = _React$PropTypes.shape,
    bool = _React$PropTypes.bool,
    number = _React$PropTypes.number,
    string = _React$PropTypes.string,
    oneOfType = _React$PropTypes.oneOfType,
    arrayOf = _React$PropTypes.arrayOf;

// allows us to define propTypes recursively
// https://github.com/facebook/react/issues/5676

var lazyF = function lazyF(f) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return f().apply(undefined, args);
  };
};

var facetValueShape = shape({
  id: oneOfType([number, string]).isRequired,
  name: string.isRequired,
  count: number.isRequired,
  selected: bool.isRequired,
  childValues: arrayOf(lazyF(function () {
    return facetValueShape;
  }))
});

var facetGroupShape = shape({
  id: oneOfType([number, string]).isRequired,
  label: string.isRequired,
  values: arrayOf(facetValueShape).isRequired,
  childGroups: arrayOf(lazyF(function () {
    return facetGroupShape;
  }))
});

FacetGroup.propTypes = {
  isOpen: bool,
  dupeSelected: bool,
  handleFacetChange: func.isRequired,
  updateSelectedFacets: func.isRequired,
  handleClearGroup: func.isRequired,
  group: facetGroupShape,
  dictionary: shape({
    facetGroupPlaceholder: string,
    facetGroupNoResults: string
  })
};

FacetGroup.defaultProps = {
  isOpen: true,
  dupeSelected: true
};

},{"../redux/facets":85,"classnames":"classnames","ramda":"ramda","react":"react"}],67:[function(require,module,exports){
arguments[4][40][0].apply(exports,arguments)
},{"../filterSlider":80,"./FacetGroup.jsx":66,"./FacetTag.jsx":68,"dup":40,"react":"react"}],68:[function(require,module,exports){
arguments[4][41][0].apply(exports,arguments)
},{"../redux/facets":85,"classnames":"classnames","dup":41,"ramda":"ramda","react":"react"}],69:[function(require,module,exports){
arguments[4][4][0].apply(exports,arguments)
},{"./LoadingSpinner.jsx":70,"dup":4,"react":"react"}],70:[function(require,module,exports){
arguments[4][43][0].apply(exports,arguments)
},{"dup":43,"react":"react"}],71:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _paging = require("../paging");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pagination = function Pagination(_ref) {
  var totalResults = _ref.totalResults,
      resultsPerPage = _ref.resultsPerPage,
      currentPage = _ref.currentPage,
      handlePageChange = _ref.handlePageChange;


  var block = (0, _paging.pageBlock)(totalResults, resultsPerPage, currentPage);
  var isLast = (0, _paging.isLastPage)(totalResults, resultsPerPage, currentPage);
  var isFirst = (0, _paging.isFirstPage)(currentPage);
  var lastPage = (0, _paging.totalPages)(totalResults, resultsPerPage);

  function getPage(label, value, isDisabled) {
    return _react2.default.createElement(
      "li",
      null,
      _react2.default.createElement(
        "button",
        {
          className: "pagination__item",
          key: label,
          type: "button",
          onClick: function onClick() {
            return onPageClick(value, isDisabled);
          },
          disabled: isDisabled },
        label
      )
    );
  }

  function onPageClick(pageNum, isDisabled) {
    if (!isDisabled) {
      handlePageChange(pageNum);
    }
  }

  return _react2.default.createElement(
    "div",
    { className: "directory-results__pagination pagination" },
    _react2.default.createElement(
      "button",
      { type: "button", className: "pagination__jump pagination__jump--back", onClick: function onClick() {
          return onPageClick(currentPage - 1, isFirst);
        }, disabled: isFirst },
      "Back"
    ),
    _react2.default.createElement(
      "ul",
      { className: "pagination__list" },
      block.map(function (page) {
        return _react2.default.createElement(
          "li",
          { key: page.label },
          _react2.default.createElement(
            "button",
            {
              className: "pagination__item",
              type: "button",
              onClick: function onClick() {
                return onPageClick(page.num, page.current);
              },
              disabled: page.current },
            page.label
          )
        );
      })
    ),
    _react2.default.createElement(
      "button",
      { type: "button", className: "pagination__jump pagination__jump--next", onClick: function onClick() {
          return onPageClick(currentPage + 1, isLast);
        }, disabled: isLast },
      "Next"
    )
  );
};

var _React$PropTypes = _react2.default.PropTypes,
    number = _React$PropTypes.number,
    func = _React$PropTypes.func;


Pagination.propTypes = {
  totalResults: number.isRequired,
  resultsPerPage: number.isRequired,
  currentPage: number.isRequired,
  handlePageChange: func.isRequired
};

exports.default = Pagination;

},{"../paging":82,"react":"react"}],72:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResultItem = function (_React$Component) {
  _inherits(ResultItem, _React$Component);

  function ResultItem(props) {
    _classCallCheck(this, ResultItem);

    var _this = _possibleConstructorReturn(this, (ResultItem.__proto__ || Object.getPrototypeOf(ResultItem)).call(this, props));

    _this.itemWrapper = null;
    _this.sectionName = null;
    _this.sections = [];
    _this.state = { sectionsBelow: [] };

    //https://facebook.github.io/react/docs/react-without-es6.html
    _this.handleResultSectionLayout = _this.handleResultSectionLayout.bind(_this);
    return _this;
  }

  _createClass(ResultItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.itemWrapper.className = this.itemWrapper.className + " is-visible";

      this.handleResultSectionLayout();

      window.addEventListener("resize", this.handleResultSectionLayout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleResultSectionLayout);
    }
  }, {
    key: "getSectionClasses",
    value: function getSectionClasses(key) {
      return (0, _classnames2.default)("directory-result__section", "directory-result__section--" + key, {
        'is-below': this.state.sectionsBelow.includes(key)
      });
    }
  }, {
    key: "handleResultSectionLayout",
    value: function handleResultSectionLayout() {
      var _this2 = this;

      var sectionsBelow = this.sections.map(function (_ref) {
        var key = _ref.key,
            el = _ref.el;

        if (el.offsetTop > _this2.sectionName.offsetTop) {
          return key;
        } else {
          return '';
        }
      });
      this.setState({
        sectionsBelow: sectionsBelow
      });
    }
  }, {
    key: "addSectionRef",
    value: function addSectionRef(key) {
      var _this3 = this;

      return function (el) {
        // https://facebook.github.io/react/docs/refs-and-the-dom.html
        // see caveats
        if (el !== null) {
          _this3.sections.push({ key: key, el: el });
        }
      };
    }
  }, {
    key: "titleMarkup",
    value: function titleMarkup() {
      return { __html: this.props.title };
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          profileUrl = _props.profileUrl,
          image = _props.image,
          name = _props.name,
          title = _props.title,
          department = _props.department,
          officeOrRoomNumber = _props.officeOrRoomNumber,
          email = _props.email,
          phone = _props.phone;


      return _react2.default.createElement(
        "section",
        { className: "directory-result", ref: function ref(el) {
            return _this4.itemWrapper = el;
          } },
        _react2.default.createElement(
          "section",
          { className: "directory-result__section directory-result__section--name", ref: function ref(el) {
              return _this4.sectionName = el;
            } },
          image ? _react2.default.createElement("img", { src: image, alt: name, className: "directory-result__image" }) : _react2.default.createElement("img", { src: "/default", alt: name, className: "directory-result__image" }),
          _react2.default.createElement(
            "div",
            { className: "directory-result__name-wrapper" },
            profileUrl ? _react2.default.createElement(
              "h1",
              { className: "directory-result__name" },
              _react2.default.createElement(
                "a",
                { href: profileUrl },
                name
              )
            ) : _react2.default.createElement(
              "h1",
              { className: "directory-result__name" },
              name
            ),
            _react2.default.createElement(
              "div",
              { className: "directory-result__title" },
              _react2.default.createElement("span", { dangerouslySetInnerHTML: this.titleMarkup() })
            )
          )
        ),
        _react2.default.createElement(
          "section",
          { className: this.getSectionClasses("department"), ref: this.addSectionRef("department") },
          _react2.default.createElement(
            "h6",
            { className: "directory-result__section-header" },
            "Department"
          ),
          department.map(function (item, index) {
            return _react2.default.createElement(
              "span",
              { key: index },
              item
            );
          })
        ),
        _react2.default.createElement(
          "section",
          { className: this.getSectionClasses("office-room"), ref: this.addSectionRef("office-room") },
          _react2.default.createElement(
            "h6",
            { className: "directory-result__section-header" },
            "Office/Room #"
          ),
          officeOrRoomNumber
        ),
        _react2.default.createElement(
          "section",
          { className: this.getSectionClasses("email-address"), ref: this.addSectionRef("email-address") },
          _react2.default.createElement(
            "h6",
            { className: "directory-result__section-header" },
            "Email Address"
          ),
          email ? _react2.default.createElement(
            "a",
            { href: "mailto:" + email },
            email
          ) : null
        ),
        _react2.default.createElement(
          "section",
          { className: this.getSectionClasses("phone-number"), ref: this.addSectionRef("phone-number") },
          _react2.default.createElement(
            "h6",
            { className: "directory-result__section-header" },
            "Phone Number"
          ),
          phone ? _react2.default.createElement(
            "a",
            { href: "tel:" + phone },
            phone
          ) : null
        )
      );
    }
  }]);

  return ResultItem;
}(_react2.default.Component);

exports.default = ResultItem;
var _React$PropTypes = _react2.default.PropTypes,
    arrayOf = _React$PropTypes.arrayOf,
    string = _React$PropTypes.string,
    object = _React$PropTypes.object;

ResultItem.propTypes = {
  profileUrl: string,
  image: string,
  name: string.isRequired,
  title: string.isRequired,
  department: arrayOf(string).isRequired,
  officeOrRoomNumber: string.isRequired,
  email: string.isRequired,
  phone: string.isRequired
};

},{"classnames":"classnames","react":"react"}],73:[function(require,module,exports){
arguments[4][46][0].apply(exports,arguments)
},{"../filterSlider":80,"../paging":82,"../redux/resultsDisplay":86,"./LoadMore.jsx":69,"./LoadingSpinner.jsx":70,"./Pagination.jsx":71,"./ResultItem.jsx":72,"./SearchStatus.jsx":75,"./SortBar.jsx":76,"classnames":"classnames","dup":46,"react":"react"}],74:[function(require,module,exports){
arguments[4][47][0].apply(exports,arguments)
},{"./LoadingSpinner.jsx":70,"dup":47,"react":"react"}],75:[function(require,module,exports){
arguments[4][48][0].apply(exports,arguments)
},{"dup":48,"react":"react"}],76:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activeSortAscClass(sorter) {
  return (0, _classnames2.default)({ "is-selected": sorter.isActive && sorter.direction === "asc" });
}

function activeSortDescClass(sorter) {
  return (0, _classnames2.default)({ "is-selected": sorter.isActive && sorter.direction === "desc" });
}

function activateOrToggleSorter(sorterId, sorters, handleSortClick) {
  var toggleDir = function toggleDir(dir) {
    if (!dir) {
      return null;
    } else {
      return dir === "asc" ? "desc" : "asc";
    }
  };

  // this is like a 'bookmark' to the direction property
  var dirLens = _ramda2.default.lensProp("direction");

  // each argument array supplies a condition predicate, and an action
  // 1) if clicked sorter and active, toggle the sort direction
  // 2) if clicked sorter and not active, make active
  // 3) if not clicked sorter, and active, make inactive
  // 4) all other cases, do nothing
  var adjustSorters = _ramda2.default.cond([[_ramda2.default.whereEq({ id: sorterId, isActive: true }), _ramda2.default.over(dirLens, toggleDir)], [_ramda2.default.whereEq({ id: sorterId, isActive: false }), _ramda2.default.assoc("isActive", true)], [_ramda2.default.whereEq({ isActive: true }), _ramda2.default.assoc("isActive", false)], [_ramda2.default.T, _ramda2.default.identity]]);

  var newSorters = _ramda2.default.map(adjustSorters, sorters);
  handleSortClick(newSorters);
}

var SortBar = function SortBar(_ref) {
  var sorters = _ref.sorters,
      handleSortClick = _ref.handleSortClick;


  return _react2.default.createElement(
    "div",
    { className: "directory-results__sort-bar" },
    _react2.default.createElement(
      "ul",
      null,
      _react2.default.createElement(
        "li",
        { className: "directory-results__sort-title" },
        "Sort By:"
      ),
      sorters.map(function (sorter) {
        var labelStr = sorter.label;
        var uniqueClass = "directory-results__sorter--" + labelStr.replace(' #', '').replace(/ |\//g, '-').toLowerCase();
        var sorterClass = (0, _classnames2.default)("directory-results__sorter", uniqueClass, { "is-active": sorter.isActive }, { "is-label-only": sorter.labelOnly });
        return _react2.default.createElement(
          "li",
          {
            key: sorter.id,
            className: sorterClass,
            onClick: function onClick() {
              return !sorter.labelOnly ? activateOrToggleSorter(sorter.id, sorters, handleSortClick) : '';
            } },
          sorter.direction && _react2.default.createElement(
            "span",
            { className: "directory-results__sort-dir" },
            _react2.default.createElement(
              "button",
              { type: "button", className: activeSortAscClass(sorter) },
              _react2.default.createElement(
                "svg",
                { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", version: "1.1", width: "24", height: "24", viewBox: "0 0 24 24" },
                _react2.default.createElement("path", { fill: "#424242", d: "M6.984 14.016l5.016-5.016 5.016 5.016h-10.031z" })
              )
            ),
            _react2.default.createElement(
              "button",
              { type: "button", className: activeSortDescClass(sorter) },
              _react2.default.createElement(
                "svg",
                { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", version: "1.1", width: "24", height: "24", viewBox: "0 0 24 24" },
                _react2.default.createElement("path", { fill: "#424242", d: "M6.984 9.984h10.031l-5.016 5.016z" })
              )
            )
          ),
          _react2.default.createElement(
            "span",
            { className: "directory-results__sort-label" },
            sorter.label
          )
        );
      })
    )
  );
};

var _React$PropTypes = _react2.default.PropTypes,
    shape = _React$PropTypes.shape,
    func = _React$PropTypes.func,
    number = _React$PropTypes.number,
    string = _React$PropTypes.string,
    bool = _React$PropTypes.bool,
    oneOfType = _React$PropTypes.oneOfType,
    arrayOf = _React$PropTypes.arrayOf;


SortBar.propTypes = {
  sorters: arrayOf(shape({
    id: oneOfType([number, string]).isRequired,
    label: string.isRequired,
    value: string.isRequired,
    direction: oneOfType([bool, string]),
    isActive: bool.isRequired,
    labelOnly: string.isRequired
  })).isRequired,
  dictionary: shape({
    sortByLabel: string
  }),
  handleSortClick: func.isRequired
};

exports.default = SortBar;

},{"classnames":"classnames","ramda":"ramda","react":"react"}],77:[function(require,module,exports){
arguments[4][50][0].apply(exports,arguments)
},{"../components/FacetList.jsx":67,"../redux/search/search.actions":89,"dup":50,"react-redux":"react-redux"}],78:[function(require,module,exports){
arguments[4][14][0].apply(exports,arguments)
},{"../components/SearchBox.jsx":74,"../redux/search/search.actions":89,"dup":14,"react-redux":"react-redux"}],79:[function(require,module,exports){
arguments[4][52][0].apply(exports,arguments)
},{"../components/ResultList.jsx":73,"../redux/facets":85,"../redux/search/search.actions":89,"dup":52,"react-redux":"react-redux"}],80:[function(require,module,exports){
arguments[4][53][0].apply(exports,arguments)
},{"dup":53}],81:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initStaffListingApp = initStaffListingApp;

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxThunk = require("redux-thunk");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactRedux = require("react-redux");

var _rootReducer = require("./redux/rootReducer");

var _rootReducer2 = _interopRequireDefault(_rootReducer);

var _search = require("./redux/search/search.reducer");

var _search2 = require("./redux/search/search.actions");

var _configureStore = require("./redux/configureStore");

var _configureStore2 = _interopRequireDefault(_configureStore);

var _createRoutingMiddleware = require("./redux/createRoutingMiddleware");

var _createRoutingMiddleware2 = _interopRequireDefault(_createRoutingMiddleware);

var _routing = require("./redux/routing");

var _resultsDisplay = require("./redux/resultsDisplay");

var _ResultsContainer = require("./containers/ResultsContainer.jsx");

var _ResultsContainer2 = _interopRequireDefault(_ResultsContainer);

var _QueryContainer = require("./containers/QueryContainer.jsx");

var _QueryContainer2 = _interopRequireDefault(_QueryContainer);

var _FacetsContainer = require("./containers/FacetsContainer.jsx");

var _FacetsContainer2 = _interopRequireDefault(_FacetsContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// the mount nodes are the elements we want to include
// as part of the search app
function initStaffListingApp(mountNodes) {

  if (!mountNodes.length) {
    return;
  }

  // extract the searchId from the mountNodes
  // while also checking mountNodes share same id
  var searchId = mountNodes.reduce(function (id, node) {
    var nodeId = (0, _jquery2.default)(node).data("searchId");
    // if id is null, we want to set it
    // with the first node's value
    if (id === null) {
      return nodeId;
    }
    // if node id does not equal current
    // id value, it's invalid and return undefined
    if (id !== nodeId) {
      return;
    }

    return id;
  }, null);

  // if we have an invalid or non-matching id, raise an error
  if (!searchId) {
    throw new Error("Could not initialize Thread search app. searchId was either not present, or provided mount nodes did not share the same searchId");
  }

  // define the canonical inital state of our redux store here
  // including some value taken from the data-attrs of the
  // mount node.
  var config = window.drexelCOESearchConfigs.find(function (c) {
    return c.searchId === searchId;
  });
  if (!config) {
    throw new Error("Could not initialize Thread search app instance with id of \"" + searchId + "\". Configuration data not found.");
  }

  // create a starting state object,
  // which includes and intitial state
  // from individual reducers
  var initialState = _ramda2.default.merge(_search.initialState, {
    url: config.url,
    pagination: config.pagination,
    resultsDisplayStrategy: config.pagination ? _resultsDisplay.RESULTS_DISPLAY_REFRESH : _resultsDisplay.RESULTS_DISPLAY_APPEND,
    sorters: config.sorters,
    dictionary: config.dictionary,
    numOpenGroups: config.numOpenGroups,
    query: _ramda2.default.merge(_search.initialState.query, {
      pageId: config.pageId
    })
  });

  // determine if we want to load all page results in our cold load
  var doLoadAllPages = initialState.resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND && initialState.isFirstLoad;

  initialState = _ramda2.default.merge(initialState, {
    query: _ramda2.default.merge(initialState.query, {
      loadAllPages: doLoadAllPages
    })
  });

  var routingMiddleware = (0, _createRoutingMiddleware2.default)(_routing.mapStateToUrl, _routing.handleUrlChange);
  var store = (0, _configureStore2.default)(_rootReducer2.default, initialState, [_reduxThunk2.default, routingMiddleware]);

  store.dispatch((0, _search2.loadResults)());

  mountNodes.forEach(function (node) {
    if (node.className.indexOf("js-search-query") > -1) {
      _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_QueryContainer2.default, null)
      ), node);
    }

    if (node.className.indexOf("js-search-results") > -1) {
      _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_ResultsContainer2.default, null)
      ), node);
    }

    if (node.className.indexOf("js-search-facets") > -1) {
      _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_FacetsContainer2.default, null)
      ), node);
    }
  });
}

},{"./containers/FacetsContainer.jsx":77,"./containers/QueryContainer.jsx":78,"./containers/ResultsContainer.jsx":79,"./redux/configureStore":83,"./redux/createRoutingMiddleware":84,"./redux/resultsDisplay":86,"./redux/rootReducer":87,"./redux/routing":88,"./redux/search/search.actions":89,"./redux/search/search.reducer":90,"jquery":"jquery","ramda":"ramda","react":"react","react-dom":"react-dom","react-redux":"react-redux","redux-thunk":"redux-thunk"}],82:[function(require,module,exports){
arguments[4][18][0].apply(exports,arguments)
},{"dup":18,"ramda":"ramda"}],83:[function(require,module,exports){
arguments[4][19][0].apply(exports,arguments)
},{"dup":19,"redux":"redux"}],84:[function(require,module,exports){
arguments[4][20][0].apply(exports,arguments)
},{"dup":20,"urijs":"urijs"}],85:[function(require,module,exports){
arguments[4][58][0].apply(exports,arguments)
},{"../util":92,"dup":58,"ramda":"ramda"}],86:[function(require,module,exports){
arguments[4][22][0].apply(exports,arguments)
},{"dup":22}],87:[function(require,module,exports){
arguments[4][23][0].apply(exports,arguments)
},{"./search/search.reducer":90,"dup":23}],88:[function(require,module,exports){
arguments[4][61][0].apply(exports,arguments)
},{"./facets":85,"./search/search.actions":89,"dup":61,"ramda":"ramda"}],89:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOGGLE_MOBILE_FACETS = exports.CLEAR_ALL_FACETS = exports.CLEAR_FACET_GROUP = exports.FACET_CHANGED = exports.SORT_CHANGED = exports.CHANGE_PAGE = exports.INCREMENT_PAGE = exports.KEYWORDS_CHANGED = exports.MERGE_QUERY_PARAMS = exports.LOAD_RESULTS_SUCCESS = exports.LOAD_RESULTS_FAIL = exports.LOAD_RESULTS_START = undefined;
exports.mergeQueryParams = mergeQueryParams;
exports.loadStart = loadStart;
exports.loadSuccess = loadSuccess;
exports.loadFail = loadFail;
exports.sortChanged = sortChanged;
exports.incrementPage = incrementPage;
exports.changePage = changePage;
exports.keywordsChanged = keywordsChanged;
exports.facetChanged = facetChanged;
exports.clearFacetGroup = clearFacetGroup;
exports.clearAllFacets = clearAllFacets;
exports.showMobileFacets = showMobileFacets;
exports.hideMobileFacets = hideMobileFacets;
exports.loadResults = loadResults;
exports.loadNextPage = loadNextPage;
exports.loadNewPage = loadNewPage;
exports.loadNewSort = loadNewSort;
exports.loadNewKeywords = loadNewKeywords;
exports.loadFacetChange = loadFacetChange;
exports.loadClearFacetGroup = loadClearFacetGroup;
exports.loadClearAllFacets = loadClearAllFacets;
exports.getSelectedFacets = getSelectedFacets;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _service = require("../service");

var _resultsDisplay = require("../resultsDisplay");

var _facets = require("../facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Action Names
var LOAD_RESULTS_START = exports.LOAD_RESULTS_START = "SEARCH/LOAD_RESULTS_START";
var LOAD_RESULTS_FAIL = exports.LOAD_RESULTS_FAIL = "SEARCH/LOAD_RESULTS_FAIL";
var LOAD_RESULTS_SUCCESS = exports.LOAD_RESULTS_SUCCESS = "SEARCH/LOAD_RESULTS_SUCCESS";
var MERGE_QUERY_PARAMS = exports.MERGE_QUERY_PARAMS = "SEARCH/MERGE_QUERY_PARAMS";
var KEYWORDS_CHANGED = exports.KEYWORDS_CHANGED = "SEARCH/KEYWORDS_CHANGED";
var INCREMENT_PAGE = exports.INCREMENT_PAGE = "SEARCH/INCREMENT_PAGE";
var CHANGE_PAGE = exports.CHANGE_PAGE = "SEARCH/CHANGE_PAGE";
var SORT_CHANGED = exports.SORT_CHANGED = "SEARCH/SORT_CHANGED";
var FACET_CHANGED = exports.FACET_CHANGED = "SEARCH/FACET_CHANGED";
var CLEAR_FACET_GROUP = exports.CLEAR_FACET_GROUP = "SEARCH/CLEAR_FACET_GROUP";
var CLEAR_ALL_FACETS = exports.CLEAR_ALL_FACETS = "SEARCH/CLEAR_ALL_FACETS";
var TOGGLE_MOBILE_FACETS = exports.TOGGLE_MOBILE_FACETS = "SEARCH/TOGGLE_MOBILE_FACETS";

// Single-dispatch Action Creators
function mergeQueryParams(params, facets, preSelectedFacets) {
  return {
    type: MERGE_QUERY_PARAMS,
    payload: { params: params, facets: facets, preSelectedFacets: preSelectedFacets }
  };
}

function loadStart() {
  return {
    type: LOAD_RESULTS_START,
    payload: null
  };
}

function loadSuccess(response, resultsDisplay) {
  return {
    type: LOAD_RESULTS_SUCCESS,
    payload: { response: response, resultsDisplay: resultsDisplay }
  };
}

function loadFail(err) {
  return {
    type: LOAD_RESULTS_FAIL,
    payload: err
  };
}

function sortChanged(sorters) {
  return {
    type: SORT_CHANGED,
    payload: sorters
  };
}

function incrementPage() {
  return {
    type: INCREMENT_PAGE,
    payload: null
  };
}

function changePage(pageNum) {
  return {
    type: CHANGE_PAGE,
    payload: pageNum
  };
}

function keywordsChanged(keywords) {
  return {
    type: KEYWORDS_CHANGED,
    payload: keywords
  };
}

function facetChanged(facetId, facetValue) {
  return {
    type: FACET_CHANGED,
    payload: { facetId: facetId, facetValue: facetValue }
  };
}

function clearFacetGroup(group) {
  return {
    type: CLEAR_FACET_GROUP,
    payload: group
  };
}

function clearAllFacets() {
  return {
    type: CLEAR_ALL_FACETS,
    payload: null
  };
}

function showMobileFacets() {
  return {
    type: TOGGLE_MOBILE_FACETS,
    payload: true
  };
}

function hideMobileFacets() {
  return {
    type: TOGGLE_MOBILE_FACETS,
    payload: false
  };
}

// Multi-dispatch Action Creators
// Note that multiple dispatches inside an
// action creator only work when using the
// redux-thunk middleware. These action
// creators MUST return a function.
// https://github.com/gaearon/redux-thunk

function loadResults() {
  var resultsDisplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _resultsDisplay.RESULTS_DISPLAY_APPEND;

  return function (dispatch, getState) {
    var state = getState();
    var url = state.url;

    // get our query params, and add any pre-selected facets we
    // might have
    var query = _ramda2.default.merge(state.query, state.preSelectedFacets);

    var facets = (0, _facets.selectedFacetIdsByGroup)(getState().facets);

    // merge with pre-selected facets
    _ramda2.default.merge(facets, state.preSelectedFacets);

    dispatch(loadStart());
    (0, _service.fetchSearchResults)(url, _ramda2.default.merge(query, facets)).then(function (response) {
      dispatch(loadSuccess(response, resultsDisplay));
    }).fail(function (error) {
      dispatch(loadFail(error));
    });
  };
}

function loadNextPage() {
  return function (dispatch) {
    dispatch(incrementPage());
    dispatch(loadResults());
  };
}

function loadNewPage(pageNum) {
  return function (dispatch) {
    dispatch(changePage(pageNum));
    dispatch(loadResults());
  };
}

function loadNewSort(sorters) {
  return function (dispatch) {
    dispatch(sortChanged(sorters));
    dispatch(loadResults());
  };
}

function loadNewKeywords(keywords) {
  return function (dispatch) {
    dispatch(keywordsChanged(keywords));
    dispatch(loadResults());
  };
}

function loadFacetChange(facetId, facetValue) {
  return function (dispatch) {
    dispatch(facetChanged(facetId, facetValue));
    dispatch(loadResults());
  };
}

function loadClearFacetGroup(group) {
  return function (dispatch) {
    dispatch(clearFacetGroup(group));
    dispatch(loadResults());
  };
}

function loadClearAllFacets() {
  return function (dispatch) {
    dispatch(clearAllFacets());
    dispatch(loadResults());
  };
}

function getSelectedFacets(facets) {
  return (0, _facets.allSelectedFacets)(facets);
}

},{"../facets":85,"../resultsDisplay":86,"../service":91,"ramda":"ramda"}],90:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _actionMap;

exports.default = searchReducer;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _service = require("../service");

var _facets = require("../facets");

var _resultsDisplay = require("../resultsDisplay");

var _search = require("./search.actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = {
  query: {
    q: null,
    sortBy: "relevance",
    sortOrder: "asc",
    page: 1,
    perPage: 10,
    pageId: "00000000-0000-0000-0000-000000000000",
    loadAllPages: true
  },
  url: null,
  errorMsg: null,
  loading: true,
  pagination: false,
  totalResults: 0,
  results: [],
  resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_APPEND,
  sorters: [],
  dictionary: {},
  facets: [],
  numOpenGroups: null,
  preSelectedFacets: {},
  isFirstLoad: true,
  mobileFacetsShown: false
};

var actionMap = (_actionMap = {}, _defineProperty(_actionMap, _search.LOAD_RESULTS_START, loadStart), _defineProperty(_actionMap, _search.LOAD_RESULTS_SUCCESS, loadSuccess), _defineProperty(_actionMap, _search.LOAD_RESULTS_FAIL, loadError), _defineProperty(_actionMap, _search.SORT_CHANGED, updateSort), _defineProperty(_actionMap, _search.MERGE_QUERY_PARAMS, updateQueryParams), _defineProperty(_actionMap, _search.KEYWORDS_CHANGED, updateKeywords), _defineProperty(_actionMap, _search.INCREMENT_PAGE, incrementPage), _defineProperty(_actionMap, _search.CHANGE_PAGE, changePage), _defineProperty(_actionMap, _search.FACET_CHANGED, changeFacet), _defineProperty(_actionMap, _search.CLEAR_FACET_GROUP, clearFacetGroup), _defineProperty(_actionMap, _search.CLEAR_ALL_FACETS, clearAllFacets), _defineProperty(_actionMap, _search.TOGGLE_MOBILE_FACETS, toggleMobileFacets), _actionMap);

function searchReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var actionType = actionMap[action.type];
  return actionType ? actionType(state, action) : state;
}

function loadStart(state, action) {
  return _ramda2.default.merge(state, {
    loading: true
  });
}

function loadSuccess(state, action) {
  var response = action.payload.response;

  return _ramda2.default.merge((0, _service.mapResponseToState)(response, state), {
    loading: false,
    isFirstLoad: false,
    preSelectedFacets: {}
  });
}

function loadError(state, action) {
  return _ramda2.default.merge(state, { loading: false, errorMsg: action.payload });
}

function updateSort(state, action) {
  var activeSorter = _ramda2.default.find(_ramda2.default.propEq("isActive", true), action.payload);

  return _ramda2.default.merge(state, {
    sorters: action.payload,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      sortBy: activeSorter.value,
      sortOrder: activeSorter.direction,
      page: 1
    })
  });
}

function updateQueryParams(state, action) {
  return _ramda2.default.merge(state, {
    query: _ramda2.default.merge(state.query, action.payload.params),
    facets: action.payload.facets,
    preSelectedFacets: action.payload.preSelectedFacets
  });
}

function incrementPage(state, action) {
  var pageNum = parseInt(state.query.page, 10) + 1;
  return _ramda2.default.merge(state, {
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_APPEND,
    query: _ramda2.default.merge(state.query, {
      page: pageNum
    })
  });
}

function changePage(state, action) {
  return _ramda2.default.merge(state, {
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      page: action.payload
    })
  });
}

function updateKeywords(state, action) {
  return _ramda2.default.merge(state, {
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      q: action.payload,
      page: 1
    })
  });
}

function changeFacet(state, action) {
  // We want to provide a new facet object to our
  // state with a single facet changed.

  // Lookup the path for the given facetId
  // and change it using assocPath
  var facetId = action.payload.facetId;
  var facetValue = action.payload.facetValue;
  var newFacets = (0, _facets.setSelectedOnFacetValues)([facetId], facetValue, state.facets);

  return _ramda2.default.merge(state, {
    facets: newFacets,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      page: 1
    })
  });
}

function clearFacetGroup(state, action) {
  var group = action.payload;
  var selectedFacetIds = (0, _facets.selectedFacetsFromGroup)(group).map(function (v) {
    return v.id;
  });
  var newFacets = (0, _facets.setSelectedOnFacetValues)(selectedFacetIds, false, state.facets);

  return _ramda2.default.merge(state, {
    facets: newFacets,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      page: 1
    })
  });
}

function clearAllFacets(state, action) {
  var facets = state.facets;
  var selectedFacetIds = facets.reduce(function (all, group) {
    return all.concat((0, _facets.selectedFacetsFromGroup)(group).map(function (v) {
      return v.id;
    }));
  }, []);

  var newFacets = (0, _facets.setSelectedOnFacetValues)(selectedFacetIds, false, facets);

  return _ramda2.default.merge(state, {
    facets: newFacets,
    resultsDisplayStrategy: _resultsDisplay.RESULTS_DISPLAY_REFRESH,
    query: _ramda2.default.merge(state.query, {
      page: 1
    })
  });
}

function toggleMobileFacets(state, action) {
  return _ramda2.default.merge({
    mobileFacetsShown: action.payload
  }, state);
}

},{"../facets":85,"../resultsDisplay":86,"../service":91,"./search.actions":89,"ramda":"ramda"}],91:[function(require,module,exports){
arguments[4][64][0].apply(exports,arguments)
},{"./resultsDisplay":86,"dup":64,"jquery":"jquery","ramda":"ramda"}],92:[function(require,module,exports){
arguments[4][28][0].apply(exports,arguments)
},{"dup":28,"ramda":"ramda"}],93:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _facets = require("../redux/facets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_FACETS_SHOWN = 5;

var FacetGroup = function (_React$Component) {
  _inherits(FacetGroup, _React$Component);

  function FacetGroup(props) {
    _classCallCheck(this, FacetGroup);

    var _this = _possibleConstructorReturn(this, (FacetGroup.__proto__ || Object.getPrototypeOf(FacetGroup)).call(this, props));

    _this.state = {
      isGroupOpen: true,
      isGroupExpanded: false,
      valuesExpanded: [],
      searchTerm: "",
      facetGroupClicked: false
    };

    _this.pageClickHandler = _this.pageClickHandler.bind(_this);
    return _this;
  }

  // Lifecycle

  _createClass(FacetGroup, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // if group is closed, but has selected
      // values, open it
      var group = this.props.group;

      var selected = (0, _facets.selectedFacetsFromGroup)(group);
      var shouldOpen = this.state.isGroupOpen;
      if (selected.length > 0) {
        shouldOpen = true;
      }

      // Some facets will be expanded by default due to
      // children being pre-selected
      var hasSelected = (0, _facets.valuesWithSelectedChildren)(group);
      var selectedIds = hasSelected.map(function (v) {
        return v.id;
      });

      // similarly, if group's values or value children
      // are selected, auto-expand that group
      var tailValues = _ramda2.default.drop(MAX_FACETS_SHOWN, group.values);
      var shouldExpand = tailValues.reduce(function (should, tv) {
        if (tv.selected === true || selectedIds.indexOf(tv.id) >= 0) {
          should = true;
        }

        return should;
      }, false);

      window.addEventListener('mousedown', this.pageClickHandler, false);

      this.setState({
        isGroupOpen: shouldOpen,
        isGroupExpanded: true,
        valuesExpanded: selectedIds
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.pageClickHandler, false);
    }
  }, {
    key: "pageClickHandler",
    value: function pageClickHandler() {
      if (!this.state.facetGroupClicked) {
        this.setState({ showFacetDropdown: false });
      }
    }
  }, {
    key: "facetRefinementMenuHandler",
    value: function facetRefinementMenuHandler(event) {
      var wasEscapePressed = event.keyCode === 27;

      if (wasEscapePressed) {
        this.pageClickHandler();
        this.restoreArrowKeyScrolling();
      }
    }
  }, {
    key: "chunkValues",
    value: function chunkValues(values) {
      // divide the values into two arrays, the first for the Top X facets
      // and the second for overflow. If recursion level is over zero, put
      // all values in first array.
      return values.length > MAX_FACETS_SHOWN ? _ramda2.default.splitAt(MAX_FACETS_SHOWN, values) : [values, []];
    }
  }, {
    key: "showExpandButton",
    value: function showExpandButton() {
      return !this.state.isGroupExpanded;
    }
  }, {
    key: "shouldRenderTailValues",
    value: function shouldRenderTailValues(tailValues) {
      return this.state.isGroupExpanded && tailValues.length > 0;
    }
  }, {
    key: "shouldRenderChildGroups",
    value: function shouldRenderChildGroups(group) {
      return group.isOpen && !!group.childGroups && group.childGroups.length > 0;
    }
  }, {
    key: "toggleGroup",
    value: function toggleGroup() {
      var isOpen = !this.state.isGroupOpen;
      this.setState({ isGroupOpen: isOpen });
    }
  }, {
    key: "toggleExpand",
    value: function toggleExpand() {
      var isExpanded = !this.state.isGroupExpanded;
      this.setState({ isGroupExpanded: isExpanded });
    }
  }, {
    key: "toggleValueExpand",
    value: function toggleValueExpand(valueId) {
      // check if the valueId is in the list. Remove it
      // if found, add it if not.
      var valueIdx = this.state.valuesExpanded.indexOf(valueId);
      var selectedValues = valueIdx >= 0 ? _ramda2.default.remove(valueIdx, 1, this.state.valuesExpanded) : _ramda2.default.append(valueId, this.state.valuesExpanded);

      this.setState({ valuesExpanded: selectedValues });
    }
  }, {
    key: "valueIsExpanded",
    value: function valueIsExpanded(value) {
      return this.state.valuesExpanded.indexOf(value.id) >= 0;
    }
  }, {
    key: "onFacetChange",
    value: function onFacetChange(event, value) {
      var group = this.props.group;
      var selected = (0, _facets.selectedFacetsFromGroup)(group);
      var hasselections = selected.length > 0;

      if (hasselections) this.props.handleClearGroup(this.props.group);

      this.setState({ activeDescendant: event.target.id });
      this.props.updateSelectedFacets(value, event.target.checked);
      this.props.handleFacetChange(value.id, event.target.checked);

      //hack delay to prevent flashing
      if (hasselections) {
        var start = new Date().getTime();
        for (var i = 0; i < 1e7; i++) {
          if (new Date().getTime() - start > 700) {
            break;
          }
        }
      }

      this.restoreArrowKeyScrolling();
    }
  }, {
    key: "onFacetKeyUp",
    value: function onFacetKeyUp(event) {
      var visibleFacetsDropdownId = this.getFilteredFacets(this.state.searchTerm).id + '_dropdown';
      var keyPressed = event.keyCode;
      var initialFocusHolder = this.getPositionInParentElement(visibleFacetsDropdownId, event.target);
      var isFocusAtBeginning = initialFocusHolder === 0;
      var isFocusAtEnd = initialFocusHolder === this.getNumberOfSiblings(visibleFacetsDropdownId);
      var nextFocusIndex = 0;
      event.stopPropagation();

      if (keyPressed === 38) {
        if (isFocusAtBeginning) {
          nextFocusIndex = this.getNumberOfSiblings(visibleFacetsDropdownId);
        } else {
          nextFocusIndex = initialFocusHolder - 1;
        }
        this.setFacetFocus(visibleFacetsDropdownId, nextFocusIndex);
      } else if (keyPressed === 40) {
        if (isFocusAtEnd) {
          nextFocusIndex = 0;
        } else {
          nextFocusIndex = initialFocusHolder + 1;
        }
        this.setFacetFocus(visibleFacetsDropdownId, nextFocusIndex);
      }

      if (keyPressed === 13) {
        this.handleFacetEnterPress(event);
      }

      this.facetRefinementMenuHandler(event);
    }
  }, {
    key: "onFacetParentKeyUp",
    value: function onFacetParentKeyUp(event) {
      var keyPressed = event.keyCode;
      var triggerKeys = [13, 38, 40];
      var shouldFocusOnChild = triggerKeys.indexOf(keyPressed) != -1;
      var wasInputEmpty = event.target.value.length === 1;
      var wasSpacebarPressed = keyPressed === 32;
      var relatedDropdownId = event.target.dataset.filterid;

      if (shouldFocusOnChild || wasSpacebarPressed && wasInputEmpty) {
        this.handleFacetInputClick();
        this.setFacetFocusFromParent(relatedDropdownId, 0);
      }

      this.facetRefinementMenuHandler(event);
    }
  }, {
    key: "getNumberOfSiblings",
    value: function getNumberOfSiblings(id) {
      var facetDropdownItems = this.getRelatedFacetGroupElements(id);
      return facetDropdownItems.length - 1;
    }
  }, {
    key: "getPositionInParentElement",
    value: function getPositionInParentElement(id, node) {
      var facetDropdownItems = this.getRelatedFacetGroupElements(id);
      return Array.prototype.indexOf.call(facetDropdownItems, node);
    }
  }, {
    key: "setFacetFocus",
    value: function setFacetFocus(element, index) {
      var nextElementToFocus = this.getAdjacentFacetGroupElement(element, index);
      if (typeof nextElementToFocus != 'undefined') {
        nextElementToFocus.focus();
      }
    }
  }, {
    key: "setFacetFocusFromParent",
    value: function setFacetFocusFromParent(id, index) {
      var activeFacets = this.getRelatedFacetGroupElements(id);
      if (typeof activeFacets[index] != 'undefined') {
        activeFacets[index].focus();
      }
    }
  }, {
    key: "getAdjacentFacetGroupElement",
    value: function getAdjacentFacetGroupElement(id, index) {
      var facetDropdownItems = this.getRelatedFacetGroupElements(id);
      return facetDropdownItems[index];
    }
  }, {
    key: "getRelatedFacetGroupElements",
    value: function getRelatedFacetGroupElements(id) {
      return document.getElementById(id).getElementsByTagName('li');
    }
  }, {
    key: "handleFacetEnterPress",
    value: function handleFacetEnterPress(event) {
      event.target.getElementsByClassName('search-facets__toggle')[0].click();
    }
  }, {
    key: "disableArrowKeyScrolling",
    value: function disableArrowKeyScrolling() {
      var arrowKeyHandler = function arrowKeyHandler(e) {
        if ([13, 37, 38, 39, 40].indexOf(e.keyCode) > -1) {
          e.preventDefault();
        }
      };
      window.addEventListener("keydown", arrowKeyHandler, false);
    }
  }, {
    key: "restoreArrowKeyScrolling",
    value: function restoreArrowKeyScrolling() {
      if (typeof arrowKeyHandler != 'undefined') {
        window.removeEventListener("keydown", arrowKeyHandler, false);
      }
    }
  }, {
    key: "notNull",
    value: function notNull(object) {
      return !!object;
    }
  }, {
    key: "isMatch",
    value: function isMatch(input) {
      return input.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) >= 0;
    }
  }, {
    key: "applyHighlighting",
    value: function applyHighlighting(text) {
      var highlightedText,
          strIndex = text.toLowerCase().indexOf(this.state.searchTerm.toLowerCase());

      if (strIndex >= 0) {
        var substrLength = this.state.searchTerm.length,
            titleLength = text.length,
            endSpan = "</span>",
            startSpan = "<span class='highlighted'>";

        highlightedText = text.slice(0, strIndex) + startSpan + text.slice(strIndex, strIndex + substrLength) + endSpan + text.slice(strIndex + substrLength, titleLength);
      }

      return highlightedText;
    }
  }, {
    key: "getFilteredFacets",
    value: function getFilteredFacets(searchTerm) {
      if (!this.state.searchTerm) {
        return this.props.group;
      }

      var facets = Object.assign({}, this.props.group);

      facets.values = this.mapChildFacetMatch(facets.values);
      facets.childGroups = this.mapFacetMatches(facets.childGroups);

      var hasChildGroupMatch = !!facets.childGroups && facets.childGroups.length;
      var hasValuesMatch = !!facets.values && facets.values.length;

      if (hasChildGroupMatch || hasValuesMatch || this.isMatch(facets.label)) {
        return facets;
      } else {
        // facet filter has no results
        var emptyFacets = Object.assign({ emptyFacets: true }, facets);
        return emptyFacets;
      }
    }
  }, {
    key: "mapFacetMatches",
    value: function mapFacetMatches(facetCollection) {
      var _this2 = this;

      if (!facetCollection) {
        return;
      }
      return facetCollection.map(function (facet) {
        return _this2.mapFacetOrChildMatch(facet, "label", "values");
      }).filter(this.notNull);
    }
  }, {
    key: "mapChildFacetMatch",
    value: function mapChildFacetMatch(childFacet) {
      var _this3 = this;

      if (!childFacet) {
        return;
      }
      return childFacet.map(function (facet) {
        return _this3.mapFacetOrChildMatch(facet, "name", "childValues");
      }).filter(this.notNull);
    }
  }, {
    key: "mapFacetOrChildMatch",
    value: function mapFacetOrChildMatch(childFacet, nameField, childrenField) {
      var newChildFacets = Object.assign({}, childFacet);
      newChildFacets[childrenField] = this.mapChildFacetMatch(newChildFacets[childrenField]);

      if (newChildFacets[childrenField] && newChildFacets[childrenField].length) {
        if (this.isMatch(newChildFacets[nameField])) {
          newChildFacets = Object.assign({ displayName: this.applyHighlighting(newChildFacets[nameField]) }, newChildFacets);
        }
        return newChildFacets;
      }

      if (newChildFacets[nameField]) {
        if (this.isMatch(newChildFacets[nameField])) {
          newChildFacets = Object.assign({ displayName: this.applyHighlighting(newChildFacets[nameField]) }, newChildFacets);
          return newChildFacets;
        }
      }

      return null;
    }
  }, {
    key: "handleFacetFilterChange",
    value: function handleFacetFilterChange(e) {
      this.setState({ showFacetDropdown: true });
      this.setState({ searchTerm: e.target.value });
    }
  }, {
    key: "handleFacetInputClick",
    value: function handleFacetInputClick(e) {
      this.setState({ showFacetDropdown: true });
    }
  }, {
    key: "handleFacetDropdownClick",
    value: function handleFacetDropdownClick(e) {
      // toggle dropdown open or closed
      var shouldShowDropdown = this.state.showFacetDropdown ? false : true;
      this.setState({ showFacetDropdown: shouldShowDropdown });
    }

    // Handle closing dropdown when clicking outside

  }, {
    key: "mouseDownHandler",
    value: function mouseDownHandler(e) {
      this.setState({ facetGroupClicked: true });
    }
  }, {
    key: "mouseUpHandler",
    value: function mouseUpHandler(e) {
      this.setState({ facetGroupClicked: false });
      this.setState({ showFacetDropdown: false });
    }
  }, {
    key: "onClearGroup",
    value: function onClearGroup() {
      var group = this.props.group;
      this.props.handleClearGroup(group);
    }

    // Rendering

  }, {
    key: "renderValueItem",
    value: function renderValueItem(value, recursionLevel) {
      var _this4 = this;

      var childValues = value.childValues;
      var hasChildValues = !!childValues && childValues.length > 0;
      var isExpanded = this.valueIsExpanded(value);
      var renderChildValues = hasChildValues && isExpanded;
      var toggleClass = "search-facets__value-expand is-open";
      var labelClass = value.selected ? "search-facets__title search-facet__selected" : "search-facets__title";
      var valueID = value.id + "__student";

      return _react2.default.createElement(
        "li",
        { key: valueID, className: "search-facets__group-value", tabIndex: "0", onFocus: this.disableArrowKeyScrolling(), onKeyUp: function onKeyUp(e) {
            return _this4.onFacetKeyUp(e);
          } },
        _react2.default.createElement("input", {
          className: "search-facets__toggle",
          checked: value.selected,
          "aria-controls": "search-results",
          "aria-selected": value.selected,
          id: valueID,
          onChange: function onChange(e) {
            return _this4.onFacetChange(e, value);
          },
          type: "checkbox" }),
        _react2.default.createElement("label", { htmlFor: valueID, className: labelClass, dangerouslySetInnerHTML: { __html: value.displayName ? value.displayName : value.name } }),
        hasChildValues && this.renderValues(childValues, recursionLevel + 1)
      );
    }
  }, {
    key: "renderFlatValues",
    value: function renderFlatValues(values) {
      var _this5 = this;

      var renderValue = function renderValue(value) {
        return _react2.default.createElement(
          "li",
          { key: valueID, tabIndex: "0" },
          _react2.default.createElement("input", { id: valueID, checked: value.selected, onChange: function onChange(e) {
              return _this5.onFacetChange(e, value);
            }, type: "checkbox" }),
          _react2.default.createElement(
            "label",
            { htmlFor: valueID },
            value.name,
            " (",
            value.count,
            ")"
          )
        );
      };

      return _react2.default.createElement(
        "ul",
        { className: "search-facets__group-values" },
        values.map(function (value) {
          return renderValue(value);
        })
      );
    }
  }, {
    key: "renderValues",
    value: function renderValues(values, recursionLevel) {
      var _this6 = this;

      var chunkedValues = void 0;
      if (recursionLevel === 0) {
        chunkedValues = this.chunkValues(values);
      } else {
        chunkedValues = [values, []];
      }

      var headValues = chunkedValues[0];
      var tailValues = chunkedValues[1];

      var stateClass = "search-facets__group-values is-level-" + recursionLevel;
      var shouldRenderTailValues = this.shouldRenderTailValues(tailValues);

      return _react2.default.createElement(
        "div",
        { className: "search-facets__values-wrapper" },
        _react2.default.createElement(
          "ul",
          { className: stateClass },
          headValues.map(function (val) {
            return _this6.renderValueItem(val, recursionLevel);
          })
        ),
        shouldRenderTailValues && _react2.default.createElement(
          "ul",
          { className: (0, _classnames2.default)(stateClass, "is-overflow") },
          tailValues.map(function (val) {
            return _this6.renderValueItem(val, recursionLevel);
          })
        )
      );
    }
  }, {
    key: "renderChildGroups",
    value: function renderChildGroups(group) {
      var _this7 = this;

      if (this.state.isGroupOpen && group.childGroups && group.childGroups.length) {

        return group.childGroups.map(function (childGroup) {
          return _react2.default.createElement(FacetGroup, { key: childGroup.id,
            isChildGroup: "true",
            group: childGroup,
            dupeSelected: false,
            handleFacetChange: _this7.props.handleFacetChange,
            updateSelectedFacets: _this7.props.updateSelectedFacets,
            handleClearGroup: _this7.props.handleClearGroup });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var dictionary = this.props.dictionary;

      var visibleFacets = this.getFilteredFacets(this.state.searchTerm);
      var isChildGroup = this.props.isChildGroup;
      var noResultsText = 'No results match "' + this.state.searchTerm + '"';
      var groupWrapperClass = this.state.showFacetDropdown ? "search-facets__group-wrapper search-facets__dropdown-active " : "search-facets__group-wrapper";
      var group = this.props.group;
      var selectedValues = (0, _facets.selectedFacetsFromGroup)(group);
      var showDupeSelected = selectedValues.length > 0 && this.props.dupeSelected;
      var inputID = visibleFacets.id + '--student';
      var dropdownID = visibleFacets.id + '_dropdown--student';
      var activeDescendant = this.state.activeDescendant;
      var isFacetVisible = !this.state.showFacetDropdown;

      return _react2.default.createElement(
        "div",
        { className: "search-facets__group", "aria-live": "polite", onMouseDown: function onMouseDown(e) {
            return _this8.mouseDownHandler(e);
          }, onMouseUp: function onMouseUp(e) {
            return _this8.mouseUpHandler(e);
          } },
        _react2.default.createElement(
          "div",
          { className: "search-facets__group-heading" },
          _react2.default.createElement("label", { className: "search-facets__group-title", htmlFor: visibleFacets.id, dangerouslySetInnerHTML: { __html: visibleFacets.label } }),
          !isChildGroup && _react2.default.createElement(
            "div",
            { className: "search-facets__input-wrapper" },
            _react2.default.createElement("input", { type: "text",
              placeholder: dictionary.facetGroupPlaceholder,
              onClick: function onClick(e) {
                return _this8.handleFacetInputClick(e);
              },
              onChange: function onChange(e) {
                return _this8.handleFacetFilterChange(e);
              },
              onKeyUp: function onKeyUp(e) {
                return _this8.onFacetParentKeyUp(e);
              },
              id: inputID,
              role: "combobox",
              "aria-autocomplete": "list",
              "aria-expanded": "true",
              "aria-owns": dropdownID,
              "aria-activedescendant": activeDescendant,
              "aria-controls": "search-results",
              "aria-haspopup": "true",
              "data-filterid": dropdownID,
              className: "search-facets__text-field" }),
            _react2.default.createElement("span", { className: "search-facets__dropdown-toggle", onClick: function onClick(e) {
                return _this8.handleFacetDropdownClick(e);
              } })
          )
        ),
        !visibleFacets.emptyFacets && _react2.default.createElement(
          "div",
          { className: groupWrapperClass,
            id: dropdownID,
            "aria-hidden": isFacetVisible,
            ref: function ref(wrap) {
              return _this8.groupWrapper = wrap;
            } },
          _react2.default.createElement(
            "div",
            { className: "search-facets__group-body" },
            this.renderValues(visibleFacets.values, 0),
            this.renderChildGroups(visibleFacets)
          )
        ),
        visibleFacets.emptyFacets && _react2.default.createElement(
          "div",
          { className: "search-facets__no-results" },
          noResultsText
        )
      );
    }
  }]);

  return FacetGroup;
}(_react2.default.Component);

exports.default = FacetGroup;
var _React$PropTypes = _react2.default.PropTypes,
    func = _React$PropTypes.func,
    shape = _React$PropTypes.shape,
    bool = _React$PropTypes.bool,
    number = _React$PropTypes.number,
    string = _React$PropTypes.string,
    oneOfType = _React$PropTypes.oneOfType,
    arrayOf = _React$PropTypes.arrayOf;

// allows us to define propTypes recursively
// https://github.com/facebook/react/issues/5676

var lazyF = function lazyF(f) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return f().apply(undefined, args);
  };
};

var facetValueShape = shape({
  id: oneOfType([number, string]).isRequired,
  name: string.isRequired,
  count: number.isRequired,
  selected: bool.isRequired,
  childValues: arrayOf(lazyF(function () {
    return facetValueShape;
  }))
});

var facetGroupShape = shape({
  id: oneOfType([number, string]).isRequired,
  label: string.isRequired,
  values: arrayOf(facetValueShape).isRequired,
  childGroups: arrayOf(lazyF(function () {
    return facetGroupShape;
  }))
});

FacetGroup.propTypes = {
  isOpen: bool,
  dupeSelected: bool,
  handleFacetChange: func.isRequired,
  updateSelectedFacets: func.isRequired,
  handleClearGroup: func.isRequired,
  group: facetGroupShape,
  dictionary: shape({
    facetGroupPlaceholder: string,
    facetGroupNoResults: string
  })
};

FacetGroup.defaultProps = {
  isOpen: true,
  dupeSelected: true
};

},{"../redux/facets":112,"classnames":"classnames","ramda":"ramda","react":"react"}],94:[function(require,module,exports){
arguments[4][40][0].apply(exports,arguments)
},{"../filterSlider":107,"./FacetGroup.jsx":93,"./FacetTag.jsx":95,"dup":40,"react":"react"}],95:[function(require,module,exports){
arguments[4][41][0].apply(exports,arguments)
},{"../redux/facets":112,"classnames":"classnames","dup":41,"ramda":"ramda","react":"react"}],96:[function(require,module,exports){
arguments[4][4][0].apply(exports,arguments)
},{"./LoadingSpinner.jsx":97,"dup":4,"react":"react"}],97:[function(require,module,exports){
arguments[4][43][0].apply(exports,arguments)
},{"dup":43,"react":"react"}],98:[function(require,module,exports){
arguments[4][71][0].apply(exports,arguments)
},{"../paging":109,"dup":71,"react":"react"}],99:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResultItem = function (_React$Component) {
  _inherits(ResultItem, _React$Component);

  function ResultItem(props) {
    _classCallCheck(this, ResultItem);

    var _this = _possibleConstructorReturn(this, (ResultItem.__proto__ || Object.getPrototypeOf(ResultItem)).call(this, props));

    _this.itemWrapper = null;
    _this.sectionName = null;
    _this.sections = [];
    _this.state = { sectionsBelow: [] };

    //https://facebook.github.io/react/docs/react-without-es6.html
    _this.handleResultSectionLayout = _this.handleResultSectionLayout.bind(_this);
    return _this;
  }

  _createClass(ResultItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.itemWrapper.className = this.itemWrapper.className + " is-visible";

      this.handleResultSectionLayout();

      window.addEventListener("resize", this.handleResultSectionLayout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleResultSectionLayout);
    }
  }, {
    key: "getSectionClasses",
    value: function getSectionClasses(key) {
      return (0, _classnames2.default)("directory-result__section", "directory-result__section--" + key, {
        'is-below': this.state.sectionsBelow.includes(key)
      });
    }
  }, {
    key: "handleResultSectionLayout",
    value: function handleResultSectionLayout() {
      var _this2 = this;

      var sectionsBelow = this.sections.map(function (_ref) {
        var key = _ref.key,
            el = _ref.el;

        if (el.offsetTop > _this2.sectionName.offsetTop) {
          return key;
        } else {
          return '';
        }
      });
      this.setState({
        sectionsBelow: sectionsBelow
      });
    }
  }, {
    key: "addSectionRef",
    value: function addSectionRef(key) {
      var _this3 = this;

      return function (el) {
        // https://facebook.github.io/react/docs/refs-and-the-dom.html
        // see caveats
        if (el !== null) {
          _this3.sections.push({ key: key, el: el });
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          profileUrl = _props.profileUrl,
          image = _props.image,
          name = _props.name,
          title = _props.title,
          department = _props.department,
          colleges = _props.colleges,
          contactInfo = _props.contactInfo,
          website1link = _props.website1link,
          website1text = _props.website1text,
          website2link = _props.website2link,
          website2text = _props.website2text,
          researchAreas = _props.researchAreas;


      return _react2.default.createElement(
        "section",
        { className: "directory-result", ref: function ref(el) {
            return _this4.itemWrapper = el;
          } },
        _react2.default.createElement(
          "section",
          { className: "directory-result__section directory-result__section--name", ref: function ref(el) {
              return _this4.sectionName = el;
            } },
          image ? _react2.default.createElement("img", { src: image, alt: name, className: "directory-result__image" }) : _react2.default.createElement("img", { src: "/default", alt: name, className: "directory-result__image" }),
          _react2.default.createElement(
            "div",
            { className: "directory-result__name-wrapper" },
            profileUrl ? _react2.default.createElement(
              "h1",
              { className: "directory-result__name" },
              _react2.default.createElement(
                "a",
                { href: profileUrl },
                name
              )
            ) : _react2.default.createElement(
              "h1",
              { className: "directory-result__name" },
              name
            ),
            _react2.default.createElement(
              "div",
              { className: "directory-result__title" },
              title
            )
          )
        ),
        _react2.default.createElement(
          "section",
          { className: this.getSectionClasses("department"), ref: this.addSectionRef("department") },
          _react2.default.createElement(
            "h6",
            { className: "directory-result__section-header" },
            "Program"
          ),
          department.map(function (item, index) {
            return _react2.default.createElement(
              "span",
              { key: index },
              item
            );
          })
        ),
        _react2.default.createElement(
          "section",
          { className: this.getSectionClasses("colleges"), ref: this.addSectionRef("colleges") },
          _react2.default.createElement(
            "h6",
            { className: "directory-result__section-header" },
            "Alma Mater"
          ),
          _react2.default.createElement(
            "div",
            { className: "directory-result__colleges" },
            colleges
          )
        ),
        _react2.default.createElement(
          "section",
          { className: this.getSectionClasses("contact"), ref: this.addSectionRef("contact") },
          _react2.default.createElement(
            "h6",
            { className: "directory-result__section-header" },
            "Contact"
          ),
          _react2.default.createElement(
            "ul",
            { className: "directory-result__contact-card" },
            contactInfo.email ? _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement(
                "a",
                { href: "mailto:" + contactInfo.email },
                contactInfo.email
              )
            ) : null,
            website1link ? _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement(
                "a",
                { href: website1link },
                website1text
              )
            ) : null,
            website2link ? _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement(
                "a",
                { href: website2link },
                website2text
              )
            ) : null
          )
        ),
        _react2.default.createElement(
          "section",
          { className: this.getSectionClasses("research-areas"), ref: this.addSectionRef("research-areas") },
          _react2.default.createElement(
            "h6",
            { className: "directory-result__section-header" },
            "Research Areas"
          ),
          _react2.default.createElement(
            "ul",
            { className: "directory-result__research-areas" },
            researchAreas.map(function (item, index) {
              return _react2.default.createElement(
                "li",
                { key: item.label },
                _react2.default.createElement(
                  "a",
                  { href: item.href },
                  item.label
                )
              );
            })
          )
        )
      );
    }
  }]);

  return ResultItem;
}(_react2.default.Component);

exports.default = ResultItem;
var _React$PropTypes = _react2.default.PropTypes,
    arrayOf = _React$PropTypes.arrayOf,
    string = _React$PropTypes.string,
    object = _React$PropTypes.object;

ResultItem.propTypes = {
  profileUrl: string,
  image: string,
  name: string.isRequired,
  title: string.isRequired,
  department: arrayOf(string).isRequired,
  colleges: string,
  website1link: string,
  website1text: string,
  website2link: string,
  website2text: string,
  contactInfo: object,
  researchAreas: arrayOf(object).isRequired
};

},{"classnames":"classnames","react":"react"}],100:[function(require,module,exports){
arguments[4][46][0].apply(exports,arguments)
},{"../filterSlider":107,"../paging":109,"../redux/resultsDisplay":113,"./LoadMore.jsx":96,"./LoadingSpinner.jsx":97,"./Pagination.jsx":98,"./ResultItem.jsx":99,"./SearchStatus.jsx":102,"./SortBar.jsx":103,"classnames":"classnames","dup":46,"react":"react"}],101:[function(require,module,exports){
arguments[4][47][0].apply(exports,arguments)
},{"./LoadingSpinner.jsx":97,"dup":47,"react":"react"}],102:[function(require,module,exports){
arguments[4][48][0].apply(exports,arguments)
},{"dup":48,"react":"react"}],103:[function(require,module,exports){
arguments[4][76][0].apply(exports,arguments)
},{"classnames":"classnames","dup":76,"ramda":"ramda","react":"react"}],104:[function(require,module,exports){
arguments[4][50][0].apply(exports,arguments)
},{"../components/FacetList.jsx":94,"../redux/search/search.actions":116,"dup":50,"react-redux":"react-redux"}],105:[function(require,module,exports){
arguments[4][14][0].apply(exports,arguments)
},{"../components/SearchBox.jsx":101,"../redux/search/search.actions":116,"dup":14,"react-redux":"react-redux"}],106:[function(require,module,exports){
arguments[4][52][0].apply(exports,arguments)
},{"../components/ResultList.jsx":100,"../redux/facets":112,"../redux/search/search.actions":116,"dup":52,"react-redux":"react-redux"}],107:[function(require,module,exports){
arguments[4][53][0].apply(exports,arguments)
},{"dup":53}],108:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initStudentListingApp = initStudentListingApp;

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxThunk = require("redux-thunk");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactRedux = require("react-redux");

var _rootReducer = require("./redux/rootReducer");

var _rootReducer2 = _interopRequireDefault(_rootReducer);

var _search = require("./redux/search/search.reducer");

var _search2 = require("./redux/search/search.actions");

var _configureStore = require("./redux/configureStore");

var _configureStore2 = _interopRequireDefault(_configureStore);

var _createRoutingMiddleware = require("./redux/createRoutingMiddleware");

var _createRoutingMiddleware2 = _interopRequireDefault(_createRoutingMiddleware);

var _routing = require("./redux/routing");

var _resultsDisplay = require("./redux/resultsDisplay");

var _ResultsContainer = require("./containers/ResultsContainer.jsx");

var _ResultsContainer2 = _interopRequireDefault(_ResultsContainer);

var _QueryContainer = require("./containers/QueryContainer.jsx");

var _QueryContainer2 = _interopRequireDefault(_QueryContainer);

var _FacetsContainer = require("./containers/FacetsContainer.jsx");

var _FacetsContainer2 = _interopRequireDefault(_FacetsContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// the mount nodes are the elements we want to include
// as part of the search app
function initStudentListingApp(mountNodes) {

  if (!mountNodes.length) {
    return;
  }

  console.log('mountNodes', mountNodes);
  // extract the searchId from the mountNodes
  // while also checking mountNodes share same id
  var searchId = mountNodes.reduce(function (id, node) {
    var nodeId = (0, _jquery2.default)(node).data("searchId");
    // if id is null, we want to set it
    // with the first node's value
    if (id === null) {
      return nodeId;
    }
    // if node id does not equal current
    // id value, it's invalid and return undefined
    if (id !== nodeId) {
      return;
    }

    return id;
  }, null);

  // if we have an invalid or non-matching id, raise an error
  if (!searchId) {
    throw new Error("Could not initialize Thread search app. searchId was either not present, or provided mount nodes did not share the same searchId");
  }

  // define the canonical inital state of our redux store here
  // including some value taken from the data-attrs of the
  // mount node.
  var config = window.drexelCOESearchConfigs.find(function (c) {
    return c.searchId === searchId;
  });
  if (!config) {
    throw new Error("Could not initialize Thread search app instance with id of \"" + searchId + "\". Configuration data not found.");
  }

  // create a starting state object,
  // which includes and intitial state
  // from individual reducers
  var initialState = _ramda2.default.merge(_search.initialState, {
    url: config.url,
    pagination: config.pagination,
    resultsDisplayStrategy: config.pagination ? _resultsDisplay.RESULTS_DISPLAY_REFRESH : _resultsDisplay.RESULTS_DISPLAY_APPEND,
    sorters: config.sorters,
    dictionary: config.dictionary,
    numOpenGroups: config.numOpenGroups,
    query: _ramda2.default.merge(_search.initialState.query, {
      pageId: config.pageId
    })
  });

  // determine if we want to load all page results in our cold load
  var doLoadAllPages = initialState.resultsDisplayStrategy === _resultsDisplay.RESULTS_DISPLAY_APPEND && initialState.isFirstLoad;

  initialState = _ramda2.default.merge(initialState, {
    query: _ramda2.default.merge(initialState.query, {
      loadAllPages: doLoadAllPages
    })
  });

  var routingMiddleware = (0, _createRoutingMiddleware2.default)(_routing.mapStateToUrl, _routing.handleUrlChange);
  var store = (0, _configureStore2.default)(_rootReducer2.default, initialState, [_reduxThunk2.default, routingMiddleware]);

  store.dispatch((0, _search2.loadResults)());

  mountNodes.forEach(function (node) {
    if (node.className.indexOf("js-search-query") > -1) {
      _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_QueryContainer2.default, null)
      ), node);
    }

    if (node.className.indexOf("js-search-results") > -1) {
      _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_ResultsContainer2.default, null)
      ), node);
    }

    if (node.className.indexOf("js-search-facets") > -1) {
      _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_FacetsContainer2.default, null)
      ), node);
    }
  });
}

},{"./containers/FacetsContainer.jsx":104,"./containers/QueryContainer.jsx":105,"./containers/ResultsContainer.jsx":106,"./redux/configureStore":110,"./redux/createRoutingMiddleware":111,"./redux/resultsDisplay":113,"./redux/rootReducer":114,"./redux/routing":115,"./redux/search/search.actions":116,"./redux/search/search.reducer":117,"jquery":"jquery","ramda":"ramda","react":"react","react-dom":"react-dom","react-redux":"react-redux","redux-thunk":"redux-thunk"}],109:[function(require,module,exports){
arguments[4][18][0].apply(exports,arguments)
},{"dup":18,"ramda":"ramda"}],110:[function(require,module,exports){
arguments[4][19][0].apply(exports,arguments)
},{"dup":19,"redux":"redux"}],111:[function(require,module,exports){
arguments[4][20][0].apply(exports,arguments)
},{"dup":20,"urijs":"urijs"}],112:[function(require,module,exports){
arguments[4][58][0].apply(exports,arguments)
},{"../util":119,"dup":58,"ramda":"ramda"}],113:[function(require,module,exports){
arguments[4][22][0].apply(exports,arguments)
},{"dup":22}],114:[function(require,module,exports){
arguments[4][23][0].apply(exports,arguments)
},{"./search/search.reducer":117,"dup":23}],115:[function(require,module,exports){
arguments[4][61][0].apply(exports,arguments)
},{"./facets":112,"./search/search.actions":116,"dup":61,"ramda":"ramda"}],116:[function(require,module,exports){
arguments[4][89][0].apply(exports,arguments)
},{"../facets":112,"../resultsDisplay":113,"../service":118,"dup":89,"ramda":"ramda"}],117:[function(require,module,exports){
arguments[4][90][0].apply(exports,arguments)
},{"../facets":112,"../resultsDisplay":113,"../service":118,"./search.actions":116,"dup":90,"ramda":"ramda"}],118:[function(require,module,exports){
arguments[4][64][0].apply(exports,arguments)
},{"./resultsDisplay":113,"dup":64,"jquery":"jquery","ramda":"ramda"}],119:[function(require,module,exports){
arguments[4][28][0].apply(exports,arguments)
},{"dup":28,"ramda":"ramda"}],120:[function(require,module,exports){
(function (global){
"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _lity = require("lity");

var _lity2 = _interopRequireDefault(_lity);

var _select = require("select2");

var _select2 = _interopRequireDefault(_select);

require("./polyfill");

require("./drexel/modules/Listing.js");

require("./drexel/modules/InputLabels.js");

require("./drexel/modules/Tabs.js");

require("./drexel/modules/SearchDropdown.js");

var _ImageSlider = require("./drexel/modules/ImageSlider");

var _CenterModeSlider = require("./drexel/modules/CenterModeSlider");

var _contentListing = require("./drexel/contentListing");

var _search = require("./drexel/search");

var _staffListing = require("./drexel/staffListing");

var _studentListing = require("./drexel/studentListing");

var _ReadMore = require("./drexel/modules/ReadMore");

var _ReadMore2 = _interopRequireDefault(_ReadMore);

var _PrimaryNav = require("./drexel/navigation/PrimaryNav");

var _SecondaryNav = require("./drexel/navigation/SecondaryNav");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

global.jQuery = _jquery2.default;
global.$ = _jquery2.default;

// Global elements


(0, _jquery2.default)('select').select2();

function runIfExists(componentSelector, functionToRun) {
  if (document.querySelectorAll(componentSelector).length > 0) {
    functionToRun();
  }
}

// PrimaryNav
var primaryNavEl = ".js-primary-nav";

runIfExists(primaryNavEl, function () {
  var primaryNav = new _PrimaryNav.PrimaryNav((0, _jquery2.default)(primaryNavEl));
});

// Secondary Nav
runIfExists(".js-secondary-nav", function () {
  var secondaryNav = new _SecondaryNav.SecondaryNav((0, _jquery2.default)(".js-secondary-nav"));
});

// readMore
var readMore = (0, _jquery2.default)('.js-readmore').map(function (index, element) {
  return (0, _ReadMore2.default)((0, _jquery2.default)(element), 'Read More', 'Read Less', '...', 240);
});

// center mode slider
var centermodeSlider = (0, _jquery2.default)('.js-slider-centermode').map(function (index, element) {
  return new _CenterModeSlider.CenterModeSlider((0, _jquery2.default)(element));
});

// Slideshows

runIfExists('.slideshow--overlay', function () {
  return mediaSliderInit();
});

function mediaSliderInit() {
  var slideshow = _jquery2.default.makeArray((0, _jquery2.default)(".slideshow--overlay .js-slider")).map(function (el) {
    return new _ImageSlider.ImageSlider((0, _jquery2.default)(el), {
      appendDots: (0, _jquery2.default)(".slideshow--overlay .slideshow__dots"),
      dots: true,
      swipe: true
    });
  });

  (0, _jquery2.default)('.slideshow--overlay .slideshow__next').click(function () {

    slideshow.map(function (slider) {
      slider.$el.slick('slickNext');
    });
  });

  (0, _jquery2.default)('.slideshow--overlay .slideshow__prev').click(function () {
    slideshow.map(function (slider) {
      slider.$el.slick('slickPrev');
    });
  });
}

if ((0, _jquery2.default)('.js-content-listing').length) {
  (0, _contentListing.initListingApp)(_jquery2.default.makeArray((0, _jquery2.default)(".js-search-query,.js-search-results,.js-search-facets")));
}

if ((0, _jquery2.default)(".js-directory-results").length) {
  (0, _search.initDirectoryApp)(_jquery2.default.makeArray((0, _jquery2.default)(".js-directory-results,.js-directory-facets")));
}

if ((0, _jquery2.default)(".js-staff-results").length) {
  (0, _staffListing.initStaffListingApp)(_jquery2.default.makeArray((0, _jquery2.default)(".js-staff-results,.js-staff-facets")));
}

if ((0, _jquery2.default)(".js-student-results").length) {
  (0, _studentListing.initStudentListingApp)(_jquery2.default.makeArray((0, _jquery2.default)(".js-student-results,.js-student-facets")));
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./drexel/contentListing":17,"./drexel/modules/CenterModeSlider":30,"./drexel/modules/ImageSlider":31,"./drexel/modules/InputLabels.js":32,"./drexel/modules/Listing.js":33,"./drexel/modules/ReadMore":34,"./drexel/modules/SearchDropdown.js":35,"./drexel/modules/Tabs.js":36,"./drexel/navigation/PrimaryNav":37,"./drexel/navigation/SecondaryNav":38,"./drexel/search":54,"./drexel/staffListing":81,"./drexel/studentListing":108,"./polyfill":122,"jquery":"jquery","lity":"lity","select2":"select2"}],121:[function(require,module,exports){
"use strict";

require("core-js/fn/object/assign");

require("core-js/fn/array/find");

require("core-js/fn/array/find-index");

require("core-js/fn/array/fill");

require("core-js/fn/array/includes");

require("core-js/fn/array/from");

},{"core-js/fn/array/fill":124,"core-js/fn/array/find":126,"core-js/fn/array/find-index":125,"core-js/fn/array/from":127,"core-js/fn/array/includes":128,"core-js/fn/object/assign":129}],122:[function(require,module,exports){
"use strict";

require("./es6-polyfill");

require("./object-fit");

var _svg4everybody = require("svg4everybody");

var _svg4everybody2 = _interopRequireDefault(_svg4everybody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _svg4everybody2.default)();

},{"./es6-polyfill":121,"./object-fit":123,"svg4everybody":"svg4everybody"}],123:[function(require,module,exports){
"use strict";

/*----------------------------------------
 * objectFitPolyfill 2.0.3
 *
 * Made by Constance Chen
 * Released under the MIT license
 *
 * https://github.com/constancecchen/object-fit-polyfill
 *--------------------------------------*/

(function () {
  "use strict";

  // If the browser does support object-fit, we don't need to continue

  if ("objectFit" in document.documentElement.style !== false) {
    window.objectFitPolyfill = function () {
      return false;
    };
    return;
  }

  /**
   * Check the container's parent element to make sure it will
   * correctly handle and clip absolutely positioned children
   *
   * @param {node} $container - parent element
   */
  var checkParentContainer = function checkParentContainer($container) {
    var styles = window.getComputedStyle($container, null);
    var position = styles.getPropertyValue("position");
    var overflow = styles.getPropertyValue("overflow");
    var display = styles.getPropertyValue("display");

    if (!position || position === "static") {
      $container.style.position = "relative";
    }
    if (overflow !== "hidden") {
      $container.style.overflow = "hidden";
    }
    // Guesstimating that people want the parent to act like full width/height wrapper here.
    // Mostly attempts to target <picture> elements, which default to inline.
    if (!display || display === "inline") {
      $container.style.display = "block";
    }
    if ($container.clientHeight === 0) {
      $container.style.height = "100%";
    }

    $container.classList.add("object-fit-polyfill");
  };

  /**
   * Check for pre-set max-width/height or min-width/height,
   * which can mess up image calculations
   *
   * @param {node} $media - img/video element
   */
  var checkMediaConstraints = function checkMediaConstraints($media) {
    var styles = window.getComputedStyle($media, null);
    var constraints = {
      "max-width": "none",
      "max-height": "none",
      "min-width": "0px",
      "min-height": "0px"
    };

    for (var property in constraints) {
      var constraint = styles.getPropertyValue(property);

      if (constraint !== constraints[property]) {
        $media.style[property] = constraints[property];
      }
    }
  };

  /**
   * Calculate & set object-position
   *
   * @param {string} axis - either "x" or "y"
   * @param {node} $media - img or video element
   * @param {string} objectPosition - e.g. "50% 50%", "top bottom"
   */
  var setPosition = function setPosition(axis, $media, objectPosition) {
    objectPosition = objectPosition.split(" ");
    var position, other, start, end, side;

    if (axis === "x") {
      position = objectPosition[0];
      other = objectPosition[1];
      start = "left";
      end = "right";
      side = $media.clientWidth;
    } else if (axis === "y") {
      position = objectPosition[1];
      other = objectPosition[0];
      start = "top";
      end = "bottom";
      side = $media.clientHeight;
    } else {
      return; // Neither x or y axis specified
    }

    if (position === start || other === start) {
      $media.style[start] = "0";
      return;
    }

    if (position === end || other === end) {
      $media.style[end] = "0";
      return;
    }

    if (position === "center" || position === "50%") {
      $media.style[start] = "50%";
      $media.style["margin-" + start] = side / -2 + "px";
      return;
    }

    // Percentage values (e.g., 30% 10%)
    if (position.indexOf("%") >= 0) {
      position = parseInt(position);

      if (position < 50) {
        $media.style[start] = position + "%";
        $media.style["margin-" + start] = side * (position / -100) + "px";
      } else {
        position = 100 - position;
        $media.style[end] = position + "%";
        $media.style["margin-" + end] = side * (position / -100) + "px";
      }

      return;
    }
    // Length-based values (e.g. 10px / 10em)
    else {
        $media.style[start] = position;
      }
  };

  /**
   * Calculate & set object-fit
   *
   * @param {node} $media - img/video/picture element
   */
  var objectFit = function objectFit($media) {
    // Fallbacks, IE 10- data
    var fit = $media.dataset ? $media.dataset.objectFit : $media.getAttribute("data-object-fit");
    var position = $media.dataset ? $media.dataset.objectPosition : $media.getAttribute("data-object-position");
    fit = fit || "cover";
    position = position || "50% 50%";

    // If necessary, make the parent container work with absolutely positioned elements
    var $container = $media.parentNode;
    checkParentContainer($container);

    // Check for max-width/height or min-width/height, which can mess up image calculations
    checkMediaConstraints($media);

    // Mathematically figure out which side needs covering, and add CSS positioning & centering
    $media.style.position = "absolute";
    $media.style.height = "100%";
    $media.style.width = "auto";

    if (fit === "scale-down") {
      $media.style.height = "auto";

      if ($media.clientWidth < $container.clientWidth && $media.clientHeight < $container.clientHeight) {
        setPosition("x", $media, position);
        setPosition("y", $media, position);
      } else {
        fit = "contain";
        $media.style.height = "100%";
      }
    }

    if (fit === "none") {
      $media.style.width = "auto";
      $media.style.height = "auto";
      setPosition("x", $media, position);
      setPosition("y", $media, position);
    } else if (fit === "cover" && $media.clientWidth > $container.clientWidth || fit === "contain" && $media.clientWidth < $container.clientWidth) {
      $media.style.top = "0";
      $media.style.marginTop = "0";
      setPosition("x", $media, position);
    } else if (fit !== "scale-down") {
      $media.style.width = "100%";
      $media.style.height = "auto";
      $media.style.left = "0";
      $media.style.marginLeft = "0";
      setPosition("y", $media, position);
    }
  };

  /**
   * Initialize plugin
   */
  var objectFitPolyfill = function objectFitPolyfill() {
    var media = document.querySelectorAll("[data-object-fit]");

    for (var i = 0; i < media.length; i++) {
      var mediaType = media[i].nodeName.toLowerCase();

      if (mediaType === "img") {
        if (media[i].complete) {
          objectFit(media[i]);
        } else {
          media[i].addEventListener("load", function () {
            objectFit(this);
          });
        }
      } else if (mediaType === "video") {
        if (media[i].readyState > 0) {
          objectFit(media[i]);
        } else {
          media[i].addEventListener("loadedmetadata", function () {
            objectFit(this);
          });
        }
      }
    }

    return true;
  };

  document.addEventListener("DOMContentLoaded", function () {
    objectFitPolyfill();
  });
  window.addEventListener("resize", function () {
    objectFitPolyfill();
  });

  window.objectFitPolyfill = objectFitPolyfill;
})();

},{}],124:[function(require,module,exports){
require('../../modules/es6.array.fill');
module.exports = require('../../modules/_core').Array.fill;

},{"../../modules/_core":140,"../../modules/es6.array.fill":188}],125:[function(require,module,exports){
require('../../modules/es6.array.find-index');
module.exports = require('../../modules/_core').Array.findIndex;

},{"../../modules/_core":140,"../../modules/es6.array.find-index":189}],126:[function(require,module,exports){
require('../../modules/es6.array.find');
module.exports = require('../../modules/_core').Array.find;

},{"../../modules/_core":140,"../../modules/es6.array.find":190}],127:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;

},{"../../modules/_core":140,"../../modules/es6.array.from":191,"../../modules/es6.string.iterator":193}],128:[function(require,module,exports){
require('../../modules/es7.array.includes');
module.exports = require('../../modules/_core').Array.includes;

},{"../../modules/_core":140,"../../modules/es7.array.includes":194}],129:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;

},{"../../modules/_core":140,"../../modules/es6.object.assign":192}],130:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],131:[function(require,module,exports){
// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./_wks')('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) require('./_hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

},{"./_hide":151,"./_wks":186}],132:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":157}],133:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

},{"./_to-absolute-index":179,"./_to-length":182,"./_to-object":183}],134:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":179,"./_to-iobject":181,"./_to-length":182}],135:[function(require,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = require('./_ctx');
var IObject = require('./_iobject');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var asc = require('./_array-species-create');
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

},{"./_array-species-create":137,"./_ctx":142,"./_iobject":154,"./_to-length":182,"./_to-object":183}],136:[function(require,module,exports){
var isObject = require('./_is-object');
var isArray = require('./_is-array');
var SPECIES = require('./_wks')('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

},{"./_is-array":156,"./_is-object":157,"./_wks":186}],137:[function(require,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

},{"./_array-species-constructor":136}],138:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":139,"./_wks":186}],139:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],140:[function(require,module,exports){
var core = module.exports = { version: '2.5.0' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],141:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":166,"./_property-desc":173}],142:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":130}],143:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],144:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":148}],145:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":149,"./_is-object":157}],146:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],147:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var hide = require('./_hide');
var redefine = require('./_redefine');
var ctx = require('./_ctx');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":140,"./_ctx":142,"./_global":149,"./_hide":151,"./_redefine":174}],148:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],149:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],150:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],151:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":144,"./_object-dp":166,"./_property-desc":173}],152:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":149}],153:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":144,"./_dom-create":145,"./_fails":148}],154:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":139}],155:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":162,"./_wks":186}],156:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":139}],157:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],158:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":132}],159:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":151,"./_object-create":165,"./_property-desc":173,"./_set-to-string-tag":175,"./_wks":186}],160:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var has = require('./_has');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":147,"./_has":150,"./_hide":151,"./_iter-create":159,"./_iterators":162,"./_library":163,"./_object-gpo":169,"./_redefine":174,"./_set-to-string-tag":175,"./_wks":186}],161:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":186}],162:[function(require,module,exports){
module.exports = {};

},{}],163:[function(require,module,exports){
module.exports = false;

},{}],164:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;

},{"./_fails":148,"./_iobject":154,"./_object-gops":168,"./_object-keys":171,"./_object-pie":172,"./_to-object":183}],165:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":132,"./_dom-create":145,"./_enum-bug-keys":146,"./_html":152,"./_object-dps":167,"./_shared-key":176}],166:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":132,"./_descriptors":144,"./_ie8-dom-define":153,"./_to-primitive":184}],167:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":132,"./_descriptors":144,"./_object-dp":166,"./_object-keys":171}],168:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],169:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":150,"./_shared-key":176,"./_to-object":183}],170:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":134,"./_has":150,"./_shared-key":176,"./_to-iobject":181}],171:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":146,"./_object-keys-internal":170}],172:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],173:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],174:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var has = require('./_has');
var SRC = require('./_uid')('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

require('./_core').inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

},{"./_core":140,"./_global":149,"./_has":150,"./_hide":151,"./_uid":185}],175:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":150,"./_object-dp":166,"./_wks":186}],176:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":177,"./_uid":185}],177:[function(require,module,exports){
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};

},{"./_global":149}],178:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":143,"./_to-integer":180}],179:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":180}],180:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],181:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":143,"./_iobject":154}],182:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":180}],183:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":143}],184:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":157}],185:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],186:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":149,"./_shared":177,"./_uid":185}],187:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":138,"./_core":140,"./_iterators":162,"./_wks":186}],188:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { fill: require('./_array-fill') });

require('./_add-to-unscopables')('fill');

},{"./_add-to-unscopables":131,"./_array-fill":133,"./_export":147}],189:[function(require,module,exports){
'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":131,"./_array-methods":135,"./_export":147}],190:[function(require,module,exports){
'use strict';
// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":131,"./_array-methods":135,"./_export":147}],191:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":141,"./_ctx":142,"./_export":147,"./_is-array-iter":155,"./_iter-call":158,"./_iter-detect":161,"./_to-length":182,"./_to-object":183,"./core.get-iterator-method":187}],192:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":147,"./_object-assign":164}],193:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":160,"./_string-at":178}],194:[function(require,module,exports){
'use strict';
// https://github.com/tc39/Array.prototype.includes
var $export = require('./_export');
var $includes = require('./_array-includes')(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

require('./_add-to-unscopables')('includes');

},{"./_add-to-unscopables":131,"./_array-includes":134,"./_export":147}]},{},[120]);
